$(function () {
  if ($('#contactHidden').length > 0) {
    scroll(0, 0);
  }

  $('.js-radio-item-text').click(function () {
    let image = $(this).prev().data('target-image');
    $('.js-image').attr('src', image);
  });

  $('#nutrition-facts-select').on('change', function () {
    let selected = $(this).find(':selected');let img = selected.attr('data-target-image');$('.nutrition-facts__image').attr('src', img);
  });
  if ($('.collection-carousel').length > 0) {
    $('.collection-carousel').owlCarousel({
      loop: true,
      margin: 0,
      center: true,
      stagePadding: 50,
      nav: false,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 2,
        }        
      },
    });
  }
  var owl = null;
  if ($('.carousel').length > 0 && typeof $.fn.owlCarousel == "function") {
    owl = $('.carousel').owlCarousel({
      lazyLoad: true,
      items: 1,
      nav: false,
      dots: false,
    });
  } 
  

  if (owl) {
    owl.on('changed.owl.carousel', function (event) {
      var item = event.item.index;
      $('.owl-carousel__thmbs > .owl-carousel__thmb').removeClass('active');
      $(
        '.owl-carousel__thmbs > .owl-carousel__thmb:nth-child(' +
          (item + 1) +
          ')'
      ).addClass('active');
    });

    $('.owl-carousel__thmb').on('click', function () {
      var index = $(this).index();
      owl.trigger('to.owl.carousel', [index]);
    });
  }

  if ($('#ProductSection-product-template-premium-selection').length > 0) {
    $('.js-change-number').on('click', function (e) {
      e.preventDefault();

      var add = $(this).attr('data-method') == 'add' ? true : false;

      var qty = parseInt($('.js-item-number-input').val());

      if (add) {
        $('#AddToCart-product-template-premium-selection').prop(
          'disabled',
          false
        );
        if (qty < parseInt($('.js-item-number-input').attr('max'))) {
          $('.js-item-number-input').val(qty + 1);
        }
      } else {
        if (qty > 0) {
          $('.js-item-number-input').val(qty - 1);

          if (parseInt($('.js-item-number-input').val()) == 0) {
            $('#AddToCart-product-template-premium-selection').prop(
              'disabled',
              true
            );
          } else {
            $('#AddToCart-product-template-premium-selection').prop(
              'disabled',
              false
            );
          }
        } else {
          $('#AddToCart-product-template-premium-selection').prop(
            'disabled',
            true
          );
        }
      }
    });
  }





  var originalPriceElem = document.querySelector('.wh-original-price');
  var previousCartTotal = 0;
  if($('.cart-page').length && false) { /* if CART page*/
    var originalPriceModified = false;
    var observer = new MutationObserver(function (event) {
        setTimeout(function(){
            if(!$(originalPriceElem).css('text-decoration') || originalPriceModified) return;
            var discountElem = document.querySelector('.discountInfoContainer');

            var cartOriginalTotal = cartTotal;
            if(discountElem) {

                if($('.cart-list--full').length) {
                    $('.cart-list--full .cart-list__row--product').each(function(e) {
                        var name = $(this).find('.cart-list__column--title').text();
                        if(name) {
                            if(name.includes('Ajándék BHK')) {
                                cartOriginalTotal = cartOriginalTotal + 4990;
                            } else if(name.includes('Ajándék 2')) {
                                cartOriginalTotal = cartOriginalTotal + 2495;
                            } else if(name.includes('Ajándék 4')) {
                                cartOriginalTotal = cartOriginalTotal + 4990;
                            }
                        }
                    });
                }
                console.log(cartOriginalTotal);

                originalPriceElem.innerText = (typeof numberSeparator !== "undefined")? numberSeparator(cartOriginalTotal) + " Ft" : cartOriginalTotal + " Ft";
                originalPriceModified = true;
            }
        },100);
        
    })
    
    observer.observe(originalPriceElem, {
    attributes: true,
    attributeFilter: ['style'],
    childList: false, 
    characterData: false
    });
  } else if($('.template-product').length && false) {
      console.log("product page");
    var observer = new MutationObserver(function (event) {
        setTimeout(function(){
            console.log("CART PRICE CALC: Price observer run");
            console.log("CART PRICE CALC: style - "+$(originalPriceElem).css('text-decoration'));
            console.log("CART PRICE CALC: loadCount - "+window.ajaxCartLoaded);
            if(!$(originalPriceElem).css('text-decoration') || (window.ajaxCartLoaded && window.ajaxCartLoaded > 1)) return;
            console.log("CART PRICE CALC: Price observer run first");
            var discountElem = document.querySelector('.discountInfoContainer');
            var discountAjaxElem = document.querySelector('.discountInfoContainer_cart_drawer');

            var cartOriginalTotal = parseInt($('.wh-original-price').first().text().replace('CHF ','').replace('.',''));
            if(cartOriginalTotal === previousCartTotal) return;
            previousCartTotal = cartOriginalTotal;
			
			var checkDiscountElemExist = setInterval(function() {
			   if (discountElem || discountAjaxElem) {
				  clearInterval(checkDiscountElemExist);
				  
				  console.log("CART PRICE CALC: has discount elem, recalculating");
				  
				  var checkCartListElem = setInterval(function() {
					   if($('.cart-list .cart-list__row--product').length) {
						  clearInterval(checkCartListElem);

								$('.cart-list .cart-list__row--product').each(function(e) {
									var name = $(this).find('.cart-list__column--title').text();
									if(name) {
										if(name.includes('Ajándék BHK')) {console.log("CART PRICE CALC: has BHK");
											cartOriginalTotal = cartOriginalTotal + 4990;
										} else if(name.includes('Ajándék 2')) {console.log("CART PRICE CALC: has 2pc Sprinkles");
											cartOriginalTotal = cartOriginalTotal + 2495;
										} else if(name.includes('Ajándék 4')) {console.log("CART PRICE CALC: has 4pc Sprinkles");
											cartOriginalTotal = cartOriginalTotal + 4990;
										}
									}
								});

							originalPriceElem.innerText = (typeof numberSeparator !== "undefined")? numberSeparator(cartOriginalTotal) + " Ft" : cartOriginalTotal + " Ft";
							window.ajaxCartLoaded = window.ajaxCartLoaded + 1;
					   }
					}, 50);
					
					setTimeout(function(){ /* Clear interval after 2 secs */
						clearInterval(checkCartListElem);
					},2000);
			   }
			}, 50);
			
			setTimeout(function(){ /* Clear interval after 5 secs */
				clearInterval(checkDiscountElemExist);
			},5000);
        },100);
    })
    
    observer.observe(originalPriceElem, {
    attributes: true,
    attributeFilter: ['style'],
    childList: false, 
    characterData: false
    });
  }
});

function numberSeparator(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = _.filter(this.instances, function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    /* eslint-disable-next-line no-shadow */
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    /* eslint-disable-next-line no-shadow */
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    /* eslint-disable-next-line no-shadow */
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    /* eslint-disable-next-line no-shadow */
    var instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function (index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  keyboardKeys: {
    TAB: 9,
  },
};

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    options.$iframes.each(function () {
     
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      this.src = this.src;
    });
  },
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    /* is there a hash in the url? is it an element on the page? */
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $('a[href*=#]').on(
      'click',
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventsName = {
      focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
      focusout: options.namespace
        ? 'focusout.' + options.namespace
        : 'focusout',
      keydown: options.namespace
        ? 'keydown.' + options.namespace
        : 'keydown.handleFocus',
    };

    /**
     * Get every possible visible focusable element
     */
    var $focusableElements = options.$container.find(
      $(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      ).filter(':visible')
    );
    var firstFocusable = $focusableElements[0];
    var lastFocusable = $focusableElements[$focusableElements.length - 1];

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    function _manageFocus(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

      /**
       * On the last focusable element and tab forward,
       * focus the first element.
       */
      if (evt.target === lastFocusable && !evt.shiftKey) {
        evt.preventDefault();
        firstFocusable.focus();
      }
      /**
       * On the first focusable element and tab backward,
       * focus the last element.
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventsName.focusout, function () {
      $(document).off(eventsName.keydown);
    });

    $(document).on(eventsName.focusin, function (evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      $(document).on(eventsName.keydown, function (evt) {
        _manageFocus(evt);
      });
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {jQuery} options.$links - Specific links to be targeted
   */
  accessibleLinks: function (options) {
    var body = document.querySelector('body');

    var idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message',
    };

    if (options.$links === undefined || !options.$links.jquery) {
      options.$links = $('a:not([aria-describedby])');
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {};
      }

      var messages = $.extend(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.',
        },
        customMessages
      );

      var container = document.createElement('ul');
      var htmlMessages = '';

      for (var message in messages) {
        htmlMessages +=
          '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
      }

      container.setAttribute('hidden', true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite($link) {
      var hostname = window.location.hostname;

      return $link[0].hostname !== hostname;
    }

    $.each(options.$links, function () {
      var $link = $(this);
      var target = $link.attr('target');
      var rel = $link.attr('rel');
      var isExternal = _externalSite($link);
      var isTargetBlank = target === '_blank';

      if (isExternal) {
        $link.attr('aria-describedby', idSelectors.external);
      }
      if (isTargetBlank) {
        if (rel === undefined || rel.indexOf('noopener') === -1) {
          $link.attr('rel', function (i, val) {
            var relValue = val === undefined ? '' : val + ' ';
            return relValue + 'noopener';
          });
        }
        $link.attr('aria-describedby', idSelectors.newWindow);
      }
      if (isExternal && isTargetBlank) {
        $link.attr('aria-describedby', idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  },
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); /* eslint-disable-line callback-return */
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function () {
  var moneyFormat = '${{amount}}';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney,
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function (variant) {
        return selectedValues.every(function (values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant,
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant,
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant,
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function (variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant,
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    },
  });

  return Variants;
})();

/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function () {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position,
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer'),
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    
    var externalCall = false;

    
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    /* Without this, the drawer opens, the click event bubbles up to nodes.$page
     which closes the drawer.*/
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      /* save the source of the click, we'll focus to this on close */
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    /* Add is-transitioning class to moved elements on open so drawer can have
     transition for close animation */
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus',
    });

    
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) {
      
      return;
    }

    
    $(document.activeElement).trigger('blur');

    
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    this.drawerIsOpen = false;

    
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus',
    });

    this.unbindEvents();

    
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === 'function'
    ) {
      this.config.onDrawerClose();
    }
  };

  Drawer.prototype.bindEvents = function () {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function (evt) {
        
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

   
    this.nodes.$page.on('touchmove.drawer', function () {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function () {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function () {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function () {
  var selectors = {
    body: 'body',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last',
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link',
  };

  var cache = {};

  function init() {
    cacheSelectors();

    cache.$parents.on('click.siteNav', function () {
      var $el = $(this);

      $el.hasClass(config.activeClass) ? hideDropdown($el) : showDropdown($el);
    });

   
    $(selectors.siteNavChildLink).on('focusout.siteNav', function () {
      setTimeout(function () {
        if (
          $(document.activeElement).hasClass(config.childLinkClass) ||
          !cache.$activeDropdown.length
        ) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    
    cache.$topLevel.on('focus.siteNav', function () {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on('click.siteNav', function (evt) {
      
      evt.stopImmediatePropagation();
    });
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown),
    };
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass);

    
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $el;

    
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

    setTimeout(function () {
      $(window).on('keyup.siteNav', function (evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on('click.siteNav', function () {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);

   
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  return {
    init: init,
    unload: unload,
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function () {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLinkWrapper: 'mobile-nav__item',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu',
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
 
  var mediaQuerySmall = 'screen and (max-width: 749px)';

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on('click', toggleMobileNav);
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

    
    enquire.register(mediaQuerySmall, {
      unmatch: function () {
        closeMobileNav();
      },
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContainer'),
      $siteHeader: $('.site-header'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $sectionHeader: $('#shopify-section-header'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn),
    };
  }

  function openMobileNav() {
    var translateHeaderHeight = cache.$siteHeader.outerHeight();

    cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translateY(' + translateHeaderHeight + 'px)',
    });

    cache.$pageContainer.css({
      transform:
        'translate3d(0, ' +
        cache.$mobileNavContainer[0].scrollHeight +
        'px, 0)',
    });

    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNavToggle,
      namespace: 'navFocus',
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon)
      .attr('aria-expanded', true);

   
    $(window).on('keyup.mobileNav', function (evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translateY(-100%)',
    });

    cache.$pageContainer.removeAttr('style');

    slate.a11y.trapFocus({
      $container: $('html'),
      $elementToFocus: $('body'),
    });

    cache.$mobileNavContainer.one(
      'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
      function () {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: 'navFocus',
        });
      }
    );

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon)
      .attr('aria-expanded', false)
      .focus();

    $(window).off('keyup.mobileNav');

    scrollTo(0, 0);
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;

    if (isReturn) {
      
      $(
        '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data('target'));
  }

  function goToSubnav(target) {
    /*eslint-disable shopify/jquery-dollar-sign-reference */

    var $targetMenu = target
      ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
      : cache.$mobileNav;

    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    /*eslint-enable shopify/jquery-dollar-sign-reference */

    var translateMenuHeight = $targetMenu.outerHeight();

    var openNavClass =
      menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

    cache.$mobileNavContainer
      .css('height', translateMenuHeight)
      .removeClass(classes.thirdNavShowing)
      .addClass(openNavClass);

    if (!target) {
     
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing);
    }

    /* if going back to first subnav, focus is on whole header */
    var $container = menuLevel === 1 ? cache.$sectionHeader : $targetMenu;

    var $menuTitle = $targetMenu.find('[data-menu-title=' + menuLevel + ']');
    var $elementToFocus = $menuTitle ? $menuTitle : $targetMenu;

    /* Focusing an item in the subnav early forces element into view and breaks the animation.*/
    cache.$mobileNavContainer.one(
      'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
      function () {
        slate.a11y.trapFocus({
          $container: $container,
          $elementToFocus: $elementToFocus,
          namespace: 'subNavFocus',
        });

        cache.$mobileNavContainer.off('.subnavToggle');
        isTransitioning = false;
      }
    );

    
    cache.$pageContainer.css({
      transform: 'translateY(' + translateMenuHeight + 'px)',
    });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav,
  };
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function () {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    searchResultSubmit: '#SearchResultSubmit',
    searchResultInput: '#SearchInput',
    searchResultMessage: '[data-search-error-message]',

    mobileNavWrapper: '.mobile-nav-wrapper',
  };

  var classes = {
    focus: 'search--focus',
    hidden: 'hide',
    mobileNavIsOpen: 'js-menu--is-open',
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    this.$searchResultInput = $(selectors.searchResultInput);
    this.$searchErrorMessage = $(selectors.searchResultMessage);

    initDrawer();

    var searchQuery = slate.utils.getParameterByName('q');

    if (searchQuery !== null) {
      validateSearchResultForm.call(this);
    }

    $(selectors.searchResultSubmit).on(
      'click',
      validateSearchResultForm.bind(this)
    );

    $(selectors.searchHeaderInput)
      .add(selectors.searchHeaderSubmit)
      .on('focus blur', function () {
        $(selectors.searchHeader).toggleClass(classes.focus);
      });

    $(selectors.siteHeaderSearchToggle).on('click', function () {
      var searchHeight = $(selectors.siteHeader).outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

      $(selectors.searchDrawer).css({
        height: searchHeight + 'px',
        top: searchOffset + 'px',
      });
    });
  }

  function initDrawer() {
   
    $('#PageContainer').addClass('drawer-page-content');
    $('.js-drawer-open-top')
      .attr('aria-controls', 'SearchDrawer')
      .attr('aria-expanded', 'false')
      .attr('aria-haspopup', 'dialog');

    theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: searchDrawerFocus,
      onDrawerClose: searchDrawerFocusClose,
    });
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));

    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      theme.MobileNav.closeMobileNav();
    }
  }

  function searchFocus($el) {
    $el.focus();
    
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchDrawerFocusClose() {
    $(selectors.siteHeaderSearchToggle).focus();
  }

  /**
   * Remove the aria-attributes and hide the error messages
   */
  function hideErrorMessage() {
    this.$searchErrorMessage.addClass(classes.hidden);
    this.$searchResultInput
      .removeAttr('aria-describedby')
      .removeAttr('aria-invalid');
  }

  /**
   * Add the aria-attributes and show the error messages
   */
  function showErrorMessage() {
    this.$searchErrorMessage.removeClass(classes.hidden);
    this.$searchResultInput
      .attr('aria-describedby', 'error-search-form')
      .attr('aria-invalid', true);
  }

  function validateSearchResultForm(evt) {
    var isInputValueEmpty = this.$searchResultInput.val().trim().length === 0;

    if (!isInputValueEmpty) {
      hideErrorMessage.call(this);
      return;
    }

    if (typeof evt !== 'undefined') {
      evt.preventDefault();
    }

    searchFocus(this.$searchResultInput);
    showErrorMessage.call(this);
  }

  return {
    init: init,
  };
})();

(function () {
  var selectors = {
    backButton: '.return-link',
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function (evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function () {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused',
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed'),
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    if (typeof this.$slideshow.slick != "undefined") {
      this.$slideshow.slick(this.settings);
    }

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    $list.removeAttr('aria-live');

    $wrapper.on('focusin', function (evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

   
    $wrapper.on('focusout', function (evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    if (obj.$dots) {
      obj.$dots.on('keydown', function (evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        if (evt.which === 37 || evt.which === 39) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find(
      '.slideshow__slide[data-slick-index="' + nextSlide + '"]'
    );

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function () {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function () {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
     
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0,
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange,
    },
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay',
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', 
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow'),
    };

    if (!youtubeLoaded) {
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
     if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
        setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    player.playVideo();

    autoplayTest(player)
      .then(function () {
        setAutoplaySupport(true);
      })
      .fail(function () {
         setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function () {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function () {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function () {
      clearInterval(wait);
      deferred.reject();
    }, 4000); 

    return deferred;
  }

  function playOnClickCheck() {
   

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (window.mobileCheck()) {
      playOnClick = true;
    }

    if (playOnClick) {
     
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: 
        setAsFinished(videoData);
        break;
      case 1: 
        setAsPlaying(videoData);
        break;
      case 2:
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow.removeClass(classes.paused).addClass(classes.playing);
        $slide.removeClass(classes.paused).addClass(classes.playing);
        break;
    }

    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); 
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];

    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    
    $(document).on('keydown.videoPlayer', function (evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function (index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
   
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); 
      $player
        .width(playerWidth)
        .height(playerHeight)
        .css({
          left: (slideWidth - playerWidth) / 2,
          top: 0,
        }); 
    } else {
      
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); 
      $player
        .width(slideWidth)
        .height(playerHeight)
        .css({
          left: 0,
          top: (playerHeight - playerHeight) / 2,
        }); 
    }

    $player.prepareTransition().addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    $('#' + playerId)
      .removeAttr('style')
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    var $player = $('#' + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on(
      'click.videoPlayer',
      '.' + classes.playVideoBtn,
      function (evt) {
        var playerId = $(evt.currentTarget).data('controls');
        startVideoOnClick(playerId);
      }
    );

    $(document).on(
      'click.videoPlayer',
      '.' + classes.closeVideoBtn,
      function (evt) {
        var playerId = $(evt.currentTarget).data('controls');
        closeVideo(playerId);
      }
    );

    
    $(window).on(
      'resize.videoPlayer',
      $.debounce(250, function () {
        if (youtubeLoaded) {
          sizeBackgroundVideos();
        }
      })
    );
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents,
  };
})();

window.theme = window.theme || {};

theme.FormStatus = (function () {
  var selectors = {
    statusMessage: '[data-form-status]',
  };

  function init() {
    this.$statusMessage = $(selectors.statusMessage);

    if (!this.$statusMessage) return;

    this.$statusMessage.focus();
  }

  return {
    init: init,
  };
})();

/* ================ TEMPLATES ================ */
(function () {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function () {
    location.href = $(this).val();
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function () {
  function initEventListeners() {
    
    $('#RecoverPassword').on('click', function (evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

   
    $('#HideRecoverPasswordLink').on('click', function (evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    
    if (!$formState.length) {
      return;
    }

   
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

   
    if (Shopify) {
      
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew',
        }
      );
    }

    
    $('.address-country-option').each(function () {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

     
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector,
      });
    });

    
    $('.address-new-toggle').on('click', function () {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function () {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function () {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

     
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' },
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function () {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    },
  };
})();

/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function () {
  var selectors = {
    edit: '.js-edit-toggle',
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies',
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on('click', this._onEditClick.bind(this));
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function () {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function (evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    },

    cookiesEnabled: function () {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    },
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function () {
  var constants = {
    SORT_BY: 'sort_by',
  };
  var selectors = {
    mainContent: '#MainContent',
    filterSelection: '#SortTags',
    sortSelection: '#SortBy',
    defaultSort: '#DefaultSortBy',
  };

  function Filters(container) {
    var $container = (this.$container = $(container));

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );

    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects);
    this.$selects.removeClass('hidden');

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _onSortChange: function (evt) {
      var sort = this._sortValue();
      var url = window.location.href.replace(window.location.search, '');

      if (sort.length) {
        var urlStripped = url.replace(window.location.hash, '');
        window.location.href = urlStripped + '?' + sort + selectors.mainContent;
      } else {
       
        window.location.href = url;
      }
      this._resizeSelect($(evt.target));
    },

    _onFilterChange: function (evt) {
      var filter = this._getFilterValue();

     
      var search = document.location.search.replace(/\?(page=\w+)?&?/, '');

     
      search = search !== '' ? '?' + search : '';

      document.location.href = filter + search + selectors.mainContent;
      this._resizeSelect($(evt.target));
    },

    _getFilterValue: function () {
      return this.$filterSelect.val();
    },

    _getSortValue: function () {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function () {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function () {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function ($selection) {
      $selection.each(function () {
        var $this = $(this);
        var arrowWidth = 10;
       
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

       
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function () {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    },
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function () {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function () {
      theme.Header.unload();
    },
  });

  return Header;
})();

theme.Maps = (function () {
  var config = {
    zoom: 14,
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError,
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]',
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center',
  };

 
  window.gm_authFailure = function () {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
        classes.errorMsg +
        '">' +
        theme.strings.authError +
        '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function () {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    
    $.each(mapsToLoad, function (index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function (results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function () {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function (results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true,
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

           
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter(),
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function () {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
                $map.removeAttr('style');
              })
            );
          }.bind(this)
        )
        .fail(function () {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

         
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    onUnload: function () {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, 'resize');
    },
  });

  return Map;
})();

/* eslint-disable no-new */
theme.Product = (function () {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
     
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false,
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productImageWraps: '.product-single__photo',
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productFeaturedImage: '.product-featured-img',
      productThumbsWrapper: '.thumbnails-wrapper',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]',
    };

    this.classes = {
      productOnSale: 'price--on-sale',
      productUnavailable: 'price--unavailable',
    };

    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      'js-zoom-enabled'
    );

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._setActiveThumbnail();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function () {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function () {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function () {
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider();
          }

          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function () {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function () {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          self.settings.bpSmall = false;
        },
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function () {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function () {
              _enableZoom(this);
            });
          }
        },
      });
    },

    _initVariants: function () {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject,
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAvailability.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    _initImageSwitch: function () {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages).on('click', function (evt) {
        evt.preventDefault();
        var $el = $(this);

        var imageId = $el.data('thumbnail-id');

        self._switchImage(imageId);
        self._setActiveThumbnail(imageId);
      });
    },

    _setActiveThumbnail: function (imageId) {
      var activeClass = 'active-thumb';

      if (typeof imageId === 'undefined') {
        imageId = $(this.selectors.productImageWraps + ":not('.hide')").data(
          'image-id'
        );
      }

      var $thumbnail = $(
        this.selectors.productThumbImages +
          "[data-thumbnail-id='" +
          imageId +
          "']"
      );

      $(this.selectors.productThumbImages)
        .removeClass(activeClass)
        .removeAttr('aria-current');

      $thumbnail.addClass(activeClass);
      $thumbnail.attr('aria-current', true);
    },

    _switchImage: function (imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );
      $newImage.removeClass('hide');
      $newImage.find(this.selectors.productFeaturedImage).focus();
      $otherImages.addClass('hide');
    },

    _initThumbnailSlider: function () {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      };

      $(this.selectors.productThumbs).slick(options);

      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-list')
        .removeAttr('aria-live');
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-disabled')
        .removeAttr('aria-disabled');

      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function () {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('[tabindex="-1"]')
        .removeAttr('tabindex');
    },

    _liveRegionText: function (variant) {
      var liveRegionText = '[Availability] [Regular] [$$] [Sale] [$]';

      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      var availability = variant.available ? '' : theme.strings.soldOut + ',';
      liveRegionText = liveRegionText.replace('[Availability]', availability);

      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[Sale]', saleLabel)
        .replace('[$]', salePrice)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function (evt) {
      var variant = evt.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );

      liveRegion.textContent = this._liveRegionText(variant);
      liveRegion.setAttribute('aria-hidden', false);

      setTimeout(function () {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _updateAddToCart: function (evt) {
      var variant = evt.variant;

      if (variant) {
        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCartText).text(theme.strings.addToCart);
          $(this.selectors.shopifyPaymentButton, this.$container).show();
        } else {
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
      }
    },

    _updateAvailability: function (evt) {
      this._updateAddToCart(evt);
      this._updateLiveRegion(evt);

      this._updatePrice(evt);
    },

    _updateImages: function (evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function (evt) {
      var variant = evt.variant;

      var $priceContainer = $(this.selectors.priceContainer, this.$container);
      var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
      var $salePrice = $(this.selectors.salePrice, $priceContainer);

      $priceContainer
        .removeClass(this.classes.productUnavailable)
        .removeClass(this.classes.productOnSale)
        .removeAttr('aria-hidden');

      if (!variant) {
        $priceContainer
          .addClass(this.classes.productUnavailable)
          .attr('aria-hidden', true);
        return;
      }

     if (variant.compare_at_price > variant.price) {
        $regularPrice
          .html(
            theme.Currency.formatMoney(
              variant.compare_at_price,
              'CHF {{amount}}'
            ).replace(',', ' ')
          )
          .css({
            'text-decoration': 'line-through',
            'margin-right': 4,
          });
        $salePrice.html(
          theme.Currency.formatMoney(
            variant.price,
            'CHF {{amount}}'
          ).replace(',,', ' ')
        );
        $priceContainer.addClass(this.classes.productOnSale);
      } else {
        // Regular price
        $salePrice.html('');
        $regularPrice
          .html(
            theme.Currency.formatMoney(
              variant.price,
              'CHF {{amount}}'
            ).replace(',,', ' ')
          )
          .removeAttr('style');
      }
    },

    _updateSKU: function (evt) {
      var variant = evt.variant;
      

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function () {
      this.$container.off(this.settings.namespace);
    },
  });

  function _enableZoom(el) {
    //var zoomUrl = $(el).data('zoom');
    //$(el).zoom({
    //    url: zoomUrl
    //});
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

  return Product;
})();

theme.Quotes = (function () {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0,
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3,
  };

  function Quotes(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.quotes-wrapper');
    var slider = (this.slider = '#Quotes-' + sectionId);
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function () {
        initSlider($slider, mobileOptions);
      },
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function () {
        initSlider($slider, defaults);
      },
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function () {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function (evt) {
      // Ignore the cloned version
      var $slide = $(
        '.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function (event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function () {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    $('.slideshow__video', slideshow).each(function () {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function () {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function (evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function () {
      // Resume autoplay
      $(this.slideshow).slick('slickPlay');
    },
  }
);

$(document).ready(function () {
  var sections = new theme.Sections();

  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('quotes', theme.Quotes);
});

theme.init = function () {
  theme.customerTemplates.init();

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = '.rte table,' + '.custom__item-inner--html table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper',
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'video-wrapper',
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function (evt) {
    evt.preventDefault();
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal,
    },
    $links: $('a:not([aria-describedby], .product-single__thumbnail)'),
  });
};

$(theme.init);

!(function (t) {
  var e = {};

  function n(i) {
    if (e[i]) return e[i].exports;
    var o = (e[i] = { i: i, l: !1, exports: {} });
    return t[i].call(o.exports, o, o.exports, n), (o.l = !0), o.exports;
  }

  (n.m = t),
    (n.c = e),
    (n.d = function (t, e, i) {
      n.o(t, e) ||
        Object.defineProperty(t, e, {
          configurable: !1,
          enumerable: !0,
          get: i,
        });
    }),
    (n.r = function (t) {
      Object.defineProperty(t, '__esModule', { value: !0 });
    }),
    (n.n = function (t) {
      var e =
        t && t.__esModule
          ? function () {
              return t.default;
            }
          : function () {
              return t;
            };
      return n.d(e, 'a', e), e;
    }),
    (n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (n.p = ''),
    n((n.s = 37));
})([
  function (t, e, n) {
    var i;
    /*!
     * jQuery JavaScript Library v3.3.1
     * https://jquery.com/
     *
     * Includes Sizzle.js
     * https://sizzlejs.com/
     *
     * Copyright JS Foundation and other contributors
     * Released under the MIT license
     * https://jquery.org/license
     *
     * Date: 2018-01-20T17:24Z
     */
    /*!
     * jQuery JavaScript Library v3.3.1
     * https://jquery.com/
     *
     * Includes Sizzle.js
     * https://sizzlejs.com/
     *
     * Copyright JS Foundation and other contributors
     * Released under the MIT license
     * https://jquery.org/license
     *
     * Date: 2018-01-20T17:24Z
     */
    !(function (e, n) {
      'use strict';
      'object' == typeof t && 'object' == typeof t.exports
        ? (t.exports = e.document
            ? n(e, !0)
            : function (t) {
                if (!t.document)
                  throw new Error('jQuery requires a window with a document');
                return n(t);
              })
        : n(e);
    })('undefined' != typeof window ? window : this, function (n, o) {
      'use strict';
      var r = [],
        s = n.document,
        a = Object.getPrototypeOf,
        l = r.slice,
        c = r.concat,
        u = r.push,
        d = r.indexOf,
        h = {},
        f = h.toString,
        p = h.hasOwnProperty,
        g = p.toString,
        m = g.call(Object),
        v = {},
        y = function (t) {
          return 'function' == typeof t && 'number' != typeof t.nodeType;
        },
        w = function (t) {
          return null != t && t === t.window;
        },
        x = { type: !0, src: !0, noModule: !0 };

      function b(t, e, n) {
        var i,
          o = (e = e || s).createElement('script');
        if (((o.text = t), n)) for (i in x) n[i] && (o[i] = n[i]);
        e.head.appendChild(o).parentNode.removeChild(o);
      }

      function _(t) {
        return null == t
          ? t + ''
          : 'object' == typeof t || 'function' == typeof t
          ? h[f.call(t)] || 'object'
          : typeof t;
      }

      var C = function (t, e) {
          return new C.fn.init(t, e);
        },
        T = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

      function k(t) {
        var e = !!t && 'length' in t && t.length,
          n = _(t);
        return (
          !y(t) &&
          !w(t) &&
          ('array' === n ||
            0 === e ||
            ('number' == typeof e && e > 0 && e - 1 in t))
        );
      }

      (C.fn = C.prototype =
        {
          jquery: '3.3.1',
          constructor: C,
          length: 0,
          toArray: function () {
            return l.call(this);
          },
          get: function (t) {
            return null == t
              ? l.call(this)
              : t < 0
              ? this[t + this.length]
              : this[t];
          },
          pushStack: function (t) {
            var e = C.merge(this.constructor(), t);
            return (e.prevObject = this), e;
          },
          each: function (t) {
            return C.each(this, t);
          },
          map: function (t) {
            return this.pushStack(
              C.map(this, function (e, n) {
                return t.call(e, n, e);
              })
            );
          },
          slice: function () {
            return this.pushStack(l.apply(this, arguments));
          },
          first: function () {
            return this.eq(0);
          },
          last: function () {
            return this.eq(-1);
          },
          eq: function (t) {
            var e = this.length,
              n = +t + (t < 0 ? e : 0);
            return this.pushStack(n >= 0 && n < e ? [this[n]] : []);
          },
          end: function () {
            return this.prevObject || this.constructor();
          },
          push: u,
          sort: r.sort,
          splice: r.splice,
        }),
        (C.extend = C.fn.extend =
          function () {
            var t,
              e,
              n,
              i,
              o,
              r,
              s = arguments[0] || {},
              a = 1,
              l = arguments.length,
              c = !1;
            for (
              'boolean' == typeof s && ((c = s), (s = arguments[a] || {}), a++),
                'object' == typeof s || y(s) || (s = {}),
                a === l && ((s = this), a--);
              a < l;
              a++
            )
              if (null != (t = arguments[a]))
                for (e in t)
                  (n = s[e]),
                    s !== (i = t[e]) &&
                      (c && i && (C.isPlainObject(i) || (o = Array.isArray(i)))
                        ? (o
                            ? ((o = !1), (r = n && Array.isArray(n) ? n : []))
                            : (r = n && C.isPlainObject(n) ? n : {}),
                          (s[e] = C.extend(c, r, i)))
                        : void 0 !== i && (s[e] = i));
            return s;
          }),
        C.extend({
          expando: 'jQuery' + ('3.3.1' + Math.random()).replace(/\D/g, ''),
          isReady: !0,
          error: function (t) {
            throw new Error(t);
          },
          noop: function () {},
          isPlainObject: function (t) {
            var e, n;
            return (
              !(!t || '[object Object]' !== f.call(t)) &&
              (!(e = a(t)) ||
                ('function' ==
                  typeof (n = p.call(e, 'constructor') && e.constructor) &&
                  g.call(n) === m))
            );
          },
          isEmptyObject: function (t) {
            var e;
            for (e in t) return !1;
            return !0;
          },
          globalEval: function (t) {
            b(t);
          },
          each: function (t, e) {
            var n,
              i = 0;
            if (k(t))
              for (n = t.length; i < n && !1 !== e.call(t[i], i, t[i]); i++);
            else for (i in t) if (!1 === e.call(t[i], i, t[i])) break;
            return t;
          },
          trim: function (t) {
            return null == t ? '' : (t + '').replace(T, '');
          },
          makeArray: function (t, e) {
            var n = e || [];
            return (
              null != t &&
                (k(Object(t))
                  ? C.merge(n, 'string' == typeof t ? [t] : t)
                  : u.call(n, t)),
              n
            );
          },
          inArray: function (t, e, n) {
            return null == e ? -1 : d.call(e, t, n);
          },
          merge: function (t, e) {
            for (var n = +e.length, i = 0, o = t.length; i < n; i++)
              t[o++] = e[i];
            return (t.length = o), t;
          },
          grep: function (t, e, n) {
            for (var i = [], o = 0, r = t.length, s = !n; o < r; o++)
              !e(t[o], o) !== s && i.push(t[o]);
            return i;
          },
          map: function (t, e, n) {
            var i,
              o,
              r = 0,
              s = [];
            if (k(t))
              for (i = t.length; r < i; r++)
                null != (o = e(t[r], r, n)) && s.push(o);
            else for (r in t) null != (o = e(t[r], r, n)) && s.push(o);
            return c.apply([], s);
          },
          guid: 1,
          support: v,
        }),
        'function' == typeof Symbol &&
          (C.fn[Symbol.iterator] = r[Symbol.iterator]),
        C.each(
          'Boolean Number String Function Array Date RegExp Object Error Symbol'.split(
            ' '
          ),
          function (t, e) {
            h['[object ' + e + ']'] = e.toLowerCase();
          }
        );
      var E =
        /*!
         * Sizzle CSS Selector Engine v2.3.3
         * https://sizzlejs.com/
         *
         * Copyright jQuery Foundation and other contributors
         * Released under the MIT license
         * http://jquery.org/license
         *
         * Date: 2016-08-08
         */
        (function (t) {
          var e,
            n,
            i,
            o,
            r,
            s,
            a,
            l,
            c,
            u,
            d,
            h,
            f,
            p,
            g,
            m,
            v,
            y,
            w,
            x = 'sizzle' + 1 * new Date(),
            b = t.document,
            _ = 0,
            C = 0,
            T = st(),
            k = st(),
            E = st(),
            S = function (t, e) {
              return t === e && (d = !0), 0;
            },
            j = {}.hasOwnProperty,
            A = [],
            $ = A.pop,
            D = A.push,
            O = A.push,
            N = A.slice,
            z = function (t, e) {
              for (var n = 0, i = t.length; n < i; n++)
                if (t[n] === e) return n;
              return -1;
            },
            q =
              'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped',
            L = '[\\x20\\t\\r\\n\\f]',
            M = '(?:\\\\.|[\\w-]|[^\0-\\xa0])+',
            P =
              '\\[' +
              L +
              '*(' +
              M +
              ')(?:' +
              L +
              '*([*^$|!~]?=)' +
              L +
              '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' +
              M +
              '))|)' +
              L +
              '*\\]',
            H =
              ':(' +
              M +
              ')(?:\\(((\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|' +
              P +
              ')*)|.*)\\)|)',
            I = new RegExp(L + '+', 'g'),
            R = new RegExp(
              '^' + L + '+|((?:^|[^\\\\])(?:\\\\.)*)' + L + '+$',
              'g'
            ),
            W = new RegExp('^' + L + '*,' + L + '*'),
            B = new RegExp('^' + L + '*([>+~]|' + L + ')' + L + '*'),
            F = new RegExp('=' + L + '*([^\\]\'"]*?)' + L + '*\\]', 'g'),
            Q = new RegExp(H),
            X = new RegExp('^' + M + '$'),
            V = {
              ID: new RegExp('^#(' + M + ')'),
              CLASS: new RegExp('^\\.(' + M + ')'),
              TAG: new RegExp('^(' + M + '|[*])'),
              ATTR: new RegExp('^' + P),
              PSEUDO: new RegExp('^' + H),
              CHILD: new RegExp(
                '^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' +
                  L +
                  '*(even|odd|(([+-]|)(\\d*)n|)' +
                  L +
                  '*(?:([+-]|)' +
                  L +
                  '*(\\d+)|))' +
                  L +
                  '*\\)|)',
                'i'
              ),
              bool: new RegExp('^(?:' + q + ')$', 'i'),
              needsContext: new RegExp(
                '^' +
                  L +
                  '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' +
                  L +
                  '*((?:-\\d)?\\d*)' +
                  L +
                  '*\\)|)(?=[^-]|$)',
                'i'
              ),
            },
            G = /^(?:input|select|textarea|button)$/i,
            U = /^h\d$/i,
            Y = /^[^{]+\{\s*\[native \w/,
            Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            J = /[+~]/,
            K = new RegExp('\\\\([\\da-f]{1,6}' + L + '?|(' + L + ')|.)', 'ig'),
            tt = function (t, e, n) {
              var i = '0x' + e - 65536;
              return i != i || n
                ? e
                : i < 0
                ? String.fromCharCode(i + 65536)
                : String.fromCharCode((i >> 10) | 55296, (1023 & i) | 56320);
            },
            et = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
            nt = function (t, e) {
              return e
                ? '\0' === t
                  ? '�'
                  : t.slice(0, -1) +
                    '\\' +
                    t.charCodeAt(t.length - 1).toString(16) +
                    ' '
                : '\\' + t;
            },
            it = function () {
              h();
            },
            ot = yt(
              function (t) {
                return !0 === t.disabled && ('form' in t || 'label' in t);
              },
              { dir: 'parentNode', next: 'legend' }
            );
          try {
            O.apply((A = N.call(b.childNodes)), b.childNodes),
              A[b.childNodes.length].nodeType;
          } catch (t) {
            O = {
              apply: A.length
                ? function (t, e) {
                    D.apply(t, N.call(e));
                  }
                : function (t, e) {
                    for (var n = t.length, i = 0; (t[n++] = e[i++]); );
                    t.length = n - 1;
                  },
            };
          }

          function rt(t, e, i, o) {
            var r,
              a,
              c,
              u,
              d,
              p,
              v,
              y = e && e.ownerDocument,
              _ = e ? e.nodeType : 9;
            if (
              ((i = i || []),
              'string' != typeof t || !t || (1 !== _ && 9 !== _ && 11 !== _))
            )
              return i;
            if (
              !o &&
              ((e ? e.ownerDocument || e : b) !== f && h(e), (e = e || f), g)
            ) {
              if (11 !== _ && (d = Z.exec(t)))
                if ((r = d[1])) {
                  if (9 === _) {
                    if (!(c = e.getElementById(r))) return i;
                    if (c.id === r) return i.push(c), i;
                  } else if (
                    y &&
                    (c = y.getElementById(r)) &&
                    w(e, c) &&
                    c.id === r
                  )
                    return i.push(c), i;
                } else {
                  if (d[2]) return O.apply(i, e.getElementsByTagName(t)), i;
                  if (
                    (r = d[3]) &&
                    n.getElementsByClassName &&
                    e.getElementsByClassName
                  )
                    return O.apply(i, e.getElementsByClassName(r)), i;
                }
              if (n.qsa && !E[t + ' '] && (!m || !m.test(t))) {
                if (1 !== _) (y = e), (v = t);
                else if ('object' !== e.nodeName.toLowerCase()) {
                  for (
                    (u = e.getAttribute('id'))
                      ? (u = u.replace(et, nt))
                      : e.setAttribute('id', (u = x)),
                      a = (p = s(t)).length;
                    a--;

                  )
                    p[a] = '#' + u + ' ' + vt(p[a]);
                  (v = p.join(',')), (y = (J.test(t) && gt(e.parentNode)) || e);
                }
                if (v)
                  try {
                    return O.apply(i, y.querySelectorAll(v)), i;
                  } catch (t) {
                  } finally {
                    u === x && e.removeAttribute('id');
                  }
              }
            }
            return l(t.replace(R, '$1'), e, i, o);
          }

          function st() {
            var t = [];
            return function e(n, o) {
              return (
                t.push(n + ' ') > i.cacheLength && delete e[t.shift()],
                (e[n + ' '] = o)
              );
            };
          }

          function at(t) {
            return (t[x] = !0), t;
          }

          function lt(t) {
            var e = f.createElement('fieldset');
            try {
              return !!t(e);
            } catch (t) {
              return !1;
            } finally {
              e.parentNode && e.parentNode.removeChild(e), (e = null);
            }
          }

          function ct(t, e) {
            for (var n = t.split('|'), o = n.length; o--; )
              i.attrHandle[n[o]] = e;
          }

          function ut(t, e) {
            var n = e && t,
              i =
                n &&
                1 === t.nodeType &&
                1 === e.nodeType &&
                t.sourceIndex - e.sourceIndex;
            if (i) return i;
            if (n) for (; (n = n.nextSibling); ) if (n === e) return -1;
            return t ? 1 : -1;
          }

          function dt(t) {
            return function (e) {
              return 'input' === e.nodeName.toLowerCase() && e.type === t;
            };
          }

          function ht(t) {
            return function (e) {
              var n = e.nodeName.toLowerCase();
              return ('input' === n || 'button' === n) && e.type === t;
            };
          }

          function ft(t) {
            return function (e) {
              return 'form' in e
                ? e.parentNode && !1 === e.disabled
                  ? 'label' in e
                    ? 'label' in e.parentNode
                      ? e.parentNode.disabled === t
                      : e.disabled === t
                    : e.isDisabled === t || (e.isDisabled !== !t && ot(e) === t)
                  : e.disabled === t
                : 'label' in e && e.disabled === t;
            };
          }

          function pt(t) {
            return at(function (e) {
              return (
                (e = +e),
                at(function (n, i) {
                  for (var o, r = t([], n.length, e), s = r.length; s--; )
                    n[(o = r[s])] && (n[o] = !(i[o] = n[o]));
                })
              );
            });
          }

          function gt(t) {
            return t && void 0 !== t.getElementsByTagName && t;
          }

          for (e in ((n = rt.support = {}),
          (r = rt.isXML =
            function (t) {
              var e = t && (t.ownerDocument || t).documentElement;
              return !!e && 'HTML' !== e.nodeName;
            }),
          (h = rt.setDocument =
            function (t) {
              var e,
                o,
                s = t ? t.ownerDocument || t : b;
              return s !== f && 9 === s.nodeType && s.documentElement
                ? ((p = (f = s).documentElement),
                  (g = !r(f)),
                  b !== f &&
                    (o = f.defaultView) &&
                    o.top !== o &&
                    (o.addEventListener
                      ? o.addEventListener('unload', it, !1)
                      : o.attachEvent && o.attachEvent('onunload', it)),
                  (n.attributes = lt(function (t) {
                    return (t.className = 'i'), !t.getAttribute('className');
                  })),
                  (n.getElementsByTagName = lt(function (t) {
                    return (
                      t.appendChild(f.createComment('')),
                      !t.getElementsByTagName('*').length
                    );
                  })),
                  (n.getElementsByClassName = Y.test(f.getElementsByClassName)),
                  (n.getById = lt(function (t) {
                    return (
                      (p.appendChild(t).id = x),
                      !f.getElementsByName || !f.getElementsByName(x).length
                    );
                  })),
                  n.getById
                    ? ((i.filter.ID = function (t) {
                        var e = t.replace(K, tt);
                        return function (t) {
                          return t.getAttribute('id') === e;
                        };
                      }),
                      (i.find.ID = function (t, e) {
                        if (void 0 !== e.getElementById && g) {
                          var n = e.getElementById(t);
                          return n ? [n] : [];
                        }
                      }))
                    : ((i.filter.ID = function (t) {
                        var e = t.replace(K, tt);
                        return function (t) {
                          var n =
                            void 0 !== t.getAttributeNode &&
                            t.getAttributeNode('id');
                          return n && n.value === e;
                        };
                      }),
                      (i.find.ID = function (t, e) {
                        if (void 0 !== e.getElementById && g) {
                          var n,
                            i,
                            o,
                            r = e.getElementById(t);
                          if (r) {
                            if ((n = r.getAttributeNode('id')) && n.value === t)
                              return [r];
                            for (
                              o = e.getElementsByName(t), i = 0;
                              (r = o[i++]);

                            )
                              if (
                                (n = r.getAttributeNode('id')) &&
                                n.value === t
                              )
                                return [r];
                          }
                          return [];
                        }
                      })),
                  (i.find.TAG = n.getElementsByTagName
                    ? function (t, e) {
                        return void 0 !== e.getElementsByTagName
                          ? e.getElementsByTagName(t)
                          : n.qsa
                          ? e.querySelectorAll(t)
                          : void 0;
                      }
                    : function (t, e) {
                        var n,
                          i = [],
                          o = 0,
                          r = e.getElementsByTagName(t);
                        if ('*' === t) {
                          for (; (n = r[o++]); ) 1 === n.nodeType && i.push(n);
                          return i;
                        }
                        return r;
                      }),
                  (i.find.CLASS =
                    n.getElementsByClassName &&
                    function (t, e) {
                      if (void 0 !== e.getElementsByClassName && g)
                        return e.getElementsByClassName(t);
                    }),
                  (v = []),
                  (m = []),
                  (n.qsa = Y.test(f.querySelectorAll)) &&
                    (lt(function (t) {
                      (p.appendChild(t).innerHTML =
                        "<a id='" +
                        x +
                        "'></a><select id='" +
                        x +
                        "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                        t.querySelectorAll("[msallowcapture^='']").length &&
                          m.push('[*^$]=' + L + '*(?:\'\'|"")'),
                        t.querySelectorAll('[selected]').length ||
                          m.push('\\[' + L + '*(?:value|' + q + ')'),
                        t.querySelectorAll('[id~=' + x + '-]').length ||
                          m.push('~='),
                        t.querySelectorAll(':checked').length ||
                          m.push(':checked'),
                        t.querySelectorAll('a#' + x + '+*').length ||
                          m.push('.#.+[+~]');
                    }),
                    lt(function (t) {
                      t.innerHTML =
                        "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                      var e = f.createElement('input');
                      e.setAttribute('type', 'hidden'),
                        t.appendChild(e).setAttribute('name', 'D'),
                        t.querySelectorAll('[name=d]').length &&
                          m.push('name' + L + '*[*^$|!~]?='),
                        2 !== t.querySelectorAll(':enabled').length &&
                          m.push(':enabled', ':disabled'),
                        (p.appendChild(t).disabled = !0),
                        2 !== t.querySelectorAll(':disabled').length &&
                          m.push(':enabled', ':disabled'),
                        t.querySelectorAll('*,:x'),
                        m.push(',.*:');
                    })),
                  (n.matchesSelector = Y.test(
                    (y =
                      p.matches ||
                      p.webkitMatchesSelector ||
                      p.mozMatchesSelector ||
                      p.oMatchesSelector ||
                      p.msMatchesSelector)
                  )) &&
                    lt(function (t) {
                      (n.disconnectedMatch = y.call(t, '*')),
                        y.call(t, "[s!='']:x"),
                        v.push('!=', H);
                    }),
                  (m = m.length && new RegExp(m.join('|'))),
                  (v = v.length && new RegExp(v.join('|'))),
                  (e = Y.test(p.compareDocumentPosition)),
                  (w =
                    e || Y.test(p.contains)
                      ? function (t, e) {
                          var n = 9 === t.nodeType ? t.documentElement : t,
                            i = e && e.parentNode;
                          return (
                            t === i ||
                            !(
                              !i ||
                              1 !== i.nodeType ||
                              !(n.contains
                                ? n.contains(i)
                                : t.compareDocumentPosition &&
                                  16 & t.compareDocumentPosition(i))
                            )
                          );
                        }
                      : function (t, e) {
                          if (e)
                            for (; (e = e.parentNode); ) if (e === t) return !0;
                          return !1;
                        }),
                  (S = e
                    ? function (t, e) {
                        if (t === e) return (d = !0), 0;
                        var i =
                          !t.compareDocumentPosition -
                          !e.compareDocumentPosition;
                        return (
                          i ||
                          (1 &
                            (i =
                              (t.ownerDocument || t) === (e.ownerDocument || e)
                                ? t.compareDocumentPosition(e)
                                : 1) ||
                          (!n.sortDetached &&
                            e.compareDocumentPosition(t) === i)
                            ? t === f || (t.ownerDocument === b && w(b, t))
                              ? -1
                              : e === f || (e.ownerDocument === b && w(b, e))
                              ? 1
                              : u
                              ? z(u, t) - z(u, e)
                              : 0
                            : 4 & i
                            ? -1
                            : 1)
                        );
                      }
                    : function (t, e) {
                        if (t === e) return (d = !0), 0;
                        var n,
                          i = 0,
                          o = t.parentNode,
                          r = e.parentNode,
                          s = [t],
                          a = [e];
                        if (!o || !r)
                          return t === f
                            ? -1
                            : e === f
                            ? 1
                            : o
                            ? -1
                            : r
                            ? 1
                            : u
                            ? z(u, t) - z(u, e)
                            : 0;
                        if (o === r) return ut(t, e);
                        for (n = t; (n = n.parentNode); ) s.unshift(n);
                        for (n = e; (n = n.parentNode); ) a.unshift(n);
                        for (; s[i] === a[i]; ) i++;
                        return i
                          ? ut(s[i], a[i])
                          : s[i] === b
                          ? -1
                          : a[i] === b
                          ? 1
                          : 0;
                      }),
                  f)
                : f;
            }),
          (rt.matches = function (t, e) {
            return rt(t, null, null, e);
          }),
          (rt.matchesSelector = function (t, e) {
            if (
              ((t.ownerDocument || t) !== f && h(t),
              (e = e.replace(F, "='$1']")),
              n.matchesSelector &&
                g &&
                !E[e + ' '] &&
                (!v || !v.test(e)) &&
                (!m || !m.test(e)))
            )
              try {
                var i = y.call(t, e);
                if (
                  i ||
                  n.disconnectedMatch ||
                  (t.document && 11 !== t.document.nodeType)
                )
                  return i;
              } catch (t) {}
            return rt(e, f, null, [t]).length > 0;
          }),
          (rt.contains = function (t, e) {
            return (t.ownerDocument || t) !== f && h(t), w(t, e);
          }),
          (rt.attr = function (t, e) {
            (t.ownerDocument || t) !== f && h(t);
            var o = i.attrHandle[e.toLowerCase()],
              r =
                o && j.call(i.attrHandle, e.toLowerCase())
                  ? o(t, e, !g)
                  : void 0;
            return void 0 !== r
              ? r
              : n.attributes || !g
              ? t.getAttribute(e)
              : (r = t.getAttributeNode(e)) && r.specified
              ? r.value
              : null;
          }),
          (rt.escape = function (t) {
            return (t + '').replace(et, nt);
          }),
          (rt.error = function (t) {
            throw new Error('Syntax error, unrecognized expression: ' + t);
          }),
          (rt.uniqueSort = function (t) {
            var e,
              i = [],
              o = 0,
              r = 0;
            if (
              ((d = !n.detectDuplicates),
              (u = !n.sortStable && t.slice(0)),
              t.sort(S),
              d)
            ) {
              for (; (e = t[r++]); ) e === t[r] && (o = i.push(r));
              for (; o--; ) t.splice(i[o], 1);
            }
            return (u = null), t;
          }),
          (o = rt.getText =
            function (t) {
              var e,
                n = '',
                i = 0,
                r = t.nodeType;
              if (r) {
                if (1 === r || 9 === r || 11 === r) {
                  if ('string' == typeof t.textContent) return t.textContent;
                  for (t = t.firstChild; t; t = t.nextSibling) n += o(t);
                } else if (3 === r || 4 === r) return t.nodeValue;
              } else for (; (e = t[i++]); ) n += o(e);
              return n;
            }),
          ((i = rt.selectors =
            {
              cacheLength: 50,
              createPseudo: at,
              match: V,
              attrHandle: {},
              find: {},
              relative: {
                '>': { dir: 'parentNode', first: !0 },
                ' ': { dir: 'parentNode' },
                '+': { dir: 'previousSibling', first: !0 },
                '~': { dir: 'previousSibling' },
              },
              preFilter: {
                ATTR: function (t) {
                  return (
                    (t[1] = t[1].replace(K, tt)),
                    (t[3] = (t[3] || t[4] || t[5] || '').replace(K, tt)),
                    '~=' === t[2] && (t[3] = ' ' + t[3] + ' '),
                    t.slice(0, 4)
                  );
                },
                CHILD: function (t) {
                  return (
                    (t[1] = t[1].toLowerCase()),
                    'nth' === t[1].slice(0, 3)
                      ? (t[3] || rt.error(t[0]),
                        (t[4] = +(t[4]
                          ? t[5] + (t[6] || 1)
                          : 2 * ('even' === t[3] || 'odd' === t[3]))),
                        (t[5] = +(t[7] + t[8] || 'odd' === t[3])))
                      : t[3] && rt.error(t[0]),
                    t
                  );
                },
                PSEUDO: function (t) {
                  var e,
                    n = !t[6] && t[2];
                  return V.CHILD.test(t[0])
                    ? null
                    : (t[3]
                        ? (t[2] = t[4] || t[5] || '')
                        : n &&
                          Q.test(n) &&
                          (e = s(n, !0)) &&
                          (e = n.indexOf(')', n.length - e) - n.length) &&
                          ((t[0] = t[0].slice(0, e)), (t[2] = n.slice(0, e))),
                      t.slice(0, 3));
                },
              },
              filter: {
                TAG: function (t) {
                  var e = t.replace(K, tt).toLowerCase();
                  return '*' === t
                    ? function () {
                        return !0;
                      }
                    : function (t) {
                        return t.nodeName && t.nodeName.toLowerCase() === e;
                      };
                },
                CLASS: function (t) {
                  var e = T[t + ' '];
                  return (
                    e ||
                    ((e = new RegExp('(^|' + L + ')' + t + '(' + L + '|$)')) &&
                      T(t, function (t) {
                        return e.test(
                          ('string' == typeof t.className && t.className) ||
                            (void 0 !== t.getAttribute &&
                              t.getAttribute('class')) ||
                            ''
                        );
                      }))
                  );
                },
                ATTR: function (t, e, n) {
                  return function (i) {
                    var o = rt.attr(i, t);
                    return null == o
                      ? '!=' === e
                      : !e ||
                          ((o += ''),
                          '=' === e
                            ? o === n
                            : '!=' === e
                            ? o !== n
                            : '^=' === e
                            ? n && 0 === o.indexOf(n)
                            : '*=' === e
                            ? n && o.indexOf(n) > -1
                            : '$=' === e
                            ? n && o.slice(-n.length) === n
                            : '~=' === e
                            ? (' ' + o.replace(I, ' ') + ' ').indexOf(n) > -1
                            : '|=' === e &&
                              (o === n ||
                                o.slice(0, n.length + 1) === n + '-'));
                  };
                },
                CHILD: function (t, e, n, i, o) {
                  var r = 'nth' !== t.slice(0, 3),
                    s = 'last' !== t.slice(-4),
                    a = 'of-type' === e;
                  return 1 === i && 0 === o
                    ? function (t) {
                        return !!t.parentNode;
                      }
                    : function (e, n, l) {
                        var c,
                          u,
                          d,
                          h,
                          f,
                          p,
                          g = r !== s ? 'nextSibling' : 'previousSibling',
                          m = e.parentNode,
                          v = a && e.nodeName.toLowerCase(),
                          y = !l && !a,
                          w = !1;
                        if (m) {
                          if (r) {
                            for (; g; ) {
                              for (h = e; (h = h[g]); )
                                if (
                                  a
                                    ? h.nodeName.toLowerCase() === v
                                    : 1 === h.nodeType
                                )
                                  return !1;
                              p = g = 'only' === t && !p && 'nextSibling';
                            }
                            return !0;
                          }
                          if (
                            ((p = [s ? m.firstChild : m.lastChild]), s && y)
                          ) {
                            for (
                              w =
                                (f =
                                  (c =
                                    (u =
                                      (d = (h = m)[x] || (h[x] = {}))[
                                        h.uniqueID
                                      ] || (d[h.uniqueID] = {}))[t] ||
                                    [])[0] === _ && c[1]) && c[2],
                                h = f && m.childNodes[f];
                              (h =
                                (++f && h && h[g]) || (w = f = 0) || p.pop());

                            )
                              if (1 === h.nodeType && ++w && h === e) {
                                u[t] = [_, f, w];
                                break;
                              }
                          } else if (
                            (y &&
                              (w = f =
                                (c =
                                  (u =
                                    (d = (h = e)[x] || (h[x] = {}))[
                                      h.uniqueID
                                    ] || (d[h.uniqueID] = {}))[t] || [])[0] ===
                                  _ && c[1]),
                            !1 === w)
                          )
                            for (
                              ;
                              (h =
                                (++f && h && h[g]) || (w = f = 0) || p.pop()) &&
                              ((a
                                ? h.nodeName.toLowerCase() !== v
                                : 1 !== h.nodeType) ||
                                !++w ||
                                (y &&
                                  ((u =
                                    (d = h[x] || (h[x] = {}))[h.uniqueID] ||
                                    (d[h.uniqueID] = {}))[t] = [_, w]),
                                h !== e));

                            );
                          return (w -= o) === i || (w % i == 0 && w / i >= 0);
                        }
                      };
                },
                PSEUDO: function (t, e) {
                  var n,
                    o =
                      i.pseudos[t] ||
                      i.setFilters[t.toLowerCase()] ||
                      rt.error('unsupported pseudo: ' + t);
                  return o[x]
                    ? o(e)
                    : o.length > 1
                    ? ((n = [t, t, '', e]),
                      i.setFilters.hasOwnProperty(t.toLowerCase())
                        ? at(function (t, n) {
                            for (var i, r = o(t, e), s = r.length; s--; )
                              t[(i = z(t, r[s]))] = !(n[i] = r[s]);
                          })
                        : function (t) {
                            return o(t, 0, n);
                          })
                    : o;
                },
              },
              pseudos: {
                not: at(function (t) {
                  var e = [],
                    n = [],
                    i = a(t.replace(R, '$1'));
                  return i[x]
                    ? at(function (t, e, n, o) {
                        for (var r, s = i(t, null, o, []), a = t.length; a--; )
                          (r = s[a]) && (t[a] = !(e[a] = r));
                      })
                    : function (t, o, r) {
                        return (
                          (e[0] = t), i(e, null, r, n), (e[0] = null), !n.pop()
                        );
                      };
                }),
                has: at(function (t) {
                  return function (e) {
                    return rt(t, e).length > 0;
                  };
                }),
                contains: at(function (t) {
                  return (
                    (t = t.replace(K, tt)),
                    function (e) {
                      return (
                        (e.textContent || e.innerText || o(e)).indexOf(t) > -1
                      );
                    }
                  );
                }),
                lang: at(function (t) {
                  return (
                    X.test(t || '') || rt.error('unsupported lang: ' + t),
                    (t = t.replace(K, tt).toLowerCase()),
                    function (e) {
                      var n;
                      do {
                        if (
                          (n = g
                            ? e.lang
                            : e.getAttribute('xml:lang') ||
                              e.getAttribute('lang'))
                        )
                          return (
                            (n = n.toLowerCase()) === t ||
                            0 === n.indexOf(t + '-')
                          );
                      } while ((e = e.parentNode) && 1 === e.nodeType);
                      return !1;
                    }
                  );
                }),
                target: function (e) {
                  var n = t.location && t.location.hash;
                  return n && n.slice(1) === e.id;
                },
                root: function (t) {
                  return t === p;
                },
                focus: function (t) {
                  return (
                    t === f.activeElement &&
                    (!f.hasFocus || f.hasFocus()) &&
                    !!(t.type || t.href || ~t.tabIndex)
                  );
                },
                enabled: ft(!1),
                disabled: ft(!0),
                checked: function (t) {
                  var e = t.nodeName.toLowerCase();
                  return (
                    ('input' === e && !!t.checked) ||
                    ('option' === e && !!t.selected)
                  );
                },
                selected: function (t) {
                  return (
                    t.parentNode && t.parentNode.selectedIndex,
                    !0 === t.selected
                  );
                },
                empty: function (t) {
                  for (t = t.firstChild; t; t = t.nextSibling)
                    if (t.nodeType < 6) return !1;
                  return !0;
                },
                parent: function (t) {
                  return !i.pseudos.empty(t);
                },
                header: function (t) {
                  return U.test(t.nodeName);
                },
                input: function (t) {
                  return G.test(t.nodeName);
                },
                button: function (t) {
                  var e = t.nodeName.toLowerCase();
                  return (
                    ('input' === e && 'button' === t.type) || 'button' === e
                  );
                },
                text: function (t) {
                  var e;
                  return (
                    'input' === t.nodeName.toLowerCase() &&
                    'text' === t.type &&
                    (null == (e = t.getAttribute('type')) ||
                      'text' === e.toLowerCase())
                  );
                },
                first: pt(function () {
                  return [0];
                }),
                last: pt(function (t, e) {
                  return [e - 1];
                }),
                eq: pt(function (t, e, n) {
                  return [n < 0 ? n + e : n];
                }),
                even: pt(function (t, e) {
                  for (var n = 0; n < e; n += 2) t.push(n);
                  return t;
                }),
                odd: pt(function (t, e) {
                  for (var n = 1; n < e; n += 2) t.push(n);
                  return t;
                }),
                lt: pt(function (t, e, n) {
                  for (var i = n < 0 ? n + e : n; --i >= 0; ) t.push(i);
                  return t;
                }),
                gt: pt(function (t, e, n) {
                  for (var i = n < 0 ? n + e : n; ++i < e; ) t.push(i);
                  return t;
                }),
              },
            }).pseudos.nth = i.pseudos.eq),
          {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0,
          }))
            i.pseudos[e] = dt(e);
          for (e in { submit: !0, reset: !0 }) i.pseudos[e] = ht(e);

          function mt() {}

          function vt(t) {
            for (var e = 0, n = t.length, i = ''; e < n; e++) i += t[e].value;
            return i;
          }

          function yt(t, e, n) {
            var i = e.dir,
              o = e.next,
              r = o || i,
              s = n && 'parentNode' === r,
              a = C++;
            return e.first
              ? function (e, n, o) {
                  for (; (e = e[i]); )
                    if (1 === e.nodeType || s) return t(e, n, o);
                  return !1;
                }
              : function (e, n, l) {
                  var c,
                    u,
                    d,
                    h = [_, a];
                  if (l) {
                    for (; (e = e[i]); )
                      if ((1 === e.nodeType || s) && t(e, n, l)) return !0;
                  } else
                    for (; (e = e[i]); )
                      if (1 === e.nodeType || s)
                        if (
                          ((u =
                            (d = e[x] || (e[x] = {}))[e.uniqueID] ||
                            (d[e.uniqueID] = {})),
                          o && o === e.nodeName.toLowerCase())
                        )
                          e = e[i] || e;
                        else {
                          if ((c = u[r]) && c[0] === _ && c[1] === a)
                            return (h[2] = c[2]);
                          if (((u[r] = h), (h[2] = t(e, n, l)))) return !0;
                        }
                  return !1;
                };
          }

          function wt(t) {
            return t.length > 1
              ? function (e, n, i) {
                  for (var o = t.length; o--; ) if (!t[o](e, n, i)) return !1;
                  return !0;
                }
              : t[0];
          }

          function xt(t, e, n, i, o) {
            for (var r, s = [], a = 0, l = t.length, c = null != e; a < l; a++)
              (r = t[a]) && ((n && !n(r, i, o)) || (s.push(r), c && e.push(a)));
            return s;
          }

          function bt(t, e, n, i, o, r) {
            return (
              i && !i[x] && (i = bt(i)),
              o && !o[x] && (o = bt(o, r)),
              at(function (r, s, a, l) {
                var c,
                  u,
                  d,
                  h = [],
                  f = [],
                  p = s.length,
                  g =
                    r ||
                    (function (t, e, n) {
                      for (var i = 0, o = e.length; i < o; i++) rt(t, e[i], n);
                      return n;
                    })(e || '*', a.nodeType ? [a] : a, []),
                  m = !t || (!r && e) ? g : xt(g, h, t, a, l),
                  v = n ? (o || (r ? t : p || i) ? [] : s) : m;
                if ((n && n(m, v, a, l), i))
                  for (c = xt(v, f), i(c, [], a, l), u = c.length; u--; )
                    (d = c[u]) && (v[f[u]] = !(m[f[u]] = d));
                if (r) {
                  if (o || t) {
                    if (o) {
                      for (c = [], u = v.length; u--; )
                        (d = v[u]) && c.push((m[u] = d));
                      o(null, (v = []), c, l);
                    }
                    for (u = v.length; u--; )
                      (d = v[u]) &&
                        (c = o ? z(r, d) : h[u]) > -1 &&
                        (r[c] = !(s[c] = d));
                  }
                } else (v = xt(v === s ? v.splice(p, v.length) : v)), o ? o(null, s, v, l) : O.apply(s, v);
              })
            );
          }

          function _t(t) {
            for (
              var e,
                n,
                o,
                r = t.length,
                s = i.relative[t[0].type],
                a = s || i.relative[' '],
                l = s ? 1 : 0,
                u = yt(
                  function (t) {
                    return t === e;
                  },
                  a,
                  !0
                ),
                d = yt(
                  function (t) {
                    return z(e, t) > -1;
                  },
                  a,
                  !0
                ),
                h = [
                  function (t, n, i) {
                    var o =
                      (!s && (i || n !== c)) ||
                      ((e = n).nodeType ? u(t, n, i) : d(t, n, i));
                    return (e = null), o;
                  },
                ];
              l < r;
              l++
            )
              if ((n = i.relative[t[l].type])) h = [yt(wt(h), n)];
              else {
                if ((n = i.filter[t[l].type].apply(null, t[l].matches))[x]) {
                  for (o = ++l; o < r && !i.relative[t[o].type]; o++);
                  return bt(
                    l > 1 && wt(h),
                    l > 1 &&
                      vt(
                        t
                          .slice(0, l - 1)
                          .concat({ value: ' ' === t[l - 2].type ? '*' : '' })
                      ).replace(R, '$1'),
                    n,
                    l < o && _t(t.slice(l, o)),
                    o < r && _t((t = t.slice(o))),
                    o < r && vt(t)
                  );
                }
                h.push(n);
              }
            return wt(h);
          }

          return (
            (mt.prototype = i.filters = i.pseudos),
            (i.setFilters = new mt()),
            (s = rt.tokenize =
              function (t, e) {
                var n,
                  o,
                  r,
                  s,
                  a,
                  l,
                  c,
                  u = k[t + ' '];
                if (u) return e ? 0 : u.slice(0);
                for (a = t, l = [], c = i.preFilter; a; ) {
                  for (s in ((n && !(o = W.exec(a))) ||
                    (o && (a = a.slice(o[0].length) || a), l.push((r = []))),
                  (n = !1),
                  (o = B.exec(a)) &&
                    ((n = o.shift()),
                    r.push({
                      value: n,
                      type: o[0].replace(R, ' '),
                    }),
                    (a = a.slice(n.length))),
                  i.filter))
                    !(o = V[s].exec(a)) ||
                      (c[s] && !(o = c[s](o))) ||
                      ((n = o.shift()),
                      r.push({
                        value: n,
                        type: s,
                        matches: o,
                      }),
                      (a = a.slice(n.length)));
                  if (!n) break;
                }
                return e ? a.length : a ? rt.error(t) : k(t, l).slice(0);
              }),
            (a = rt.compile =
              function (t, e) {
                var n,
                  o = [],
                  r = [],
                  a = E[t + ' '];
                if (!a) {
                  for (e || (e = s(t)), n = e.length; n--; )
                    (a = _t(e[n]))[x] ? o.push(a) : r.push(a);
                  (a = E(
                    t,
                    (function (t, e) {
                      var n = e.length > 0,
                        o = t.length > 0,
                        r = function (r, s, a, l, u) {
                          var d,
                            p,
                            m,
                            v = 0,
                            y = '0',
                            w = r && [],
                            x = [],
                            b = c,
                            C = r || (o && i.find.TAG('*', u)),
                            T = (_ += null == b ? 1 : Math.random() || 0.1),
                            k = C.length;
                          for (
                            u && (c = s === f || s || u);
                            y !== k && null != (d = C[y]);
                            y++
                          ) {
                            if (o && d) {
                              for (
                                p = 0,
                                  s ||
                                    d.ownerDocument === f ||
                                    (h(d), (a = !g));
                                (m = t[p++]);

                              )
                                if (m(d, s || f, a)) {
                                  l.push(d);
                                  break;
                                }
                              u && (_ = T);
                            }
                            n && ((d = !m && d) && v--, r && w.push(d));
                          }
                          if (((v += y), n && y !== v)) {
                            for (p = 0; (m = e[p++]); ) m(w, x, s, a);
                            if (r) {
                              if (v > 0)
                                for (; y--; )
                                  w[y] || x[y] || (x[y] = $.call(l));
                              x = xt(x);
                            }
                            O.apply(l, x),
                              u &&
                                !r &&
                                x.length > 0 &&
                                v + e.length > 1 &&
                                rt.uniqueSort(l);
                          }
                          return u && ((_ = T), (c = b)), w;
                        };
                      return n ? at(r) : r;
                    })(r, o)
                  )).selector = t;
                }
                return a;
              }),
            (l = rt.select =
              function (t, e, n, o) {
                var r,
                  l,
                  c,
                  u,
                  d,
                  h = 'function' == typeof t && t,
                  f = !o && s((t = h.selector || t));
                if (((n = n || []), 1 === f.length)) {
                  if (
                    (l = f[0] = f[0].slice(0)).length > 2 &&
                    'ID' === (c = l[0]).type &&
                    9 === e.nodeType &&
                    g &&
                    i.relative[l[1].type]
                  ) {
                    if (
                      !(e = (i.find.ID(c.matches[0].replace(K, tt), e) ||
                        [])[0])
                    )
                      return n;
                    h && (e = e.parentNode),
                      (t = t.slice(l.shift().value.length));
                  }
                  for (
                    r = V.needsContext.test(t) ? 0 : l.length;
                    r-- && ((c = l[r]), !i.relative[(u = c.type)]);

                  )
                    if (
                      (d = i.find[u]) &&
                      (o = d(
                        c.matches[0].replace(K, tt),
                        (J.test(l[0].type) && gt(e.parentNode)) || e
                      ))
                    ) {
                      if ((l.splice(r, 1), !(t = o.length && vt(l))))
                        return O.apply(n, o), n;
                      break;
                    }
                }
                return (
                  (h || a(t, f))(
                    o,
                    e,
                    !g,
                    n,
                    !e || (J.test(t) && gt(e.parentNode)) || e
                  ),
                  n
                );
              }),
            (n.sortStable = x.split('').sort(S).join('') === x),
            (n.detectDuplicates = !!d),
            h(),
            (n.sortDetached = lt(function (t) {
              return 1 & t.compareDocumentPosition(f.createElement('fieldset'));
            })),
            lt(function (t) {
              return (
                (t.innerHTML = "<a href='#'></a>"),
                '#' === t.firstChild.getAttribute('href')
              );
            }) ||
              ct('type|href|height|width', function (t, e, n) {
                if (!n)
                  return t.getAttribute(e, 'type' === e.toLowerCase() ? 1 : 2);
              }),
            (n.attributes &&
              lt(function (t) {
                return (
                  (t.innerHTML = '<input/>'),
                  t.firstChild.setAttribute('value', ''),
                  '' === t.firstChild.getAttribute('value')
                );
              })) ||
              ct('value', function (t, e, n) {
                if (!n && 'input' === t.nodeName.toLowerCase())
                  return t.defaultValue;
              }),
            lt(function (t) {
              return null == t.getAttribute('disabled');
            }) ||
              ct(q, function (t, e, n) {
                var i;
                if (!n)
                  return !0 === t[e]
                    ? e.toLowerCase()
                    : (i = t.getAttributeNode(e)) && i.specified
                    ? i.value
                    : null;
              }),
            rt
          );
        })(n);
      (C.find = E),
        (C.expr = E.selectors),
        (C.expr[':'] = C.expr.pseudos),
        (C.uniqueSort = C.unique = E.uniqueSort),
        (C.text = E.getText),
        (C.isXMLDoc = E.isXML),
        (C.contains = E.contains),
        (C.escapeSelector = E.escape);
      var S = function (t, e, n) {
          for (var i = [], o = void 0 !== n; (t = t[e]) && 9 !== t.nodeType; )
            if (1 === t.nodeType) {
              if (o && C(t).is(n)) break;
              i.push(t);
            }
          return i;
        },
        j = function (t, e) {
          for (var n = []; t; t = t.nextSibling)
            1 === t.nodeType && t !== e && n.push(t);
          return n;
        },
        A = C.expr.match.needsContext;

      function $(t, e) {
        return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase();
      }

      var D = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

      function O(t, e, n) {
        return y(e)
          ? C.grep(t, function (t, i) {
              return !!e.call(t, i, t) !== n;
            })
          : e.nodeType
          ? C.grep(t, function (t) {
              return (t === e) !== n;
            })
          : 'string' != typeof e
          ? C.grep(t, function (t) {
              return d.call(e, t) > -1 !== n;
            })
          : C.filter(e, t, n);
      }

      (C.filter = function (t, e, n) {
        var i = e[0];
        return (
          n && (t = ':not(' + t + ')'),
          1 === e.length && 1 === i.nodeType
            ? C.find.matchesSelector(i, t)
              ? [i]
              : []
            : C.find.matches(
                t,
                C.grep(e, function (t) {
                  return 1 === t.nodeType;
                })
              )
        );
      }),
        C.fn.extend({
          find: function (t) {
            var e,
              n,
              i = this.length,
              o = this;
            if ('string' != typeof t)
              return this.pushStack(
                C(t).filter(function () {
                  for (e = 0; e < i; e++) if (C.contains(o[e], this)) return !0;
                })
              );
            for (n = this.pushStack([]), e = 0; e < i; e++) C.find(t, o[e], n);
            return i > 1 ? C.uniqueSort(n) : n;
          },
          filter: function (t) {
            return this.pushStack(O(this, t || [], !1));
          },
          not: function (t) {
            return this.pushStack(O(this, t || [], !0));
          },
          is: function (t) {
            return !!O(
              this,
              'string' == typeof t && A.test(t) ? C(t) : t || [],
              !1
            ).length;
          },
        });
      var N,
        z = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
      ((C.fn.init = function (t, e, n) {
        var i, o;
        if (!t) return this;
        if (((n = n || N), 'string' == typeof t)) {
          if (
            !(i =
              '<' === t[0] && '>' === t[t.length - 1] && t.length >= 3
                ? [null, t, null]
                : z.exec(t)) ||
            (!i[1] && e)
          )
            return !e || e.jquery
              ? (e || n).find(t)
              : this.constructor(e).find(t);
          if (i[1]) {
            if (
              ((e = e instanceof C ? e[0] : e),
              C.merge(
                this,
                C.parseHTML(
                  i[1],
                  e && e.nodeType ? e.ownerDocument || e : s,
                  !0
                )
              ),
              D.test(i[1]) && C.isPlainObject(e))
            )
              for (i in e) y(this[i]) ? this[i](e[i]) : this.attr(i, e[i]);
            return this;
          }
          return (
            (o = s.getElementById(i[2])) && ((this[0] = o), (this.length = 1)),
            this
          );
        }
        return t.nodeType
          ? ((this[0] = t), (this.length = 1), this)
          : y(t)
          ? void 0 !== n.ready
            ? n.ready(t)
            : t(C)
          : C.makeArray(t, this);
      }).prototype = C.fn),
        (N = C(s));
      var q = /^(?:parents|prev(?:Until|All))/,
        L = { children: !0, contents: !0, next: !0, prev: !0 };

      function M(t, e) {
        for (; (t = t[e]) && 1 !== t.nodeType; );
        return t;
      }

      C.fn.extend({
        has: function (t) {
          var e = C(t, this),
            n = e.length;
          return this.filter(function () {
            for (var t = 0; t < n; t++) if (C.contains(this, e[t])) return !0;
          });
        },
        closest: function (t, e) {
          var n,
            i = 0,
            o = this.length,
            r = [],
            s = 'string' != typeof t && C(t);
          if (!A.test(t))
            for (; i < o; i++)
              for (n = this[i]; n && n !== e; n = n.parentNode)
                if (
                  n.nodeType < 11 &&
                  (s
                    ? s.index(n) > -1
                    : 1 === n.nodeType && C.find.matchesSelector(n, t))
                ) {
                  r.push(n);
                  break;
                }
          return this.pushStack(r.length > 1 ? C.uniqueSort(r) : r);
        },
        index: function (t) {
          return t
            ? 'string' == typeof t
              ? d.call(C(t), this[0])
              : d.call(this, t.jquery ? t[0] : t)
            : this[0] && this[0].parentNode
            ? this.first().prevAll().length
            : -1;
        },
        add: function (t, e) {
          return this.pushStack(C.uniqueSort(C.merge(this.get(), C(t, e))));
        },
        addBack: function (t) {
          return this.add(
            null == t ? this.prevObject : this.prevObject.filter(t)
          );
        },
      }),
        C.each(
          {
            parent: function (t) {
              var e = t.parentNode;
              return e && 11 !== e.nodeType ? e : null;
            },
            parents: function (t) {
              return S(t, 'parentNode');
            },
            parentsUntil: function (t, e, n) {
              return S(t, 'parentNode', n);
            },
            next: function (t) {
              return M(t, 'nextSibling');
            },
            prev: function (t) {
              return M(t, 'previousSibling');
            },
            nextAll: function (t) {
              return S(t, 'nextSibling');
            },
            prevAll: function (t) {
              return S(t, 'previousSibling');
            },
            nextUntil: function (t, e, n) {
              return S(t, 'nextSibling', n);
            },
            prevUntil: function (t, e, n) {
              return S(t, 'previousSibling', n);
            },
            siblings: function (t) {
              return j((t.parentNode || {}).firstChild, t);
            },
            children: function (t) {
              return j(t.firstChild);
            },
            contents: function (t) {
              return $(t, 'iframe')
                ? t.contentDocument
                : ($(t, 'template') && (t = t.content || t),
                  C.merge([], t.childNodes));
            },
          },
          function (t, e) {
            C.fn[t] = function (n, i) {
              var o = C.map(this, e, n);
              return (
                'Until' !== t.slice(-5) && (i = n),
                i && 'string' == typeof i && (o = C.filter(i, o)),
                this.length > 1 &&
                  (L[t] || C.uniqueSort(o), q.test(t) && o.reverse()),
                this.pushStack(o)
              );
            };
          }
        );
      var P = /[^\x20\t\r\n\f]+/g;

      function H(t) {
        return t;
      }

      function I(t) {
        throw t;
      }

      function R(t, e, n, i) {
        var o;
        try {
          t && y((o = t.promise))
            ? o.call(t).done(e).fail(n)
            : t && y((o = t.then))
            ? o.call(t, e, n)
            : e.apply(void 0, [t].slice(i));
        } catch (t) {
          n.apply(void 0, [t]);
        }
      }

      (C.Callbacks = function (t) {
        t =
          'string' == typeof t
            ? (function (t) {
                var e = {};
                return (
                  C.each(t.match(P) || [], function (t, n) {
                    e[n] = !0;
                  }),
                  e
                );
              })(t)
            : C.extend({}, t);
        var e,
          n,
          i,
          o,
          r = [],
          s = [],
          a = -1,
          l = function () {
            for (o = o || t.once, i = e = !0; s.length; a = -1)
              for (n = s.shift(); ++a < r.length; )
                !1 === r[a].apply(n[0], n[1]) &&
                  t.stopOnFalse &&
                  ((a = r.length), (n = !1));
            t.memory || (n = !1), (e = !1), o && (r = n ? [] : '');
          },
          c = {
            add: function () {
              return (
                r &&
                  (n && !e && ((a = r.length - 1), s.push(n)),
                  (function e(n) {
                    C.each(n, function (n, i) {
                      y(i)
                        ? (t.unique && c.has(i)) || r.push(i)
                        : i && i.length && 'string' !== _(i) && e(i);
                    });
                  })(arguments),
                  n && !e && l()),
                this
              );
            },
            remove: function () {
              return (
                C.each(arguments, function (t, e) {
                  for (var n; (n = C.inArray(e, r, n)) > -1; )
                    r.splice(n, 1), n <= a && a--;
                }),
                this
              );
            },
            has: function (t) {
              return t ? C.inArray(t, r) > -1 : r.length > 0;
            },
            empty: function () {
              return r && (r = []), this;
            },
            disable: function () {
              return (o = s = []), (r = n = ''), this;
            },
            disabled: function () {
              return !r;
            },
            lock: function () {
              return (o = s = []), n || e || (r = n = ''), this;
            },
            locked: function () {
              return !!o;
            },
            fireWith: function (t, n) {
              return (
                o ||
                  ((n = [t, (n = n || []).slice ? n.slice() : n]),
                  s.push(n),
                  e || l()),
                this
              );
            },
            fire: function () {
              return c.fireWith(this, arguments), this;
            },
            fired: function () {
              return !!i;
            },
          };
        return c;
      }),
        C.extend({
          Deferred: function (t) {
            var e = [
                [
                  'notify',
                  'progress',
                  C.Callbacks('memory'),
                  C.Callbacks('memory'),
                  2,
                ],
                [
                  'resolve',
                  'done',
                  C.Callbacks('once memory'),
                  C.Callbacks('once memory'),
                  0,
                  'resolved',
                ],
                [
                  'reject',
                  'fail',
                  C.Callbacks('once memory'),
                  C.Callbacks('once memory'),
                  1,
                  'rejected',
                ],
              ],
              i = 'pending',
              o = {
                state: function () {
                  return i;
                },
                always: function () {
                  return r.done(arguments).fail(arguments), this;
                },
                catch: function (t) {
                  return o.then(null, t);
                },
                pipe: function () {
                  var t = arguments;
                  return C.Deferred(function (n) {
                    C.each(e, function (e, i) {
                      var o = y(t[i[4]]) && t[i[4]];
                      r[i[1]](function () {
                        var t = o && o.apply(this, arguments);
                        t && y(t.promise)
                          ? t
                              .promise()
                              .progress(n.notify)
                              .done(n.resolve)
                              .fail(n.reject)
                          : n[i[0] + 'With'](this, o ? [t] : arguments);
                      });
                    }),
                      (t = null);
                  }).promise();
                },
                then: function (t, i, o) {
                  var r = 0;

                  function s(t, e, i, o) {
                    return function () {
                      var a = this,
                        l = arguments,
                        c = function () {
                          var n, c;
                          if (!(t < r)) {
                            if ((n = i.apply(a, l)) === e.promise())
                              throw new TypeError('Thenable self-resolution');
                            (c =
                              n &&
                              ('object' == typeof n ||
                                'function' == typeof n) &&
                              n.then),
                              y(c)
                                ? o
                                  ? c.call(n, s(r, e, H, o), s(r, e, I, o))
                                  : (r++,
                                    c.call(
                                      n,
                                      s(r, e, H, o),
                                      s(r, e, I, o),
                                      s(r, e, H, e.notifyWith)
                                    ))
                                : (i !== H && ((a = void 0), (l = [n])),
                                  (o || e.resolveWith)(a, l));
                          }
                        },
                        u = o
                          ? c
                          : function () {
                              try {
                                c();
                              } catch (n) {
                                C.Deferred.exceptionHook &&
                                  C.Deferred.exceptionHook(n, u.stackTrace),
                                  t + 1 >= r &&
                                    (i !== I && ((a = void 0), (l = [n])),
                                    e.rejectWith(a, l));
                              }
                            };
                      t
                        ? u()
                        : (C.Deferred.getStackHook &&
                            (u.stackTrace = C.Deferred.getStackHook()),
                          n.setTimeout(u));
                    };
                  }

                  return C.Deferred(function (n) {
                    e[0][3].add(s(0, n, y(o) ? o : H, n.notifyWith)),
                      e[1][3].add(s(0, n, y(t) ? t : H)),
                      e[2][3].add(s(0, n, y(i) ? i : I));
                  }).promise();
                },
                promise: function (t) {
                  return null != t ? C.extend(t, o) : o;
                },
              },
              r = {};
            return (
              C.each(e, function (t, n) {
                var s = n[2],
                  a = n[5];
                (o[n[1]] = s.add),
                  a &&
                    s.add(
                      function () {
                        i = a;
                      },
                      e[3 - t][2].disable,
                      e[3 - t][3].disable,
                      e[0][2].lock,
                      e[0][3].lock
                    ),
                  s.add(n[3].fire),
                  (r[n[0]] = function () {
                    return (
                      r[n[0] + 'With'](this === r ? void 0 : this, arguments),
                      this
                    );
                  }),
                  (r[n[0] + 'With'] = s.fireWith);
              }),
              o.promise(r),
              t && t.call(r, r),
              r
            );
          },
          when: function (t) {
            var e = arguments.length,
              n = e,
              i = Array(n),
              o = l.call(arguments),
              r = C.Deferred(),
              s = function (t) {
                return function (n) {
                  (i[t] = this),
                    (o[t] = arguments.length > 1 ? l.call(arguments) : n),
                    --e || r.resolveWith(i, o);
                };
              };
            if (
              e <= 1 &&
              (R(t, r.done(s(n)).resolve, r.reject, !e),
              'pending' === r.state() || y(o[n] && o[n].then))
            )
              return r.then();
            for (; n--; ) R(o[n], s(n), r.reject);
            return r.promise();
          },
        });
      var W = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
      (C.Deferred.exceptionHook = function (t, e) {
        n.console &&
          n.console.warn &&
          t &&
          W.test(t.name) &&
          n.console.warn('jQuery.Deferred exception: ' + t.message, t.stack, e);
      }),
        (C.readyException = function (t) {
          n.setTimeout(function () {
            throw t;
          });
        });
      var B = C.Deferred();

      function F() {
        s.removeEventListener('DOMContentLoaded', F),
          n.removeEventListener('load', F),
          C.ready();
      }

      (C.fn.ready = function (t) {
        return (
          B.then(t).catch(function (t) {
            C.readyException(t);
          }),
          this
        );
      }),
        C.extend({
          isReady: !1,
          readyWait: 1,
          ready: function (t) {
            (!0 === t ? --C.readyWait : C.isReady) ||
              ((C.isReady = !0),
              (!0 !== t && --C.readyWait > 0) || B.resolveWith(s, [C]));
          },
        }),
        (C.ready.then = B.then),
        'complete' === s.readyState ||
        ('loading' !== s.readyState && !s.documentElement.doScroll)
          ? n.setTimeout(C.ready)
          : (s.addEventListener('DOMContentLoaded', F),
            n.addEventListener('load', F));
      var Q = function (t, e, n, i, o, r, s) {
          var a = 0,
            l = t.length,
            c = null == n;
          if ('object' === _(n))
            for (a in ((o = !0), n)) Q(t, e, a, n[a], !0, r, s);
          else if (
            void 0 !== i &&
            ((o = !0),
            y(i) || (s = !0),
            c &&
              (s
                ? (e.call(t, i), (e = null))
                : ((c = e),
                  (e = function (t, e, n) {
                    return c.call(C(t), n);
                  }))),
            e)
          )
            for (; a < l; a++) e(t[a], n, s ? i : i.call(t[a], a, e(t[a], n)));
          return o ? t : c ? e.call(t) : l ? e(t[0], n) : r;
        },
        X = /^-ms-/,
        V = /-([a-z])/g;

      function G(t, e) {
        return e.toUpperCase();
      }

      function U(t) {
        return t.replace(X, 'ms-').replace(V, G);
      }

      var Y = function (t) {
        return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType;
      };

      function Z() {
        this.expando = C.expando + Z.uid++;
      }

      (Z.uid = 1),
        (Z.prototype = {
          cache: function (t) {
            var e = t[this.expando];
            return (
              e ||
                ((e = {}),
                Y(t) &&
                  (t.nodeType
                    ? (t[this.expando] = e)
                    : Object.defineProperty(t, this.expando, {
                        value: e,
                        configurable: !0,
                      }))),
              e
            );
          },
          set: function (t, e, n) {
            var i,
              o = this.cache(t);
            if ('string' == typeof e) o[U(e)] = n;
            else for (i in e) o[U(i)] = e[i];
            return o;
          },
          get: function (t, e) {
            return void 0 === e
              ? this.cache(t)
              : t[this.expando] && t[this.expando][U(e)];
          },
          access: function (t, e, n) {
            return void 0 === e || (e && 'string' == typeof e && void 0 === n)
              ? this.get(t, e)
              : (this.set(t, e, n), void 0 !== n ? n : e);
          },
          remove: function (t, e) {
            var n,
              i = t[this.expando];
            if (void 0 !== i) {
              if (void 0 !== e) {
                n = (e = Array.isArray(e)
                  ? e.map(U)
                  : (e = U(e)) in i
                  ? [e]
                  : e.match(P) || []).length;
                for (; n--; ) delete i[e[n]];
              }
              (void 0 === e || C.isEmptyObject(i)) &&
                (t.nodeType
                  ? (t[this.expando] = void 0)
                  : delete t[this.expando]);
            }
          },
          hasData: function (t) {
            var e = t[this.expando];
            return void 0 !== e && !C.isEmptyObject(e);
          },
        });
      var J = new Z(),
        K = new Z(),
        tt = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        et = /[A-Z]/g;

      function nt(t, e, n) {
        var i;
        if (void 0 === n && 1 === t.nodeType)
          if (
            ((i = 'data-' + e.replace(et, '-$&').toLowerCase()),
            'string' == typeof (n = t.getAttribute(i)))
          ) {
            try {
              n = (function (t) {
                return (
                  'true' === t ||
                  ('false' !== t &&
                    ('null' === t
                      ? null
                      : t === +t + ''
                      ? +t
                      : tt.test(t)
                      ? JSON.parse(t)
                      : t))
                );
              })(n);
            } catch (t) {}
            K.set(t, e, n);
          } else n = void 0;
        return n;
      }

      C.extend({
        hasData: function (t) {
          return K.hasData(t) || J.hasData(t);
        },
        data: function (t, e, n) {
          return K.access(t, e, n);
        },
        removeData: function (t, e) {
          K.remove(t, e);
        },
        _data: function (t, e, n) {
          return J.access(t, e, n);
        },
        _removeData: function (t, e) {
          J.remove(t, e);
        },
      }),
        C.fn.extend({
          data: function (t, e) {
            var n,
              i,
              o,
              r = this[0],
              s = r && r.attributes;
            if (void 0 === t) {
              if (
                this.length &&
                ((o = K.get(r)), 1 === r.nodeType && !J.get(r, 'hasDataAttrs'))
              ) {
                for (n = s.length; n--; )
                  s[n] &&
                    0 === (i = s[n].name).indexOf('data-') &&
                    ((i = U(i.slice(5))), nt(r, i, o[i]));
                J.set(r, 'hasDataAttrs', !0);
              }
              return o;
            }
            return 'object' == typeof t
              ? this.each(function () {
                  K.set(this, t);
                })
              : Q(
                  this,
                  function (e) {
                    var n;
                    if (r && void 0 === e)
                      return void 0 !== (n = K.get(r, t))
                        ? n
                        : void 0 !== (n = nt(r, t))
                        ? n
                        : void 0;
                    this.each(function () {
                      K.set(this, t, e);
                    });
                  },
                  null,
                  e,
                  arguments.length > 1,
                  null,
                  !0
                );
          },
          removeData: function (t) {
            return this.each(function () {
              K.remove(this, t);
            });
          },
        }),
        C.extend({
          queue: function (t, e, n) {
            var i;
            if (t)
              return (
                (e = (e || 'fx') + 'queue'),
                (i = J.get(t, e)),
                n &&
                  (!i || Array.isArray(n)
                    ? (i = J.access(t, e, C.makeArray(n)))
                    : i.push(n)),
                i || []
              );
          },
          dequeue: function (t, e) {
            e = e || 'fx';
            var n = C.queue(t, e),
              i = n.length,
              o = n.shift(),
              r = C._queueHooks(t, e);
            'inprogress' === o && ((o = n.shift()), i--),
              o &&
                ('fx' === e && n.unshift('inprogress'),
                delete r.stop,
                o.call(
                  t,
                  function () {
                    C.dequeue(t, e);
                  },
                  r
                )),
              !i && r && r.empty.fire();
          },
          _queueHooks: function (t, e) {
            var n = e + 'queueHooks';
            return (
              J.get(t, n) ||
              J.access(t, n, {
                empty: C.Callbacks('once memory').add(function () {
                  J.remove(t, [e + 'queue', n]);
                }),
              })
            );
          },
        }),
        C.fn.extend({
          queue: function (t, e) {
            var n = 2;
            return (
              'string' != typeof t && ((e = t), (t = 'fx'), n--),
              arguments.length < n
                ? C.queue(this[0], t)
                : void 0 === e
                ? this
                : this.each(function () {
                    var n = C.queue(this, t, e);
                    C._queueHooks(this, t),
                      'fx' === t && 'inprogress' !== n[0] && C.dequeue(this, t);
                  })
            );
          },
          dequeue: function (t) {
            return this.each(function () {
              C.dequeue(this, t);
            });
          },
          clearQueue: function (t) {
            return this.queue(t || 'fx', []);
          },
          promise: function (t, e) {
            var n,
              i = 1,
              o = C.Deferred(),
              r = this,
              s = this.length,
              a = function () {
                --i || o.resolveWith(r, [r]);
              };
            for (
              'string' != typeof t && ((e = t), (t = void 0)), t = t || 'fx';
              s--;

            )
              (n = J.get(r[s], t + 'queueHooks')) &&
                n.empty &&
                (i++, n.empty.add(a));
            return a(), o.promise(e);
          },
        });
      var it = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        ot = new RegExp('^(?:([+-])=|)(' + it + ')([a-z%]*)$', 'i'),
        rt = ['Top', 'Right', 'Bottom', 'Left'],
        st = function (t, e) {
          return (
            'none' === (t = e || t).style.display ||
            ('' === t.style.display &&
              C.contains(t.ownerDocument, t) &&
              'none' === C.css(t, 'display'))
          );
        },
        at = function (t, e, n, i) {
          var o,
            r,
            s = {};
          for (r in e) (s[r] = t.style[r]), (t.style[r] = e[r]);
          for (r in ((o = n.apply(t, i || [])), e)) t.style[r] = s[r];
          return o;
        };

      function lt(t, e, n, i) {
        var o,
          r,
          s = 20,
          a = i
            ? function () {
                return i.cur();
              }
            : function () {
                return C.css(t, e, '');
              },
          l = a(),
          c = (n && n[3]) || (C.cssNumber[e] ? '' : 'px'),
          u = (C.cssNumber[e] || ('px' !== c && +l)) && ot.exec(C.css(t, e));
        if (u && u[3] !== c) {
          for (l /= 2, c = c || u[3], u = +l || 1; s--; )
            C.style(t, e, u + c),
              (1 - r) * (1 - (r = a() / l || 0.5)) <= 0 && (s = 0),
              (u /= r);
          (u *= 2), C.style(t, e, u + c), (n = n || []);
        }
        return (
          n &&
            ((u = +u || +l || 0),
            (o = n[1] ? u + (n[1] + 1) * n[2] : +n[2]),
            i && ((i.unit = c), (i.start = u), (i.end = o))),
          o
        );
      }

      var ct = {};

      function ut(t) {
        var e,
          n = t.ownerDocument,
          i = t.nodeName,
          o = ct[i];
        return (
          o ||
          ((e = n.body.appendChild(n.createElement(i))),
          (o = C.css(e, 'display')),
          e.parentNode.removeChild(e),
          'none' === o && (o = 'block'),
          (ct[i] = o),
          o)
        );
      }

      function dt(t, e) {
        for (var n, i, o = [], r = 0, s = t.length; r < s; r++)
          (i = t[r]).style &&
            ((n = i.style.display),
            e
              ? ('none' === n &&
                  ((o[r] = J.get(i, 'display') || null),
                  o[r] || (i.style.display = '')),
                '' === i.style.display && st(i) && (o[r] = ut(i)))
              : 'none' !== n && ((o[r] = 'none'), J.set(i, 'display', n)));
        for (r = 0; r < s; r++) null != o[r] && (t[r].style.display = o[r]);
        return t;
      }

      C.fn.extend({
        show: function () {
          return dt(this, !0);
        },
        hide: function () {
          return dt(this);
        },
        toggle: function (t) {
          return 'boolean' == typeof t
            ? t
              ? this.show()
              : this.hide()
            : this.each(function () {
                st(this) ? C(this).show() : C(this).hide();
              });
        },
      });
      var ht = /^(?:checkbox|radio)$/i,
        ft = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i,
        pt = /^$|^module$|\/(?:java|ecma)script/i,
        gt = {
          option: [1, "<select multiple='multiple'>", '</select>'],
          thead: [1, '<table>', '</table>'],
          col: [2, '<table><colgroup>', '</colgroup></table>'],
          tr: [2, '<table><tbody>', '</tbody></table>'],
          td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],
          _default: [0, '', ''],
        };

      function mt(t, e) {
        var n;
        return (
          (n =
            void 0 !== t.getElementsByTagName
              ? t.getElementsByTagName(e || '*')
              : void 0 !== t.querySelectorAll
              ? t.querySelectorAll(e || '*')
              : []),
          void 0 === e || (e && $(t, e)) ? C.merge([t], n) : n
        );
      }

      function vt(t, e) {
        for (var n = 0, i = t.length; n < i; n++)
          J.set(t[n], 'globalEval', !e || J.get(e[n], 'globalEval'));
      }

      (gt.optgroup = gt.option),
        (gt.tbody = gt.tfoot = gt.colgroup = gt.caption = gt.thead),
        (gt.th = gt.td);
      var yt = /<|&#?\w+;/;

      function wt(t, e, n, i, o) {
        for (
          var r,
            s,
            a,
            l,
            c,
            u,
            d = e.createDocumentFragment(),
            h = [],
            f = 0,
            p = t.length;
          f < p;
          f++
        )
          if ((r = t[f]) || 0 === r)
            if ('object' === _(r)) C.merge(h, r.nodeType ? [r] : r);
            else if (yt.test(r)) {
              for (
                s = s || d.appendChild(e.createElement('div')),
                  a = (ft.exec(r) || ['', ''])[1].toLowerCase(),
                  l = gt[a] || gt._default,
                  s.innerHTML = l[1] + C.htmlPrefilter(r) + l[2],
                  u = l[0];
                u--;

              )
                s = s.lastChild;
              C.merge(h, s.childNodes), ((s = d.firstChild).textContent = '');
            } else h.push(e.createTextNode(r));
        for (d.textContent = '', f = 0; (r = h[f++]); )
          if (i && C.inArray(r, i) > -1) o && o.push(r);
          else if (
            ((c = C.contains(r.ownerDocument, r)),
            (s = mt(d.appendChild(r), 'script')),
            c && vt(s),
            n)
          )
            for (u = 0; (r = s[u++]); ) pt.test(r.type || '') && n.push(r);
        return d;
      }

      !(function () {
        var t = s.createDocumentFragment().appendChild(s.createElement('div')),
          e = s.createElement('input');
        e.setAttribute('type', 'radio'),
          e.setAttribute('checked', 'checked'),
          e.setAttribute('name', 't'),
          t.appendChild(e),
          (v.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked),
          (t.innerHTML = '<textarea>x</textarea>'),
          (v.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue);
      })();
      var xt = s.documentElement,
        bt = /^key/,
        _t = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        Ct = /^([^.]*)(?:\.(.+)|)/;

      function Tt() {
        return !0;
      }

      function kt() {
        return !1;
      }

      function Et() {
        try {
          return s.activeElement;
        } catch (t) {}
      }

      function St(t, e, n, i, o, r) {
        var s, a;
        if ('object' == typeof e) {
          for (a in ('string' != typeof n && ((i = i || n), (n = void 0)), e))
            St(t, a, n, i, e[a], r);
          return t;
        }
        if (
          (null == i && null == o
            ? ((o = n), (i = n = void 0))
            : null == o &&
              ('string' == typeof n
                ? ((o = i), (i = void 0))
                : ((o = i), (i = n), (n = void 0))),
          !1 === o)
        )
          o = kt;
        else if (!o) return t;
        return (
          1 === r &&
            ((s = o),
            ((o = function (t) {
              return C().off(t), s.apply(this, arguments);
            }).guid = s.guid || (s.guid = C.guid++))),
          t.each(function () {
            C.event.add(this, e, o, i, n);
          })
        );
      }

      (C.event = {
        global: {},
        add: function (t, e, n, i, o) {
          var r,
            s,
            a,
            l,
            c,
            u,
            d,
            h,
            f,
            p,
            g,
            m = J.get(t);
          if (m)
            for (
              n.handler && ((n = (r = n).handler), (o = r.selector)),
                o && C.find.matchesSelector(xt, o),
                n.guid || (n.guid = C.guid++),
                (l = m.events) || (l = m.events = {}),
                (s = m.handle) ||
                  (s = m.handle =
                    function (e) {
                      return void 0 !== C && C.event.triggered !== e.type
                        ? C.event.dispatch.apply(t, arguments)
                        : void 0;
                    }),
                c = (e = (e || '').match(P) || ['']).length;
              c--;

            )
              (f = g = (a = Ct.exec(e[c]) || [])[1]),
                (p = (a[2] || '').split('.').sort()),
                f &&
                  ((d = C.event.special[f] || {}),
                  (f = (o ? d.delegateType : d.bindType) || f),
                  (d = C.event.special[f] || {}),
                  (u = C.extend(
                    {
                      type: f,
                      origType: g,
                      data: i,
                      handler: n,
                      guid: n.guid,
                      selector: o,
                      needsContext: o && C.expr.match.needsContext.test(o),
                      namespace: p.join('.'),
                    },
                    r
                  )),
                  (h = l[f]) ||
                    (((h = l[f] = []).delegateCount = 0),
                    (d.setup && !1 !== d.setup.call(t, i, p, s)) ||
                      (t.addEventListener && t.addEventListener(f, s))),
                  d.add &&
                    (d.add.call(t, u),
                    u.handler.guid || (u.handler.guid = n.guid)),
                  o ? h.splice(h.delegateCount++, 0, u) : h.push(u),
                  (C.event.global[f] = !0));
        },
        remove: function (t, e, n, i, o) {
          var r,
            s,
            a,
            l,
            c,
            u,
            d,
            h,
            f,
            p,
            g,
            m = J.hasData(t) && J.get(t);
          if (m && (l = m.events)) {
            for (c = (e = (e || '').match(P) || ['']).length; c--; )
              if (
                ((f = g = (a = Ct.exec(e[c]) || [])[1]),
                (p = (a[2] || '').split('.').sort()),
                f)
              ) {
                for (
                  d = C.event.special[f] || {},
                    h = l[(f = (i ? d.delegateType : d.bindType) || f)] || [],
                    a =
                      a[2] &&
                      new RegExp(
                        '(^|\\.)' + p.join('\\.(?:.*\\.|)') + '(\\.|$)'
                      ),
                    s = r = h.length;
                  r--;

                )
                  (u = h[r]),
                    (!o && g !== u.origType) ||
                      (n && n.guid !== u.guid) ||
                      (a && !a.test(u.namespace)) ||
                      (i && i !== u.selector && ('**' !== i || !u.selector)) ||
                      (h.splice(r, 1),
                      u.selector && h.delegateCount--,
                      d.remove && d.remove.call(t, u));
                s &&
                  !h.length &&
                  ((d.teardown && !1 !== d.teardown.call(t, p, m.handle)) ||
                    C.removeEvent(t, f, m.handle),
                  delete l[f]);
              } else for (f in l) C.event.remove(t, f + e[c], n, i, !0);
            C.isEmptyObject(l) && J.remove(t, 'handle events');
          }
        },
        dispatch: function (t) {
          var e,
            n,
            i,
            o,
            r,
            s,
            a = C.event.fix(t),
            l = new Array(arguments.length),
            c = (J.get(this, 'events') || {})[a.type] || [],
            u = C.event.special[a.type] || {};
          for (l[0] = a, e = 1; e < arguments.length; e++) l[e] = arguments[e];
          if (
            ((a.delegateTarget = this),
            !u.preDispatch || !1 !== u.preDispatch.call(this, a))
          ) {
            for (
              s = C.event.handlers.call(this, a, c), e = 0;
              (o = s[e++]) && !a.isPropagationStopped();

            )
              for (
                a.currentTarget = o.elem, n = 0;
                (r = o.handlers[n++]) && !a.isImmediatePropagationStopped();

              )
                (a.rnamespace && !a.rnamespace.test(r.namespace)) ||
                  ((a.handleObj = r),
                  (a.data = r.data),
                  void 0 !==
                    (i = (
                      (C.event.special[r.origType] || {}).handle || r.handler
                    ).apply(o.elem, l)) &&
                    !1 === (a.result = i) &&
                    (a.preventDefault(), a.stopPropagation()));
            return u.postDispatch && u.postDispatch.call(this, a), a.result;
          }
        },
        handlers: function (t, e) {
          var n,
            i,
            o,
            r,
            s,
            a = [],
            l = e.delegateCount,
            c = t.target;
          if (l && c.nodeType && !('click' === t.type && t.button >= 1))
            for (; c !== this; c = c.parentNode || this)
              if (
                1 === c.nodeType &&
                ('click' !== t.type || !0 !== c.disabled)
              ) {
                for (r = [], s = {}, n = 0; n < l; n++)
                  void 0 === s[(o = (i = e[n]).selector + ' ')] &&
                    (s[o] = i.needsContext
                      ? C(o, this).index(c) > -1
                      : C.find(o, this, null, [c]).length),
                    s[o] && r.push(i);
                r.length && a.push({ elem: c, handlers: r });
              }
          return (
            (c = this),
            l < e.length && a.push({ elem: c, handlers: e.slice(l) }),
            a
          );
        },
        addProp: function (t, e) {
          Object.defineProperty(C.Event.prototype, t, {
            enumerable: !0,
            configurable: !0,
            get: y(e)
              ? function () {
                  if (this.originalEvent) return e(this.originalEvent);
                }
              : function () {
                  if (this.originalEvent) return this.originalEvent[t];
                },
            set: function (e) {
              Object.defineProperty(this, t, {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: e,
              });
            },
          });
        },
        fix: function (t) {
          return t[C.expando] ? t : new C.Event(t);
        },
        special: {
          load: { noBubble: !0 },
          focus: {
            trigger: function () {
              if (this !== Et() && this.focus) return this.focus(), !1;
            },
            delegateType: 'focusin',
          },
          blur: {
            trigger: function () {
              if (this === Et() && this.blur) return this.blur(), !1;
            },
            delegateType: 'focusout',
          },
          click: {
            trigger: function () {
              if ('checkbox' === this.type && this.click && $(this, 'input'))
                return this.click(), !1;
            },
            _default: function (t) {
              return $(t.target, 'a');
            },
          },
          beforeunload: {
            postDispatch: function (t) {
              void 0 !== t.result &&
                t.originalEvent &&
                (t.originalEvent.returnValue = t.result);
            },
          },
        },
      }),
        (C.removeEvent = function (t, e, n) {
          t.removeEventListener && t.removeEventListener(e, n);
        }),
        (C.Event = function (t, e) {
          if (!(this instanceof C.Event)) return new C.Event(t, e);
          t && t.type
            ? ((this.originalEvent = t),
              (this.type = t.type),
              (this.isDefaultPrevented =
                t.defaultPrevented ||
                (void 0 === t.defaultPrevented && !1 === t.returnValue)
                  ? Tt
                  : kt),
              (this.target =
                t.target && 3 === t.target.nodeType
                  ? t.target.parentNode
                  : t.target),
              (this.currentTarget = t.currentTarget),
              (this.relatedTarget = t.relatedTarget))
            : (this.type = t),
            e && C.extend(this, e),
            (this.timeStamp = (t && t.timeStamp) || Date.now()),
            (this[C.expando] = !0);
        }),
        (C.Event.prototype = {
          constructor: C.Event,
          isDefaultPrevented: kt,
          isPropagationStopped: kt,
          isImmediatePropagationStopped: kt,
          isSimulated: !1,
          preventDefault: function () {
            var t = this.originalEvent;
            (this.isDefaultPrevented = Tt),
              t && !this.isSimulated && t.preventDefault();
          },
          stopPropagation: function () {
            var t = this.originalEvent;
            (this.isPropagationStopped = Tt),
              t && !this.isSimulated && t.stopPropagation();
          },
          stopImmediatePropagation: function () {
            var t = this.originalEvent;
            (this.isImmediatePropagationStopped = Tt),
              t && !this.isSimulated && t.stopImmediatePropagation(),
              this.stopPropagation();
          },
        }),
        C.each(
          {
            altKey: !0,
            bubbles: !0,
            cancelable: !0,
            changedTouches: !0,
            ctrlKey: !0,
            detail: !0,
            eventPhase: !0,
            metaKey: !0,
            pageX: !0,
            pageY: !0,
            shiftKey: !0,
            view: !0,
            char: !0,
            charCode: !0,
            key: !0,
            keyCode: !0,
            button: !0,
            buttons: !0,
            clientX: !0,
            clientY: !0,
            offsetX: !0,
            offsetY: !0,
            pointerId: !0,
            pointerType: !0,
            screenX: !0,
            screenY: !0,
            targetTouches: !0,
            toElement: !0,
            touches: !0,
            which: function (t) {
              var e = t.button;
              return null == t.which && bt.test(t.type)
                ? null != t.charCode
                  ? t.charCode
                  : t.keyCode
                : !t.which && void 0 !== e && _t.test(t.type)
                ? 1 & e
                  ? 1
                  : 2 & e
                  ? 3
                  : 4 & e
                  ? 2
                  : 0
                : t.which;
            },
          },
          C.event.addProp
        ),
        C.each(
          {
            mouseenter: 'mouseover',
            mouseleave: 'mouseout',
            pointerenter: 'pointerover',
            pointerleave: 'pointerout',
          },
          function (t, e) {
            C.event.special[t] = {
              delegateType: e,
              bindType: e,
              handle: function (t) {
                var n,
                  i = t.relatedTarget,
                  o = t.handleObj;
                return (
                  (i && (i === this || C.contains(this, i))) ||
                    ((t.type = o.origType),
                    (n = o.handler.apply(this, arguments)),
                    (t.type = e)),
                  n
                );
              },
            };
          }
        ),
        C.fn.extend({
          on: function (t, e, n, i) {
            return St(this, t, e, n, i);
          },
          one: function (t, e, n, i) {
            return St(this, t, e, n, i, 1);
          },
          off: function (t, e, n) {
            var i, o;
            if (t && t.preventDefault && t.handleObj)
              return (
                (i = t.handleObj),
                C(t.delegateTarget).off(
                  i.namespace ? i.origType + '.' + i.namespace : i.origType,
                  i.selector,
                  i.handler
                ),
                this
              );
            if ('object' == typeof t) {
              for (o in t) this.off(o, e, t[o]);
              return this;
            }
            return (
              (!1 !== e && 'function' != typeof e) || ((n = e), (e = void 0)),
              !1 === n && (n = kt),
              this.each(function () {
                C.event.remove(this, t, n, e);
              })
            );
          },
        });
      var jt =
          /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
        At = /<script|<style|<link/i,
        $t = /checked\s*(?:[^=]|=\s*.checked.)/i,
        Dt = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

      function Ot(t, e) {
        return (
          ($(t, 'table') &&
            $(11 !== e.nodeType ? e : e.firstChild, 'tr') &&
            C(t).children('tbody')[0]) ||
          t
        );
      }

      function Nt(t) {
        return (t.type = (null !== t.getAttribute('type')) + '/' + t.type), t;
      }

      function zt(t) {
        return (
          'true/' === (t.type || '').slice(0, 5)
            ? (t.type = t.type.slice(5))
            : t.removeAttribute('type'),
          t
        );
      }

      function qt(t, e) {
        var n, i, o, r, s, a, l, c;
        if (1 === e.nodeType) {
          if (
            J.hasData(t) &&
            ((r = J.access(t)), (s = J.set(e, r)), (c = r.events))
          )
            for (o in (delete s.handle, (s.events = {}), c))
              for (n = 0, i = c[o].length; n < i; n++)
                C.event.add(e, o, c[o][n]);
          K.hasData(t) &&
            ((a = K.access(t)), (l = C.extend({}, a)), K.set(e, l));
        }
      }

      function Lt(t, e) {
        var n = e.nodeName.toLowerCase();
        'input' === n && ht.test(t.type)
          ? (e.checked = t.checked)
          : ('input' !== n && 'textarea' !== n) ||
            (e.defaultValue = t.defaultValue);
      }

      function Mt(t, e, n, i) {
        e = c.apply([], e);
        var o,
          r,
          s,
          a,
          l,
          u,
          d = 0,
          h = t.length,
          f = h - 1,
          p = e[0],
          g = y(p);
        if (g || (h > 1 && 'string' == typeof p && !v.checkClone && $t.test(p)))
          return t.each(function (o) {
            var r = t.eq(o);
            g && (e[0] = p.call(this, o, r.html())), Mt(r, e, n, i);
          });
        if (
          h &&
          ((r = (o = wt(e, t[0].ownerDocument, !1, t, i)).firstChild),
          1 === o.childNodes.length && (o = r),
          r || i)
        ) {
          for (a = (s = C.map(mt(o, 'script'), Nt)).length; d < h; d++)
            (l = o),
              d !== f &&
                ((l = C.clone(l, !0, !0)), a && C.merge(s, mt(l, 'script'))),
              n.call(t[d], l, d);
          if (a)
            for (
              u = s[s.length - 1].ownerDocument, C.map(s, zt), d = 0;
              d < a;
              d++
            )
              (l = s[d]),
                pt.test(l.type || '') &&
                  !J.access(l, 'globalEval') &&
                  C.contains(u, l) &&
                  (l.src && 'module' !== (l.type || '').toLowerCase()
                    ? C._evalUrl && C._evalUrl(l.src)
                    : b(l.textContent.replace(Dt, ''), u, l));
        }
        return t;
      }

      function Pt(t, e, n) {
        for (var i, o = e ? C.filter(e, t) : t, r = 0; null != (i = o[r]); r++)
          n || 1 !== i.nodeType || C.cleanData(mt(i)),
            i.parentNode &&
              (n && C.contains(i.ownerDocument, i) && vt(mt(i, 'script')),
              i.parentNode.removeChild(i));
        return t;
      }

      C.extend({
        htmlPrefilter: function (t) {
          return t.replace(jt, '<$1></$2>');
        },
        clone: function (t, e, n) {
          var i,
            o,
            r,
            s,
            a = t.cloneNode(!0),
            l = C.contains(t.ownerDocument, t);
          if (
            !(
              v.noCloneChecked ||
              (1 !== t.nodeType && 11 !== t.nodeType) ||
              C.isXMLDoc(t)
            )
          )
            for (s = mt(a), i = 0, o = (r = mt(t)).length; i < o; i++)
              Lt(r[i], s[i]);
          if (e)
            if (n)
              for (
                r = r || mt(t), s = s || mt(a), i = 0, o = r.length;
                i < o;
                i++
              )
                qt(r[i], s[i]);
            else qt(t, a);
          return (
            (s = mt(a, 'script')).length > 0 && vt(s, !l && mt(t, 'script')), a
          );
        },
        cleanData: function (t) {
          for (
            var e, n, i, o = C.event.special, r = 0;
            void 0 !== (n = t[r]);
            r++
          )
            if (Y(n)) {
              if ((e = n[J.expando])) {
                if (e.events)
                  for (i in e.events)
                    o[i] ? C.event.remove(n, i) : C.removeEvent(n, i, e.handle);
                n[J.expando] = void 0;
              }
              n[K.expando] && (n[K.expando] = void 0);
            }
        },
      }),
        C.fn.extend({
          detach: function (t) {
            return Pt(this, t, !0);
          },
          remove: function (t) {
            return Pt(this, t);
          },
          text: function (t) {
            return Q(
              this,
              function (t) {
                return void 0 === t
                  ? C.text(this)
                  : this.empty().each(function () {
                      (1 !== this.nodeType &&
                        11 !== this.nodeType &&
                        9 !== this.nodeType) ||
                        (this.textContent = t);
                    });
              },
              null,
              t,
              arguments.length
            );
          },
          append: function () {
            return Mt(this, arguments, function (t) {
              (1 !== this.nodeType &&
                11 !== this.nodeType &&
                9 !== this.nodeType) ||
                Ot(this, t).appendChild(t);
            });
          },
          prepend: function () {
            return Mt(this, arguments, function (t) {
              if (
                1 === this.nodeType ||
                11 === this.nodeType ||
                9 === this.nodeType
              ) {
                var e = Ot(this, t);
                e.insertBefore(t, e.firstChild);
              }
            });
          },
          before: function () {
            return Mt(this, arguments, function (t) {
              this.parentNode && this.parentNode.insertBefore(t, this);
            });
          },
          after: function () {
            return Mt(this, arguments, function (t) {
              this.parentNode &&
                this.parentNode.insertBefore(t, this.nextSibling);
            });
          },
          empty: function () {
            for (var t, e = 0; null != (t = this[e]); e++)
              1 === t.nodeType &&
                (C.cleanData(mt(t, !1)), (t.textContent = ''));
            return this;
          },
          clone: function (t, e) {
            return (
              (t = null != t && t),
              (e = null == e ? t : e),
              this.map(function () {
                return C.clone(this, t, e);
              })
            );
          },
          html: function (t) {
            return Q(
              this,
              function (t) {
                var e = this[0] || {},
                  n = 0,
                  i = this.length;
                if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
                if (
                  'string' == typeof t &&
                  !At.test(t) &&
                  !gt[(ft.exec(t) || ['', ''])[1].toLowerCase()]
                ) {
                  t = C.htmlPrefilter(t);
                  try {
                    for (; n < i; n++)
                      1 === (e = this[n] || {}).nodeType &&
                        (C.cleanData(mt(e, !1)), (e.innerHTML = t));
                    e = 0;
                  } catch (t) {}
                }
                e && this.empty().append(t);
              },
              null,
              t,
              arguments.length
            );
          },
          replaceWith: function () {
            var t = [];
            return Mt(
              this,
              arguments,
              function (e) {
                var n = this.parentNode;
                C.inArray(this, t) < 0 &&
                  (C.cleanData(mt(this)), n && n.replaceChild(e, this));
              },
              t
            );
          },
        }),
        C.each(
          {
            appendTo: 'append',
            prependTo: 'prepend',
            insertBefore: 'before',
            insertAfter: 'after',
            replaceAll: 'replaceWith',
          },
          function (t, e) {
            C.fn[t] = function (t) {
              for (
                var n, i = [], o = C(t), r = o.length - 1, s = 0;
                s <= r;
                s++
              )
                (n = s === r ? this : this.clone(!0)),
                  C(o[s])[e](n),
                  u.apply(i, n.get());
              return this.pushStack(i);
            };
          }
        );
      var Ht = new RegExp('^(' + it + ')(?!px)[a-z%]+$', 'i'),
        It = function (t) {
          var e = t.ownerDocument.defaultView;
          return (e && e.opener) || (e = n), e.getComputedStyle(t);
        },
        Rt = new RegExp(rt.join('|'), 'i');

      function Wt(t, e, n) {
        var i,
          o,
          r,
          s,
          a = t.style;
        return (
          (n = n || It(t)) &&
            ('' !== (s = n.getPropertyValue(e) || n[e]) ||
              C.contains(t.ownerDocument, t) ||
              (s = C.style(t, e)),
            !v.pixelBoxStyles() &&
              Ht.test(s) &&
              Rt.test(e) &&
              ((i = a.width),
              (o = a.minWidth),
              (r = a.maxWidth),
              (a.minWidth = a.maxWidth = a.width = s),
              (s = n.width),
              (a.width = i),
              (a.minWidth = o),
              (a.maxWidth = r))),
          void 0 !== s ? s + '' : s
        );
      }

      function Bt(t, e) {
        return {
          get: function () {
            if (!t()) return (this.get = e).apply(this, arguments);
            delete this.get;
          },
        };
      }

      !(function () {
        function t() {
          if (u) {
            (c.style.cssText =
              'position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0'),
              (u.style.cssText =
                'position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%'),
              xt.appendChild(c).appendChild(u);
            var t = n.getComputedStyle(u);
            (i = '1%' !== t.top),
              (l = 12 === e(t.marginLeft)),
              (u.style.right = '60%'),
              (a = 36 === e(t.right)),
              (o = 36 === e(t.width)),
              (u.style.position = 'absolute'),
              (r = 36 === u.offsetWidth || 'absolute'),
              xt.removeChild(c),
              (u = null);
          }
        }

        function e(t) {
          return Math.round(parseFloat(t));
        }

        var i,
          o,
          r,
          a,
          l,
          c = s.createElement('div'),
          u = s.createElement('div');
        u.style &&
          ((u.style.backgroundClip = 'content-box'),
          (u.cloneNode(!0).style.backgroundClip = ''),
          (v.clearCloneStyle = 'content-box' === u.style.backgroundClip),
          C.extend(v, {
            boxSizingReliable: function () {
              return t(), o;
            },
            pixelBoxStyles: function () {
              return t(), a;
            },
            pixelPosition: function () {
              return t(), i;
            },
            reliableMarginLeft: function () {
              return t(), l;
            },
            scrollboxSize: function () {
              return t(), r;
            },
          }));
      })();
      var Ft = /^(none|table(?!-c[ea]).+)/,
        Qt = /^--/,
        Xt = { position: 'absolute', visibility: 'hidden', display: 'block' },
        Vt = { letterSpacing: '0', fontWeight: '400' },
        Gt = ['Webkit', 'Moz', 'ms'],
        Ut = s.createElement('div').style;

      function Yt(t) {
        var e = C.cssProps[t];
        return (
          e ||
            (e = C.cssProps[t] =
              (function (t) {
                if (t in Ut) return t;
                for (
                  var e = t[0].toUpperCase() + t.slice(1), n = Gt.length;
                  n--;

                )
                  if ((t = Gt[n] + e) in Ut) return t;
              })(t) || t),
          e
        );
      }

      function Zt(t, e, n) {
        var i = ot.exec(e);
        return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || 'px') : e;
      }

      function Jt(t, e, n, i, o, r) {
        var s = 'width' === e ? 1 : 0,
          a = 0,
          l = 0;
        if (n === (i ? 'border' : 'content')) return 0;
        for (; s < 4; s += 2)
          'margin' === n && (l += C.css(t, n + rt[s], !0, o)),
            i
              ? ('content' === n && (l -= C.css(t, 'padding' + rt[s], !0, o)),
                'margin' !== n &&
                  (l -= C.css(t, 'border' + rt[s] + 'Width', !0, o)))
              : ((l += C.css(t, 'padding' + rt[s], !0, o)),
                'padding' !== n
                  ? (l += C.css(t, 'border' + rt[s] + 'Width', !0, o))
                  : (a += C.css(t, 'border' + rt[s] + 'Width', !0, o)));
        return (
          !i &&
            r >= 0 &&
            (l += Math.max(
              0,
              Math.ceil(
                t['offset' + e[0].toUpperCase() + e.slice(1)] - r - l - a - 0.5
              )
            )),
          l
        );
      }

      function Kt(t, e, n) {
        var i = It(t),
          o = Wt(t, e, i),
          r = 'border-box' === C.css(t, 'boxSizing', !1, i),
          s = r;
        if (Ht.test(o)) {
          if (!n) return o;
          o = 'auto';
        }
        return (
          (s = s && (v.boxSizingReliable() || o === t.style[e])),
          ('auto' === o ||
            (!parseFloat(o) && 'inline' === C.css(t, 'display', !1, i))) &&
            ((o = t['offset' + e[0].toUpperCase() + e.slice(1)]), (s = !0)),
          (o = parseFloat(o) || 0) +
            Jt(t, e, n || (r ? 'border' : 'content'), s, i, o) +
            'px'
        );
      }

      function te(t, e, n, i, o) {
        return new te.prototype.init(t, e, n, i, o);
      }

      C.extend({
        cssHooks: {
          opacity: {
            get: function (t, e) {
              if (e) {
                var n = Wt(t, 'opacity');
                return '' === n ? '1' : n;
              }
            },
          },
        },
        cssNumber: {
          animationIterationCount: !0,
          columnCount: !0,
          fillOpacity: !0,
          flexGrow: !0,
          flexShrink: !0,
          fontWeight: !0,
          lineHeight: !0,
          opacity: !0,
          order: !0,
          orphans: !0,
          widows: !0,
          zIndex: !0,
          zoom: !0,
        },
        cssProps: {},
        style: function (t, e, n, i) {
          if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
            var o,
              r,
              s,
              a = U(e),
              l = Qt.test(e),
              c = t.style;
            if (
              (l || (e = Yt(a)),
              (s = C.cssHooks[e] || C.cssHooks[a]),
              void 0 === n)
            )
              return s && 'get' in s && void 0 !== (o = s.get(t, !1, i))
                ? o
                : c[e];
            'string' === (r = typeof n) &&
              (o = ot.exec(n)) &&
              o[1] &&
              ((n = lt(t, e, o)), (r = 'number')),
              null != n &&
                n == n &&
                ('number' === r &&
                  (n += (o && o[3]) || (C.cssNumber[a] ? '' : 'px')),
                v.clearCloneStyle ||
                  '' !== n ||
                  0 !== e.indexOf('background') ||
                  (c[e] = 'inherit'),
                (s && 'set' in s && void 0 === (n = s.set(t, n, i))) ||
                  (l ? c.setProperty(e, n) : (c[e] = n)));
          }
        },
        css: function (t, e, n, i) {
          var o,
            r,
            s,
            a = U(e);
          return (
            Qt.test(e) || (e = Yt(a)),
            (s = C.cssHooks[e] || C.cssHooks[a]) &&
              'get' in s &&
              (o = s.get(t, !0, n)),
            void 0 === o && (o = Wt(t, e, i)),
            'normal' === o && e in Vt && (o = Vt[e]),
            '' === n || n
              ? ((r = parseFloat(o)), !0 === n || isFinite(r) ? r || 0 : o)
              : o
          );
        },
      }),
        C.each(['height', 'width'], function (t, e) {
          C.cssHooks[e] = {
            get: function (t, n, i) {
              if (n)
                return !Ft.test(C.css(t, 'display')) ||
                  (t.getClientRects().length && t.getBoundingClientRect().width)
                  ? Kt(t, e, i)
                  : at(t, Xt, function () {
                      return Kt(t, e, i);
                    });
            },
            set: function (t, n, i) {
              var o,
                r = It(t),
                s = 'border-box' === C.css(t, 'boxSizing', !1, r),
                a = i && Jt(t, e, i, s, r);
              return (
                s &&
                  v.scrollboxSize() === r.position &&
                  (a -= Math.ceil(
                    t['offset' + e[0].toUpperCase() + e.slice(1)] -
                      parseFloat(r[e]) -
                      Jt(t, e, 'border', !1, r) -
                      0.5
                  )),
                a &&
                  (o = ot.exec(n)) &&
                  'px' !== (o[3] || 'px') &&
                  ((t.style[e] = n), (n = C.css(t, e))),
                Zt(0, n, a)
              );
            },
          };
        }),
        (C.cssHooks.marginLeft = Bt(v.reliableMarginLeft, function (t, e) {
          if (e)
            return (
              (parseFloat(Wt(t, 'marginLeft')) ||
                t.getBoundingClientRect().left -
                  at(t, { marginLeft: 0 }, function () {
                    return t.getBoundingClientRect().left;
                  })) + 'px'
            );
        })),
        C.each({ margin: '', padding: '', border: 'Width' }, function (t, e) {
          (C.cssHooks[t + e] = {
            expand: function (n) {
              for (
                var i = 0,
                  o = {},
                  r = 'string' == typeof n ? n.split(' ') : [n];
                i < 4;
                i++
              )
                o[t + rt[i] + e] = r[i] || r[i - 2] || r[0];
              return o;
            },
          }),
            'margin' !== t && (C.cssHooks[t + e].set = Zt);
        }),
        C.fn.extend({
          css: function (t, e) {
            return Q(
              this,
              function (t, e, n) {
                var i,
                  o,
                  r = {},
                  s = 0;
                if (Array.isArray(e)) {
                  for (i = It(t), o = e.length; s < o; s++)
                    r[e[s]] = C.css(t, e[s], !1, i);
                  return r;
                }
                return void 0 !== n ? C.style(t, e, n) : C.css(t, e);
              },
              t,
              e,
              arguments.length > 1
            );
          },
        }),
        (C.Tween = te),
        (te.prototype = {
          constructor: te,
          init: function (t, e, n, i, o, r) {
            (this.elem = t),
              (this.prop = n),
              (this.easing = o || C.easing._default),
              (this.options = e),
              (this.start = this.now = this.cur()),
              (this.end = i),
              (this.unit = r || (C.cssNumber[n] ? '' : 'px'));
          },
          cur: function () {
            var t = te.propHooks[this.prop];
            return t && t.get ? t.get(this) : te.propHooks._default.get(this);
          },
          run: function (t) {
            var e,
              n = te.propHooks[this.prop];
            return (
              this.options.duration
                ? (this.pos = e =
                    C.easing[this.easing](
                      t,
                      this.options.duration * t,
                      0,
                      1,
                      this.options.duration
                    ))
                : (this.pos = e = t),
              (this.now = (this.end - this.start) * e + this.start),
              this.options.step &&
                this.options.step.call(this.elem, this.now, this),
              n && n.set ? n.set(this) : te.propHooks._default.set(this),
              this
            );
          },
        }),
        (te.prototype.init.prototype = te.prototype),
        (te.propHooks = {
          _default: {
            get: function (t) {
              var e;
              return 1 !== t.elem.nodeType ||
                (null != t.elem[t.prop] && null == t.elem.style[t.prop])
                ? t.elem[t.prop]
                : (e = C.css(t.elem, t.prop, '')) && 'auto' !== e
                ? e
                : 0;
            },
            set: function (t) {
              C.fx.step[t.prop]
                ? C.fx.step[t.prop](t)
                : 1 !== t.elem.nodeType ||
                  (null == t.elem.style[C.cssProps[t.prop]] &&
                    !C.cssHooks[t.prop])
                ? (t.elem[t.prop] = t.now)
                : C.style(t.elem, t.prop, t.now + t.unit);
            },
          },
        }),
        (te.propHooks.scrollTop = te.propHooks.scrollLeft =
          {
            set: function (t) {
              t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now);
            },
          }),
        (C.easing = {
          linear: function (t) {
            return t;
          },
          swing: function (t) {
            return 0.5 - Math.cos(t * Math.PI) / 2;
          },
          _default: 'swing',
        }),
        (C.fx = te.prototype.init),
        (C.fx.step = {});
      var ee,
        ne,
        ie = /^(?:toggle|show|hide)$/,
        oe = /queueHooks$/;

      function re() {
        ne &&
          (!1 === s.hidden && n.requestAnimationFrame
            ? n.requestAnimationFrame(re)
            : n.setTimeout(re, C.fx.interval),
          C.fx.tick());
      }

      function se() {
        return (
          n.setTimeout(function () {
            ee = void 0;
          }),
          (ee = Date.now())
        );
      }

      function ae(t, e) {
        var n,
          i = 0,
          o = { height: t };
        for (e = e ? 1 : 0; i < 4; i += 2 - e)
          o['margin' + (n = rt[i])] = o['padding' + n] = t;
        return e && (o.opacity = o.width = t), o;
      }

      function le(t, e, n) {
        for (
          var i,
            o = (ce.tweeners[e] || []).concat(ce.tweeners['*']),
            r = 0,
            s = o.length;
          r < s;
          r++
        )
          if ((i = o[r].call(n, e, t))) return i;
      }

      function ce(t, e, n) {
        var i,
          o,
          r = 0,
          s = ce.prefilters.length,
          a = C.Deferred().always(function () {
            delete l.elem;
          }),
          l = function () {
            if (o) return !1;
            for (
              var e = ee || se(),
                n = Math.max(0, c.startTime + c.duration - e),
                i = 1 - (n / c.duration || 0),
                r = 0,
                s = c.tweens.length;
              r < s;
              r++
            )
              c.tweens[r].run(i);
            return (
              a.notifyWith(t, [c, i, n]),
              i < 1 && s
                ? n
                : (s || a.notifyWith(t, [c, 1, 0]), a.resolveWith(t, [c]), !1)
            );
          },
          c = a.promise({
            elem: t,
            props: C.extend({}, e),
            opts: C.extend(
              !0,
              { specialEasing: {}, easing: C.easing._default },
              n
            ),
            originalProperties: e,
            originalOptions: n,
            startTime: ee || se(),
            duration: n.duration,
            tweens: [],
            createTween: function (e, n) {
              var i = C.Tween(
                t,
                c.opts,
                e,
                n,
                c.opts.specialEasing[e] || c.opts.easing
              );
              return c.tweens.push(i), i;
            },
            stop: function (e) {
              var n = 0,
                i = e ? c.tweens.length : 0;
              if (o) return this;
              for (o = !0; n < i; n++) c.tweens[n].run(1);
              return (
                e
                  ? (a.notifyWith(t, [c, 1, 0]), a.resolveWith(t, [c, e]))
                  : a.rejectWith(t, [c, e]),
                this
              );
            },
          }),
          u = c.props;
        for (
          !(function (t, e) {
            var n, i, o, r, s;
            for (n in t)
              if (
                ((o = e[(i = U(n))]),
                (r = t[n]),
                Array.isArray(r) && ((o = r[1]), (r = t[n] = r[0])),
                n !== i && ((t[i] = r), delete t[n]),
                (s = C.cssHooks[i]) && ('expand' in s))
              )
                for (n in ((r = s.expand(r)), delete t[i], r))
                  (n in t) || ((t[n] = r[n]), (e[n] = o));
              else e[i] = o;
          })(u, c.opts.specialEasing);
          r < s;
          r++
        )
          if ((i = ce.prefilters[r].call(c, t, u, c.opts)))
            return (
              y(i.stop) &&
                (C._queueHooks(c.elem, c.opts.queue).stop = i.stop.bind(i)),
              i
            );
        return (
          C.map(u, le, c),
          y(c.opts.start) && c.opts.start.call(t, c),
          c
            .progress(c.opts.progress)
            .done(c.opts.done, c.opts.complete)
            .fail(c.opts.fail)
            .always(c.opts.always),
          C.fx.timer(
            C.extend(l, {
              elem: t,
              anim: c,
              queue: c.opts.queue,
            })
          ),
          c
        );
      }

      (C.Animation = C.extend(ce, {
        tweeners: {
          '*': [
            function (t, e) {
              var n = this.createTween(t, e);
              return lt(n.elem, t, ot.exec(e), n), n;
            },
          ],
        },
        tweener: function (t, e) {
          y(t) ? ((e = t), (t = ['*'])) : (t = t.match(P));
          for (var n, i = 0, o = t.length; i < o; i++)
            (n = t[i]),
              (ce.tweeners[n] = ce.tweeners[n] || []),
              ce.tweeners[n].unshift(e);
        },
        prefilters: [
          function (t, e, n) {
            var i,
              o,
              r,
              s,
              a,
              l,
              c,
              u,
              d = 'width' in e || 'height' in e,
              h = this,
              f = {},
              p = t.style,
              g = t.nodeType && st(t),
              m = J.get(t, 'fxshow');
            for (i in (n.queue ||
              (null == (s = C._queueHooks(t, 'fx')).unqueued &&
                ((s.unqueued = 0),
                (a = s.empty.fire),
                (s.empty.fire = function () {
                  s.unqueued || a();
                })),
              s.unqueued++,
              h.always(function () {
                h.always(function () {
                  s.unqueued--, C.queue(t, 'fx').length || s.empty.fire();
                });
              })),
            e))
              if (((o = e[i]), ie.test(o))) {
                if (
                  (delete e[i],
                  (r = r || 'toggle' === o),
                  o === (g ? 'hide' : 'show'))
                ) {
                  if ('show' !== o || !m || void 0 === m[i]) continue;
                  g = !0;
                }
                f[i] = (m && m[i]) || C.style(t, i);
              }
            if ((l = !C.isEmptyObject(e)) || !C.isEmptyObject(f))
              for (i in (d &&
                1 === t.nodeType &&
                ((n.overflow = [p.overflow, p.overflowX, p.overflowY]),
                null == (c = m && m.display) && (c = J.get(t, 'display')),
                'none' === (u = C.css(t, 'display')) &&
                  (c
                    ? (u = c)
                    : (dt([t], !0),
                      (c = t.style.display || c),
                      (u = C.css(t, 'display')),
                      dt([t]))),
                ('inline' === u || ('inline-block' === u && null != c)) &&
                  'none' === C.css(t, 'float') &&
                  (l ||
                    (h.done(function () {
                      p.display = c;
                    }),
                    null == c &&
                      ((u = p.display), (c = 'none' === u ? '' : u))),
                  (p.display = 'inline-block'))),
              n.overflow &&
                ((p.overflow = 'hidden'),
                h.always(function () {
                  (p.overflow = n.overflow[0]),
                    (p.overflowX = n.overflow[1]),
                    (p.overflowY = n.overflow[2]);
                })),
              (l = !1),
              f))
                l ||
                  (m
                    ? 'hidden' in m && (g = m.hidden)
                    : (m = J.access(t, 'fxshow', { display: c })),
                  r && (m.hidden = !g),
                  g && dt([t], !0),
                  h.done(function () {
                    for (i in (g || dt([t]), J.remove(t, 'fxshow'), f))
                      C.style(t, i, f[i]);
                  })),
                  (l = le(g ? m[i] : 0, i, h)),
                  i in m ||
                    ((m[i] = l.start), g && ((l.end = l.start), (l.start = 0)));
          },
        ],
        prefilter: function (t, e) {
          e ? ce.prefilters.unshift(t) : ce.prefilters.push(t);
        },
      })),
        (C.speed = function (t, e, n) {
          var i =
            t && 'object' == typeof t
              ? C.extend({}, t)
              : {
                  complete: n || (!n && e) || (y(t) && t),
                  duration: t,
                  easing: (n && e) || (e && !y(e) && e),
                };
          return (
            C.fx.off
              ? (i.duration = 0)
              : 'number' != typeof i.duration &&
                (i.duration in C.fx.speeds
                  ? (i.duration = C.fx.speeds[i.duration])
                  : (i.duration = C.fx.speeds._default)),
            (null != i.queue && !0 !== i.queue) || (i.queue = 'fx'),
            (i.old = i.complete),
            (i.complete = function () {
              y(i.old) && i.old.call(this), i.queue && C.dequeue(this, i.queue);
            }),
            i
          );
        }),
        C.fn.extend({
          fadeTo: function (t, e, n, i) {
            return this.filter(st)
              .css('opacity', 0)
              .show()
              .end()
              .animate({ opacity: e }, t, n, i);
          },
          animate: function (t, e, n, i) {
            var o = C.isEmptyObject(t),
              r = C.speed(e, n, i),
              s = function () {
                var e = ce(this, C.extend({}, t), r);
                (o || J.get(this, 'finish')) && e.stop(!0);
              };
            return (
              (s.finish = s),
              o || !1 === r.queue ? this.each(s) : this.queue(r.queue, s)
            );
          },
          stop: function (t, e, n) {
            var i = function (t) {
              var e = t.stop;
              delete t.stop, e(n);
            };
            return (
              'string' != typeof t && ((n = e), (e = t), (t = void 0)),
              e && !1 !== t && this.queue(t || 'fx', []),
              this.each(function () {
                var e = !0,
                  o = null != t && t + 'queueHooks',
                  r = C.timers,
                  s = J.get(this);
                if (o) s[o] && s[o].stop && i(s[o]);
                else for (o in s) s[o] && s[o].stop && oe.test(o) && i(s[o]);
                for (o = r.length; o--; )
                  r[o].elem !== this ||
                    (null != t && r[o].queue !== t) ||
                    (r[o].anim.stop(n), (e = !1), r.splice(o, 1));
                (!e && n) || C.dequeue(this, t);
              })
            );
          },
          finish: function (t) {
            return (
              !1 !== t && (t = t || 'fx'),
              this.each(function () {
                var e,
                  n = J.get(this),
                  i = n[t + 'queue'],
                  o = n[t + 'queueHooks'],
                  r = C.timers,
                  s = i ? i.length : 0;
                for (
                  n.finish = !0,
                    C.queue(this, t, []),
                    o && o.stop && o.stop.call(this, !0),
                    e = r.length;
                  e--;

                )
                  r[e].elem === this &&
                    r[e].queue === t &&
                    (r[e].anim.stop(!0), r.splice(e, 1));
                for (e = 0; e < s; e++)
                  i[e] && i[e].finish && i[e].finish.call(this);
                delete n.finish;
              })
            );
          },
        }),
        C.each(['toggle', 'show', 'hide'], function (t, e) {
          var n = C.fn[e];
          C.fn[e] = function (t, i, o) {
            return null == t || 'boolean' == typeof t
              ? n.apply(this, arguments)
              : this.animate(ae(e, !0), t, i, o);
          };
        }),
        C.each(
          {
            slideDown: ae('show'),
            slideUp: ae('hide'),
            slideToggle: ae('toggle'),
            fadeIn: { opacity: 'show' },
            fadeOut: { opacity: 'hide' },
            fadeToggle: { opacity: 'toggle' },
          },
          function (t, e) {
            C.fn[t] = function (t, n, i) {
              return this.animate(e, t, n, i);
            };
          }
        ),
        (C.timers = []),
        (C.fx.tick = function () {
          var t,
            e = 0,
            n = C.timers;
          for (ee = Date.now(); e < n.length; e++)
            (t = n[e])() || n[e] !== t || n.splice(e--, 1);
          n.length || C.fx.stop(), (ee = void 0);
        }),
        (C.fx.timer = function (t) {
          C.timers.push(t), C.fx.start();
        }),
        (C.fx.interval = 13),
        (C.fx.start = function () {
          ne || ((ne = !0), re());
        }),
        (C.fx.stop = function () {
          ne = null;
        }),
        (C.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
        (C.fn.delay = function (t, e) {
          return (
            (t = (C.fx && C.fx.speeds[t]) || t),
            (e = e || 'fx'),
            this.queue(e, function (e, i) {
              var o = n.setTimeout(e, t);
              i.stop = function () {
                n.clearTimeout(o);
              };
            })
          );
        }),
        (function () {
          var t = s.createElement('input'),
            e = s
              .createElement('select')
              .appendChild(s.createElement('option'));
          (t.type = 'checkbox'),
            (v.checkOn = '' !== t.value),
            (v.optSelected = e.selected),
            ((t = s.createElement('input')).value = 't'),
            (t.type = 'radio'),
            (v.radioValue = 't' === t.value);
        })();
      var ue,
        de = C.expr.attrHandle;
      C.fn.extend({
        attr: function (t, e) {
          return Q(this, C.attr, t, e, arguments.length > 1);
        },
        removeAttr: function (t) {
          return this.each(function () {
            C.removeAttr(this, t);
          });
        },
      }),
        C.extend({
          attr: function (t, e, n) {
            var i,
              o,
              r = t.nodeType;
            if (3 !== r && 8 !== r && 2 !== r)
              return void 0 === t.getAttribute
                ? C.prop(t, e, n)
                : ((1 === r && C.isXMLDoc(t)) ||
                    (o =
                      C.attrHooks[e.toLowerCase()] ||
                      (C.expr.match.bool.test(e) ? ue : void 0)),
                  void 0 !== n
                    ? null === n
                      ? void C.removeAttr(t, e)
                      : o && 'set' in o && void 0 !== (i = o.set(t, n, e))
                      ? i
                      : (t.setAttribute(e, n + ''), n)
                    : o && 'get' in o && null !== (i = o.get(t, e))
                    ? i
                    : null == (i = C.find.attr(t, e))
                    ? void 0
                    : i);
          },
          attrHooks: {
            type: {
              set: function (t, e) {
                if (!v.radioValue && 'radio' === e && $(t, 'input')) {
                  var n = t.value;
                  return t.setAttribute('type', e), n && (t.value = n), e;
                }
              },
            },
          },
          removeAttr: function (t, e) {
            var n,
              i = 0,
              o = e && e.match(P);
            if (o && 1 === t.nodeType)
              for (; (n = o[i++]); ) t.removeAttribute(n);
          },
        }),
        (ue = {
          set: function (t, e, n) {
            return !1 === e ? C.removeAttr(t, n) : t.setAttribute(n, n), n;
          },
        }),
        C.each(C.expr.match.bool.source.match(/\w+/g), function (t, e) {
          var n = de[e] || C.find.attr;
          de[e] = function (t, e, i) {
            var o,
              r,
              s = e.toLowerCase();
            return (
              i ||
                ((r = de[s]),
                (de[s] = o),
                (o = null != n(t, e, i) ? s : null),
                (de[s] = r)),
              o
            );
          };
        });
      var he = /^(?:input|select|textarea|button)$/i,
        fe = /^(?:a|area)$/i;

      function pe(t) {
        return (t.match(P) || []).join(' ');
      }

      function ge(t) {
        return (t.getAttribute && t.getAttribute('class')) || '';
      }

      function me(t) {
        return Array.isArray(t)
          ? t
          : ('string' == typeof t && t.match(P)) || [];
      }

      C.fn.extend({
        prop: function (t, e) {
          return Q(this, C.prop, t, e, arguments.length > 1);
        },
        removeProp: function (t) {
          return this.each(function () {
            delete this[C.propFix[t] || t];
          });
        },
      }),
        C.extend({
          prop: function (t, e, n) {
            var i,
              o,
              r = t.nodeType;
            if (3 !== r && 8 !== r && 2 !== r)
              return (
                (1 === r && C.isXMLDoc(t)) ||
                  ((e = C.propFix[e] || e), (o = C.propHooks[e])),
                void 0 !== n
                  ? o && 'set' in o && void 0 !== (i = o.set(t, n, e))
                    ? i
                    : (t[e] = n)
                  : o && 'get' in o && null !== (i = o.get(t, e))
                  ? i
                  : t[e]
              );
          },
          propHooks: {
            tabIndex: {
              get: function (t) {
                var e = C.find.attr(t, 'tabindex');
                return e
                  ? parseInt(e, 10)
                  : he.test(t.nodeName) || (fe.test(t.nodeName) && t.href)
                  ? 0
                  : -1;
              },
            },
          },
          propFix: { for: 'htmlFor', class: 'className' },
        }),
        v.optSelected ||
          (C.propHooks.selected = {
            get: function (t) {
              var e = t.parentNode;
              return e && e.parentNode && e.parentNode.selectedIndex, null;
            },
            set: function (t) {
              var e = t.parentNode;
              e &&
                (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex);
            },
          }),
        C.each(
          [
            'tabIndex',
            'readOnly',
            'maxLength',
            'cellSpacing',
            'cellPadding',
            'rowSpan',
            'colSpan',
            'useMap',
            'frameBorder',
            'contentEditable',
          ],
          function () {
            C.propFix[this.toLowerCase()] = this;
          }
        ),
        C.fn.extend({
          addClass: function (t) {
            var e,
              n,
              i,
              o,
              r,
              s,
              a,
              l = 0;
            if (y(t))
              return this.each(function (e) {
                C(this).addClass(t.call(this, e, ge(this)));
              });
            if ((e = me(t)).length)
              for (; (n = this[l++]); )
                if (
                  ((o = ge(n)), (i = 1 === n.nodeType && ' ' + pe(o) + ' '))
                ) {
                  for (s = 0; (r = e[s++]); )
                    i.indexOf(' ' + r + ' ') < 0 && (i += r + ' ');
                  o !== (a = pe(i)) && n.setAttribute('class', a);
                }
            return this;
          },
          removeClass: function (t) {
            var e,
              n,
              i,
              o,
              r,
              s,
              a,
              l = 0;
            if (y(t))
              return this.each(function (e) {
                C(this).removeClass(t.call(this, e, ge(this)));
              });
            if (!arguments.length) return this.attr('class', '');
            if ((e = me(t)).length)
              for (; (n = this[l++]); )
                if (
                  ((o = ge(n)), (i = 1 === n.nodeType && ' ' + pe(o) + ' '))
                ) {
                  for (s = 0; (r = e[s++]); )
                    for (; i.indexOf(' ' + r + ' ') > -1; )
                      i = i.replace(' ' + r + ' ', ' ');
                  o !== (a = pe(i)) && n.setAttribute('class', a);
                }
            return this;
          },
          toggleClass: function (t, e) {
            var n = typeof t,
              i = 'string' === n || Array.isArray(t);
            return 'boolean' == typeof e && i
              ? e
                ? this.addClass(t)
                : this.removeClass(t)
              : y(t)
              ? this.each(function (n) {
                  C(this).toggleClass(t.call(this, n, ge(this), e), e);
                })
              : this.each(function () {
                  var e, o, r, s;
                  if (i)
                    for (o = 0, r = C(this), s = me(t); (e = s[o++]); )
                      r.hasClass(e) ? r.removeClass(e) : r.addClass(e);
                  else
                    (void 0 !== t && 'boolean' !== n) ||
                      ((e = ge(this)) && J.set(this, '__className__', e),
                      this.setAttribute &&
                        this.setAttribute(
                          'class',
                          e || !1 === t
                            ? ''
                            : J.get(this, '__className__') || ''
                        ));
                });
          },
          hasClass: function (t) {
            var e,
              n,
              i = 0;
            for (e = ' ' + t + ' '; (n = this[i++]); )
              if (1 === n.nodeType && (' ' + pe(ge(n)) + ' ').indexOf(e) > -1)
                return !0;
            return !1;
          },
        });
      var ve = /\r/g;
      C.fn.extend({
        val: function (t) {
          var e,
            n,
            i,
            o = this[0];
          return arguments.length
            ? ((i = y(t)),
              this.each(function (n) {
                var o;
                1 === this.nodeType &&
                  (null == (o = i ? t.call(this, n, C(this).val()) : t)
                    ? (o = '')
                    : 'number' == typeof o
                    ? (o += '')
                    : Array.isArray(o) &&
                      (o = C.map(o, function (t) {
                        return null == t ? '' : t + '';
                      })),
                  ((e =
                    C.valHooks[this.type] ||
                    C.valHooks[this.nodeName.toLowerCase()]) &&
                    'set' in e &&
                    void 0 !== e.set(this, o, 'value')) ||
                    (this.value = o));
              }))
            : o
            ? (e =
                C.valHooks[o.type] || C.valHooks[o.nodeName.toLowerCase()]) &&
              'get' in e &&
              void 0 !== (n = e.get(o, 'value'))
              ? n
              : 'string' == typeof (n = o.value)
              ? n.replace(ve, '')
              : null == n
              ? ''
              : n
            : void 0;
        },
      }),
        C.extend({
          valHooks: {
            option: {
              get: function (t) {
                var e = C.find.attr(t, 'value');
                return null != e ? e : pe(C.text(t));
              },
            },
            select: {
              get: function (t) {
                var e,
                  n,
                  i,
                  o = t.options,
                  r = t.selectedIndex,
                  s = 'select-one' === t.type,
                  a = s ? null : [],
                  l = s ? r + 1 : o.length;
                for (i = r < 0 ? l : s ? r : 0; i < l; i++)
                  if (
                    ((n = o[i]).selected || i === r) &&
                    !n.disabled &&
                    (!n.parentNode.disabled || !$(n.parentNode, 'optgroup'))
                  ) {
                    if (((e = C(n).val()), s)) return e;
                    a.push(e);
                  }
                return a;
              },
              set: function (t, e) {
                for (
                  var n, i, o = t.options, r = C.makeArray(e), s = o.length;
                  s--;

                )
                  ((i = o[s]).selected =
                    C.inArray(C.valHooks.option.get(i), r) > -1) && (n = !0);
                return n || (t.selectedIndex = -1), r;
              },
            },
          },
        }),
        C.each(['radio', 'checkbox'], function () {
          (C.valHooks[this] = {
            set: function (t, e) {
              if (Array.isArray(e))
                return (t.checked = C.inArray(C(t).val(), e) > -1);
            },
          }),
            v.checkOn ||
              (C.valHooks[this].get = function (t) {
                return null === t.getAttribute('value') ? 'on' : t.value;
              });
        }),
        (v.focusin = 'onfocusin' in n);
      var ye = /^(?:focusinfocus|focusoutblur)$/,
        we = function (t) {
          t.stopPropagation();
        };
      C.extend(C.event, {
        trigger: function (t, e, i, o) {
          var r,
            a,
            l,
            c,
            u,
            d,
            h,
            f,
            g = [i || s],
            m = p.call(t, 'type') ? t.type : t,
            v = p.call(t, 'namespace') ? t.namespace.split('.') : [];
          if (
            ((a = f = l = i = i || s),
            3 !== i.nodeType &&
              8 !== i.nodeType &&
              !ye.test(m + C.event.triggered) &&
              (m.indexOf('.') > -1 &&
                ((m = (v = m.split('.')).shift()), v.sort()),
              (u = m.indexOf(':') < 0 && 'on' + m),
              ((t = t[C.expando]
                ? t
                : new C.Event(m, 'object' == typeof t && t)).isTrigger = o
                ? 2
                : 3),
              (t.namespace = v.join('.')),
              (t.rnamespace = t.namespace
                ? new RegExp('(^|\\.)' + v.join('\\.(?:.*\\.|)') + '(\\.|$)')
                : null),
              (t.result = void 0),
              t.target || (t.target = i),
              (e = null == e ? [t] : C.makeArray(e, [t])),
              (h = C.event.special[m] || {}),
              o || !h.trigger || !1 !== h.trigger.apply(i, e)))
          ) {
            if (!o && !h.noBubble && !w(i)) {
              for (
                c = h.delegateType || m, ye.test(c + m) || (a = a.parentNode);
                a;
                a = a.parentNode
              )
                g.push(a), (l = a);
              l === (i.ownerDocument || s) &&
                g.push(l.defaultView || l.parentWindow || n);
            }
            for (r = 0; (a = g[r++]) && !t.isPropagationStopped(); )
              (f = a),
                (t.type = r > 1 ? c : h.bindType || m),
                (d =
                  (J.get(a, 'events') || {})[t.type] && J.get(a, 'handle')) &&
                  d.apply(a, e),
                (d = u && a[u]) &&
                  d.apply &&
                  Y(a) &&
                  ((t.result = d.apply(a, e)),
                  !1 === t.result && t.preventDefault());
            return (
              (t.type = m),
              o ||
                t.isDefaultPrevented() ||
                (h._default && !1 !== h._default.apply(g.pop(), e)) ||
                !Y(i) ||
                (u &&
                  y(i[m]) &&
                  !w(i) &&
                  ((l = i[u]) && (i[u] = null),
                  (C.event.triggered = m),
                  t.isPropagationStopped() && f.addEventListener(m, we),
                  i[m](),
                  t.isPropagationStopped() && f.removeEventListener(m, we),
                  (C.event.triggered = void 0),
                  l && (i[u] = l))),
              t.result
            );
          }
        },
        simulate: function (t, e, n) {
          var i = C.extend(new C.Event(), n, { type: t, isSimulated: !0 });
          C.event.trigger(i, null, e);
        },
      }),
        C.fn.extend({
          trigger: function (t, e) {
            return this.each(function () {
              C.event.trigger(t, e, this);
            });
          },
          triggerHandler: function (t, e) {
            var n = this[0];
            if (n) return C.event.trigger(t, e, n, !0);
          },
        }),
        v.focusin ||
          C.each({ focus: 'focusin', blur: 'focusout' }, function (t, e) {
            var n = function (t) {
              C.event.simulate(e, t.target, C.event.fix(t));
            };
            C.event.special[e] = {
              setup: function () {
                var i = this.ownerDocument || this,
                  o = J.access(i, e);
                o || i.addEventListener(t, n, !0), J.access(i, e, (o || 0) + 1);
              },
              teardown: function () {
                var i = this.ownerDocument || this,
                  o = J.access(i, e) - 1;
                o
                  ? J.access(i, e, o)
                  : (i.removeEventListener(t, n, !0), J.remove(i, e));
              },
            };
          });
      var xe = n.location,
        be = Date.now(),
        _e = /\?/;
      C.parseXML = function (t) {
        var e;
        if (!t || 'string' != typeof t) return null;
        try {
          e = new n.DOMParser().parseFromString(t, 'text/xml');
        } catch (t) {
          e = void 0;
        }
        return (
          (e && !e.getElementsByTagName('parsererror').length) ||
            C.error('Invalid XML: ' + t),
          e
        );
      };
      var Ce = /\[\]$/,
        Te = /\r?\n/g,
        ke = /^(?:submit|button|image|reset|file)$/i,
        Ee = /^(?:input|select|textarea|keygen)/i;

      function Se(t, e, n, i) {
        var o;
        if (Array.isArray(e))
          C.each(e, function (e, o) {
            n || Ce.test(t)
              ? i(t, o)
              : Se(
                  t + '[' + ('object' == typeof o && null != o ? e : '') + ']',
                  o,
                  n,
                  i
                );
          });
        else if (n || 'object' !== _(e)) i(t, e);
        else for (o in e) Se(t + '[' + o + ']', e[o], n, i);
      }

      (C.param = function (t, e) {
        var n,
          i = [],
          o = function (t, e) {
            var n = y(e) ? e() : e;
            i[i.length] =
              encodeURIComponent(t) +
              '=' +
              encodeURIComponent(null == n ? '' : n);
          };
        if (Array.isArray(t) || (t.jquery && !C.isPlainObject(t)))
          C.each(t, function () {
            o(this.name, this.value);
          });
        else for (n in t) Se(n, t[n], e, o);
        return i.join('&');
      }),
        C.fn.extend({
          serialize: function () {
            return C.param(this.serializeArray());
          },
          serializeArray: function () {
            return this.map(function () {
              var t = C.prop(this, 'elements');
              return t ? C.makeArray(t) : this;
            })
              .filter(function () {
                var t = this.type;
                return (
                  this.name &&
                  !C(this).is(':disabled') &&
                  Ee.test(this.nodeName) &&
                  !ke.test(t) &&
                  (this.checked || !ht.test(t))
                );
              })
              .map(function (t, e) {
                var n = C(this).val();
                return null == n
                  ? null
                  : Array.isArray(n)
                  ? C.map(n, function (t) {
                      return { name: e.name, value: t.replace(Te, '\r\n') };
                    })
                  : { name: e.name, value: n.replace(Te, '\r\n') };
              })
              .get();
          },
        });
      var je = /%20/g,
        Ae = /#.*$/,
        $e = /([?&])_=[^&]*/,
        De = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        Oe = /^(?:GET|HEAD)$/,
        Ne = /^\/\//,
        ze = {},
        qe = {},
        Le = '*/'.concat('*'),
        Me = s.createElement('a');

      function Pe(t) {
        return function (e, n) {
          'string' != typeof e && ((n = e), (e = '*'));
          var i,
            o = 0,
            r = e.toLowerCase().match(P) || [];
          if (y(n))
            for (; (i = r[o++]); )
              '+' === i[0]
                ? ((i = i.slice(1) || '*'), (t[i] = t[i] || []).unshift(n))
                : (t[i] = t[i] || []).push(n);
        };
      }

      function He(t, e, n, i) {
        var o = {},
          r = t === qe;

        function s(a) {
          var l;
          return (
            (o[a] = !0),
            C.each(t[a] || [], function (t, a) {
              var c = a(e, n, i);
              return 'string' != typeof c || r || o[c]
                ? r
                  ? !(l = c)
                  : void 0
                : (e.dataTypes.unshift(c), s(c), !1);
            }),
            l
          );
        }

        return s(e.dataTypes[0]) || (!o['*'] && s('*'));
      }

      function Ie(t, e) {
        var n,
          i,
          o = C.ajaxSettings.flatOptions || {};
        for (n in e) void 0 !== e[n] && ((o[n] ? t : i || (i = {}))[n] = e[n]);
        return i && C.extend(!0, t, i), t;
      }

      (Me.href = xe.href),
        C.extend({
          active: 0,
          lastModified: {},
          etag: {},
          ajaxSettings: {
            url: xe.href,
            type: 'GET',
            isLocal:
              /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
                xe.protocol
              ),
            global: !0,
            processData: !0,
            async: !0,
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
            accepts: {
              '*': Le,
              text: 'text/plain',
              html: 'text/html',
              xml: 'application/xml, text/xml',
              json: 'application/json, text/javascript',
            },
            contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
            responseFields: {
              xml: 'responseXML',
              text: 'responseText',
              json: 'responseJSON',
            },
            converters: {
              '* text': String,
              'text html': !0,
              'text json': JSON.parse,
              'text xml': C.parseXML,
            },
            flatOptions: { url: !0, context: !0 },
          },
          ajaxSetup: function (t, e) {
            return e ? Ie(Ie(t, C.ajaxSettings), e) : Ie(C.ajaxSettings, t);
          },
          ajaxPrefilter: Pe(ze),
          ajaxTransport: Pe(qe),
          ajax: function (t, e) {
            'object' == typeof t && ((e = t), (t = void 0)), (e = e || {});
            var i,
              o,
              r,
              a,
              l,
              c,
              u,
              d,
              h,
              f,
              p = C.ajaxSetup({}, e),
              g = p.context || p,
              m = p.context && (g.nodeType || g.jquery) ? C(g) : C.event,
              v = C.Deferred(),
              y = C.Callbacks('once memory'),
              w = p.statusCode || {},
              x = {},
              b = {},
              _ = 'canceled',
              T = {
                readyState: 0,
                getResponseHeader: function (t) {
                  var e;
                  if (u) {
                    if (!a)
                      for (a = {}; (e = De.exec(r)); )
                        a[e[1].toLowerCase()] = e[2];
                    e = a[t.toLowerCase()];
                  }
                  return null == e ? null : e;
                },
                getAllResponseHeaders: function () {
                  return u ? r : null;
                },
                setRequestHeader: function (t, e) {
                  return (
                    null == u &&
                      ((t = b[t.toLowerCase()] = b[t.toLowerCase()] || t),
                      (x[t] = e)),
                    this
                  );
                },
                overrideMimeType: function (t) {
                  return null == u && (p.mimeType = t), this;
                },
                statusCode: function (t) {
                  var e;
                  if (t)
                    if (u) T.always(t[T.status]);
                    else for (e in t) w[e] = [w[e], t[e]];
                  return this;
                },
                abort: function (t) {
                  var e = t || _;
                  return i && i.abort(e), k(0, e), this;
                },
              };
            if (
              (v.promise(T),
              (p.url = ((t || p.url || xe.href) + '').replace(
                Ne,
                xe.protocol + '//'
              )),
              (p.type = e.method || e.type || p.method || p.type),
              (p.dataTypes = (p.dataType || '*').toLowerCase().match(P) || [
                '',
              ]),
              null == p.crossDomain)
            ) {
              c = s.createElement('a');
              try {
                (c.href = p.url),
                  (c.href = c.href),
                  (p.crossDomain =
                    Me.protocol + '//' + Me.host != c.protocol + '//' + c.host);
              } catch (t) {
                p.crossDomain = !0;
              }
            }
            if (
              (p.data &&
                p.processData &&
                'string' != typeof p.data &&
                (p.data = C.param(p.data, p.traditional)),
              He(ze, p, e, T),
              u)
            )
              return T;
            for (h in ((d = C.event && p.global) &&
              0 == C.active++ &&
              C.event.trigger('ajaxStart'),
            (p.type = p.type.toUpperCase()),
            (p.hasContent = !Oe.test(p.type)),
            (o = p.url.replace(Ae, '')),
            p.hasContent
              ? p.data &&
                p.processData &&
                0 ===
                  (p.contentType || '').indexOf(
                    'application/x-www-form-urlencoded'
                  ) &&
                (p.data = p.data.replace(je, '+'))
              : ((f = p.url.slice(o.length)),
                p.data &&
                  (p.processData || 'string' == typeof p.data) &&
                  ((o += (_e.test(o) ? '&' : '?') + p.data), delete p.data),
                !1 === p.cache &&
                  ((o = o.replace($e, '$1')),
                  (f = (_e.test(o) ? '&' : '?') + '_=' + be++ + f)),
                (p.url = o + f)),
            p.ifModified &&
              (C.lastModified[o] &&
                T.setRequestHeader('If-Modified-Since', C.lastModified[o]),
              C.etag[o] && T.setRequestHeader('If-None-Match', C.etag[o])),
            ((p.data && p.hasContent && !1 !== p.contentType) ||
              e.contentType) &&
              T.setRequestHeader('Content-Type', p.contentType),
            T.setRequestHeader(
              'Accept',
              p.dataTypes[0] && p.accepts[p.dataTypes[0]]
                ? p.accepts[p.dataTypes[0]] +
                    ('*' !== p.dataTypes[0] ? ', ' + Le + '; q=0.01' : '')
                : p.accepts['*']
            ),
            p.headers))
              T.setRequestHeader(h, p.headers[h]);
            if (p.beforeSend && (!1 === p.beforeSend.call(g, T, p) || u))
              return T.abort();
            if (
              ((_ = 'abort'),
              y.add(p.complete),
              T.done(p.success),
              T.fail(p.error),
              (i = He(qe, p, e, T)))
            ) {
              if (((T.readyState = 1), d && m.trigger('ajaxSend', [T, p]), u))
                return T;
              p.async &&
                p.timeout > 0 &&
                (l = n.setTimeout(function () {
                  T.abort('timeout');
                }, p.timeout));
              try {
                (u = !1), i.send(x, k);
              } catch (t) {
                if (u) throw t;
                k(-1, t);
              }
            } else k(-1, 'No Transport');

            function k(t, e, s, a) {
              var c,
                h,
                f,
                x,
                b,
                _ = e;
              u ||
                ((u = !0),
                l && n.clearTimeout(l),
                (i = void 0),
                (r = a || ''),
                (T.readyState = t > 0 ? 4 : 0),
                (c = (t >= 200 && t < 300) || 304 === t),
                s &&
                  (x = (function (t, e, n) {
                    for (
                      var i, o, r, s, a = t.contents, l = t.dataTypes;
                      '*' === l[0];

                    )
                      l.shift(),
                        void 0 === i &&
                          (i =
                            t.mimeType || e.getResponseHeader('Content-Type'));
                    if (i)
                      for (o in a)
                        if (a[o] && a[o].test(i)) {
                          l.unshift(o);
                          break;
                        }
                    if (l[0] in n) r = l[0];
                    else {
                      for (o in n) {
                        if (!l[0] || t.converters[o + ' ' + l[0]]) {
                          r = o;
                          break;
                        }
                        s || (s = o);
                      }
                      r = r || s;
                    }
                    if (r) return r !== l[0] && l.unshift(r), n[r];
                  })(p, T, s)),
                (x = (function (t, e, n, i) {
                  var o,
                    r,
                    s,
                    a,
                    l,
                    c = {},
                    u = t.dataTypes.slice();
                  if (u[1])
                    for (s in t.converters)
                      c[s.toLowerCase()] = t.converters[s];
                  for (r = u.shift(); r; )
                    if (
                      (t.responseFields[r] && (n[t.responseFields[r]] = e),
                      !l &&
                        i &&
                        t.dataFilter &&
                        (e = t.dataFilter(e, t.dataType)),
                      (l = r),
                      (r = u.shift()))
                    )
                      if ('*' === r) r = l;
                      else if ('*' !== l && l !== r) {
                        if (!(s = c[l + ' ' + r] || c['* ' + r]))
                          for (o in c)
                            if (
                              (a = o.split(' '))[1] === r &&
                              (s = c[l + ' ' + a[0]] || c['* ' + a[0]])
                            ) {
                              !0 === s
                                ? (s = c[o])
                                : !0 !== c[o] && ((r = a[0]), u.unshift(a[1]));
                              break;
                            }
                        if (!0 !== s)
                          if (s && t.throws) e = s(e);
                          else
                            try {
                              e = s(e);
                            } catch (t) {
                              return {
                                state: 'parsererror',
                                error: s
                                  ? t
                                  : 'No conversion from ' + l + ' to ' + r,
                              };
                            }
                      }
                  return { state: 'success', data: e };
                })(p, x, T, c)),
                c
                  ? (p.ifModified &&
                      ((b = T.getResponseHeader('Last-Modified')) &&
                        (C.lastModified[o] = b),
                      (b = T.getResponseHeader('etag')) && (C.etag[o] = b)),
                    204 === t || 'HEAD' === p.type
                      ? (_ = 'nocontent')
                      : 304 === t
                      ? (_ = 'notmodified')
                      : ((_ = x.state), (h = x.data), (c = !(f = x.error))))
                  : ((f = _), (!t && _) || ((_ = 'error'), t < 0 && (t = 0))),
                (T.status = t),
                (T.statusText = (e || _) + ''),
                c ? v.resolveWith(g, [h, _, T]) : v.rejectWith(g, [T, _, f]),
                T.statusCode(w),
                (w = void 0),
                d &&
                  m.trigger(c ? 'ajaxSuccess' : 'ajaxError', [T, p, c ? h : f]),
                y.fireWith(g, [T, _]),
                d &&
                  (m.trigger('ajaxComplete', [T, p]),
                  --C.active || C.event.trigger('ajaxStop')));
            }

            return T;
          },
          getJSON: function (t, e, n) {
            return C.get(t, e, n, 'json');
          },
          getScript: function (t, e) {
            return C.get(t, void 0, e, 'script');
          },
        }),
        C.each(['get', 'post'], function (t, e) {
          C[e] = function (t, n, i, o) {
            return (
              y(n) && ((o = o || i), (i = n), (n = void 0)),
              C.ajax(
                C.extend(
                  {
                    url: t,
                    type: e,
                    dataType: o,
                    data: n,
                    success: i,
                  },
                  C.isPlainObject(t) && t
                )
              )
            );
          };
        }),
        (C._evalUrl = function (t) {
          return C.ajax({
            url: t,
            type: 'GET',
            dataType: 'script',
            cache: !0,
            async: !1,
            global: !1,
            throws: !0,
          });
        }),
        C.fn.extend({
          wrapAll: function (t) {
            var e;
            return (
              this[0] &&
                (y(t) && (t = t.call(this[0])),
                (e = C(t, this[0].ownerDocument).eq(0).clone(!0)),
                this[0].parentNode && e.insertBefore(this[0]),
                e
                  .map(function () {
                    for (var t = this; t.firstElementChild; )
                      t = t.firstElementChild;
                    return t;
                  })
                  .append(this)),
              this
            );
          },
          wrapInner: function (t) {
            return y(t)
              ? this.each(function (e) {
                  C(this).wrapInner(t.call(this, e));
                })
              : this.each(function () {
                  var e = C(this),
                    n = e.contents();
                  n.length ? n.wrapAll(t) : e.append(t);
                });
          },
          wrap: function (t) {
            var e = y(t);
            return this.each(function (n) {
              C(this).wrapAll(e ? t.call(this, n) : t);
            });
          },
          unwrap: function (t) {
            return (
              this.parent(t)
                .not('body')
                .each(function () {
                  C(this).replaceWith(this.childNodes);
                }),
              this
            );
          },
        }),
        (C.expr.pseudos.hidden = function (t) {
          return !C.expr.pseudos.visible(t);
        }),
        (C.expr.pseudos.visible = function (t) {
          return !!(
            t.offsetWidth ||
            t.offsetHeight ||
            t.getClientRects().length
          );
        }),
        (C.ajaxSettings.xhr = function () {
          try {
            return new n.XMLHttpRequest();
          } catch (t) {}
        });
      var Re = { 0: 200, 1223: 204 },
        We = C.ajaxSettings.xhr();
      (v.cors = !!We && 'withCredentials' in We),
        (v.ajax = We = !!We),
        C.ajaxTransport(function (t) {
          var e, i;
          if (v.cors || (We && !t.crossDomain))
            return {
              send: function (o, r) {
                var s,
                  a = t.xhr();
                if (
                  (a.open(t.type, t.url, t.async, t.username, t.password),
                  t.xhrFields)
                )
                  for (s in t.xhrFields) a[s] = t.xhrFields[s];
                for (s in (t.mimeType &&
                  a.overrideMimeType &&
                  a.overrideMimeType(t.mimeType),
                t.crossDomain ||
                  o['X-Requested-With'] ||
                  (o['X-Requested-With'] = 'XMLHttpRequest'),
                o))
                  a.setRequestHeader(s, o[s]);
                (e = function (t) {
                  return function () {
                    e &&
                      ((e =
                        i =
                        a.onload =
                        a.onerror =
                        a.onabort =
                        a.ontimeout =
                        a.onreadystatechange =
                          null),
                      'abort' === t
                        ? a.abort()
                        : 'error' === t
                        ? 'number' != typeof a.status
                          ? r(0, 'error')
                          : r(a.status, a.statusText)
                        : r(
                            Re[a.status] || a.status,
                            a.statusText,
                            'text' !== (a.responseType || 'text') ||
                              'string' != typeof a.responseText
                              ? { binary: a.response }
                              : { text: a.responseText },
                            a.getAllResponseHeaders()
                          ));
                  };
                }),
                  (a.onload = e()),
                  (i = a.onerror = a.ontimeout = e('error')),
                  void 0 !== a.onabort
                    ? (a.onabort = i)
                    : (a.onreadystatechange = function () {
                        4 === a.readyState &&
                          n.setTimeout(function () {
                            e && i();
                          });
                      }),
                  (e = e('abort'));
                try {
                  a.send((t.hasContent && t.data) || null);
                } catch (t) {
                  if (e) throw t;
                }
              },
              abort: function () {
                e && e();
              },
            };
        }),
        C.ajaxPrefilter(function (t) {
          t.crossDomain && (t.contents.script = !1);
        }),
        C.ajaxSetup({
          accepts: {
            script:
              'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript',
          },
          contents: { script: /\b(?:java|ecma)script\b/ },
          converters: {
            'text script': function (t) {
              return C.globalEval(t), t;
            },
          },
        }),
        C.ajaxPrefilter('script', function (t) {
          void 0 === t.cache && (t.cache = !1),
            t.crossDomain && (t.type = 'GET');
        }),
        C.ajaxTransport('script', function (t) {
          var e, n;
          if (t.crossDomain)
            return {
              send: function (i, o) {
                (e = C('<script>')
                  .prop({ charset: t.scriptCharset, src: t.url })
                  .on(
                    'load error',
                    (n = function (t) {
                      e.remove(),
                        (n = null),
                        t && o('error' === t.type ? 404 : 200, t.type);
                    })
                  )),
                  s.head.appendChild(e[0]);
              },
              abort: function () {
                n && n();
              },
            };
        });
      var Be = [],
        Fe = /(=)\?(?=&|$)|\?\?/;
      C.ajaxSetup({
        jsonp: 'callback',
        jsonpCallback: function () {
          var t = Be.pop() || C.expando + '_' + be++;
          return (this[t] = !0), t;
        },
      }),
        C.ajaxPrefilter('json jsonp', function (t, e, i) {
          var o,
            r,
            s,
            a =
              !1 !== t.jsonp &&
              (Fe.test(t.url)
                ? 'url'
                : 'string' == typeof t.data &&
                  0 ===
                    (t.contentType || '').indexOf(
                      'application/x-www-form-urlencoded'
                    ) &&
                  Fe.test(t.data) &&
                  'data');
          if (a || 'jsonp' === t.dataTypes[0])
            return (
              (o = t.jsonpCallback =
                y(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
              a
                ? (t[a] = t[a].replace(Fe, '$1' + o))
                : !1 !== t.jsonp &&
                  (t.url += (_e.test(t.url) ? '&' : '?') + t.jsonp + '=' + o),
              (t.converters['script json'] = function () {
                return s || C.error(o + ' was not called'), s[0];
              }),
              (t.dataTypes[0] = 'json'),
              (r = n[o]),
              (n[o] = function () {
                s = arguments;
              }),
              i.always(function () {
                void 0 === r ? C(n).removeProp(o) : (n[o] = r),
                  t[o] && ((t.jsonpCallback = e.jsonpCallback), Be.push(o)),
                  s && y(r) && r(s[0]),
                  (s = r = void 0);
              }),
              'script'
            );
        }),
        (v.createHTMLDocument = (function () {
          var t = s.implementation.createHTMLDocument('').body;
          return (
            (t.innerHTML = '<form></form><form></form>'),
            2 === t.childNodes.length
          );
        })()),
        (C.parseHTML = function (t, e, n) {
          return 'string' != typeof t
            ? []
            : ('boolean' == typeof e && ((n = e), (e = !1)),
              e ||
                (v.createHTMLDocument
                  ? (((i = (e =
                      s.implementation.createHTMLDocument('')).createElement(
                      'base'
                    )).href = s.location.href),
                    e.head.appendChild(i))
                  : (e = s)),
              (o = D.exec(t)),
              (r = !n && []),
              o
                ? [e.createElement(o[1])]
                : ((o = wt([t], e, r)),
                  r && r.length && C(r).remove(),
                  C.merge([], o.childNodes)));
          var i, o, r;
        }),
        (C.fn.load = function (t, e, n) {
          var i,
            o,
            r,
            s = this,
            a = t.indexOf(' ');
          return (
            a > -1 && ((i = pe(t.slice(a))), (t = t.slice(0, a))),
            y(e)
              ? ((n = e), (e = void 0))
              : e && 'object' == typeof e && (o = 'POST'),
            s.length > 0 &&
              C.ajax({
                url: t,
                type: o || 'GET',
                dataType: 'html',
                data: e,
              })
                .done(function (t) {
                  (r = arguments),
                    s.html(i ? C('<div>').append(C.parseHTML(t)).find(i) : t);
                })
                .always(
                  n &&
                    function (t, e) {
                      s.each(function () {
                        n.apply(this, r || [t.responseText, e, t]);
                      });
                    }
                ),
            this
          );
        }),
        C.each(
          [
            'ajaxStart',
            'ajaxStop',
            'ajaxComplete',
            'ajaxError',
            'ajaxSuccess',
            'ajaxSend',
          ],
          function (t, e) {
            C.fn[e] = function (t) {
              return this.on(e, t);
            };
          }
        ),
        (C.expr.pseudos.animated = function (t) {
          return C.grep(C.timers, function (e) {
            return t === e.elem;
          }).length;
        }),
        (C.offset = {
          setOffset: function (t, e, n) {
            var i,
              o,
              r,
              s,
              a,
              l,
              c = C.css(t, 'position'),
              u = C(t),
              d = {};
            'static' === c && (t.style.position = 'relative'),
              (a = u.offset()),
              (r = C.css(t, 'top')),
              (l = C.css(t, 'left')),
              ('absolute' === c || 'fixed' === c) &&
              (r + l).indexOf('auto') > -1
                ? ((s = (i = u.position()).top), (o = i.left))
                : ((s = parseFloat(r) || 0), (o = parseFloat(l) || 0)),
              y(e) && (e = e.call(t, n, C.extend({}, a))),
              null != e.top && (d.top = e.top - a.top + s),
              null != e.left && (d.left = e.left - a.left + o),
              'using' in e ? e.using.call(t, d) : u.css(d);
          },
        }),
        C.fn.extend({
          offset: function (t) {
            if (arguments.length)
              return void 0 === t
                ? this
                : this.each(function (e) {
                    C.offset.setOffset(this, t, e);
                  });
            var e,
              n,
              i = this[0];
            return i
              ? i.getClientRects().length
                ? ((e = i.getBoundingClientRect()),
                  (n = i.ownerDocument.defaultView),
                  {
                    top: e.top + n.pageYOffset,
                    left: e.left + n.pageXOffset,
                  })
                : { top: 0, left: 0 }
              : void 0;
          },
          position: function () {
            if (this[0]) {
              var t,
                e,
                n,
                i = this[0],
                o = { top: 0, left: 0 };
              if ('fixed' === C.css(i, 'position'))
                e = i.getBoundingClientRect();
              else {
                for (
                  e = this.offset(),
                    n = i.ownerDocument,
                    t = i.offsetParent || n.documentElement;
                  t &&
                  (t === n.body || t === n.documentElement) &&
                  'static' === C.css(t, 'position');

                )
                  t = t.parentNode;
                t &&
                  t !== i &&
                  1 === t.nodeType &&
                  (((o = C(t).offset()).top += C.css(t, 'borderTopWidth', !0)),
                  (o.left += C.css(t, 'borderLeftWidth', !0)));
              }
              return {
                top: e.top - o.top - C.css(i, 'marginTop', !0),
                left: e.left - o.left - C.css(i, 'marginLeft', !0),
              };
            }
          },
          offsetParent: function () {
            return this.map(function () {
              for (
                var t = this.offsetParent;
                t && 'static' === C.css(t, 'position');

              )
                t = t.offsetParent;
              return t || xt;
            });
          },
        }),
        C.each(
          { scrollLeft: 'pageXOffset', scrollTop: 'pageYOffset' },
          function (t, e) {
            var n = 'pageYOffset' === e;
            C.fn[t] = function (i) {
              return Q(
                this,
                function (t, i, o) {
                  var r;
                  if (
                    (w(t) ? (r = t) : 9 === t.nodeType && (r = t.defaultView),
                    void 0 === o)
                  )
                    return r ? r[e] : t[i];
                  r
                    ? r.scrollTo(n ? r.pageXOffset : o, n ? o : r.pageYOffset)
                    : (t[i] = o);
                },
                t,
                i,
                arguments.length
              );
            };
          }
        ),
        C.each(['top', 'left'], function (t, e) {
          C.cssHooks[e] = Bt(v.pixelPosition, function (t, n) {
            if (n)
              return (n = Wt(t, e)), Ht.test(n) ? C(t).position()[e] + 'px' : n;
          });
        }),
        C.each({ Height: 'height', Width: 'width' }, function (t, e) {
          C.each(
            { padding: 'inner' + t, content: e, '': 'outer' + t },
            function (n, i) {
              C.fn[i] = function (o, r) {
                var s = arguments.length && (n || 'boolean' != typeof o),
                  a = n || (!0 === o || !0 === r ? 'margin' : 'border');
                return Q(
                  this,
                  function (e, n, o) {
                    var r;
                    return w(e)
                      ? 0 === i.indexOf('outer')
                        ? e['inner' + t]
                        : e.document.documentElement['client' + t]
                      : 9 === e.nodeType
                      ? ((r = e.documentElement),
                        Math.max(
                          e.body['scroll' + t],
                          r['scroll' + t],
                          e.body['offset' + t],
                          r['offset' + t],
                          r['client' + t]
                        ))
                      : void 0 === o
                      ? C.css(e, n, a)
                      : C.style(e, n, o, a);
                  },
                  e,
                  s ? o : void 0,
                  s
                );
              };
            }
          );
        }),
        C.each(
          'blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu'.split(
            ' '
          ),
          function (t, e) {
            C.fn[e] = function (t, n) {
              return arguments.length > 0
                ? this.on(e, null, t, n)
                : this.trigger(e);
            };
          }
        ),
        C.fn.extend({
          hover: function (t, e) {
            return this.mouseenter(t).mouseleave(e || t);
          },
        }),
        C.fn.extend({
          bind: function (t, e, n) {
            return this.on(t, null, e, n);
          },
          unbind: function (t, e) {
            return this.off(t, null, e);
          },
          delegate: function (t, e, n, i) {
            return this.on(e, t, n, i);
          },
          undelegate: function (t, e, n) {
            return 1 === arguments.length
              ? this.off(t, '**')
              : this.off(e, t || '**', n);
          },
        }),
        (C.proxy = function (t, e) {
          var n, i, o;
          if (('string' == typeof e && ((n = t[e]), (e = t), (t = n)), y(t)))
            return (
              (i = l.call(arguments, 2)),
              ((o = function () {
                return t.apply(e || this, i.concat(l.call(arguments)));
              }).guid = t.guid =
                t.guid || C.guid++),
              o
            );
        }),
        (C.holdReady = function (t) {
          t ? C.readyWait++ : C.ready(!0);
        }),
        (C.isArray = Array.isArray),
        (C.parseJSON = JSON.parse),
        (C.nodeName = $),
        (C.isFunction = y),
        (C.isWindow = w),
        (C.camelCase = U),
        (C.type = _),
        (C.now = Date.now),
        (C.isNumeric = function (t) {
          var e = C.type(t);
          return (
            ('number' === e || 'string' === e) && !isNaN(t - parseFloat(t))
          );
        }),
        void 0 ===
          (i = function () {
            return C;
          }.apply(e, [])) || (t.exports = i);
      var Qe = n.jQuery,
        Xe = n.$;
      return (
        (C.noConflict = function (t) {
          return (
            n.$ === C && (n.$ = Xe), t && n.jQuery === C && (n.jQuery = Qe), C
          );
        }),
        o || (n.jQuery = n.$ = C),
        C
      );
    });
  },
  function (t, e, n) {
    'use strict';
    var i = (function (t) {
      return t && t.__esModule ? t : { default: t };
    })(n(0));

    function o(t) {
      return t
        .replace(/^\?/, '')
        .split('&')
        .reduce(function (t, e) {
          var n = e.split('='),
            i = t[n[0]] ? [t[n[0]]].concat(n[1]) : n[1];
          return (t[n[0]] = i), t;
        }, {});
    }

    t.exports = {
      init: function (t) {
        (0, i.default)('[data-component]', t || 'body')
          .addBack('[data-component]')
          .each(function (t, e) {
            var n = (0, i.default)(e);
            void 0 === n.data('module-instances') &&
              (function () {
                var t = n.data(),
                  e = n
                    .data('component')
                    .split(',')
                    .map(function (t) {
                      return t.trim();
                    }),
                  i = {};
                for (var r in e) {
                  var s = e[r];
                  if (void 0 !== window._app[s]) {
                    var a = Object.keys(t).reduce(function (e, n) {
                      return (
                        'string' == typeof t[n]
                          ? (e[n] = t[n].match('=') ? o(t[n]) : e[n])
                          : (e[n] = t[n]),
                        e
                      );
                    }, t);
                    delete a.js, (a.$element = n);
                    var l = new window._app[s](a);
                    (i[s] = l),
                      a.$element.data('module-instance', l),
                      n.data('module-instances', i),
                      l.init && l.init();
                  }
                }
              })();
          });
      },
      queryToObject: o,
      replace: function (t, e) {
        for (var n in e) {
          var i = new RegExp('{- ' + n + ' -}', 'g'),
            o = e[n];
          t = t.replace(i, o);
        }
        return t;
      },
      nicelyFormatFileSize: function (t, e) {
        var n = e ? 1e3 : 1024;
        if (Math.abs(t) < n) return t + ' B';
        var i = e
            ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
            : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'],
          o = -1;
        do {
          (t /= n), ++o;
        } while (Math.abs(t) >= n && o < i.length - 1);
        return t.toFixed(1) + ' ' + i[o];
      },
      trigger: function (t, e) {
        for (
          var n, o = arguments.length, r = Array(o > 2 ? o - 2 : 0), s = 2;
          s < o;
          s++
        )
          r[s - 2] = arguments[s];
        (n = (0, i.default)(e)).trigger.apply(n, [t].concat(r));
      },
    };
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 });
    e.default = {
      accordion: {
        toggle: 'app::accordion::toggle',
        beginToggle: 'app::accordion::beginToggle',
        expand: 'app::accordion::expand',
        collapse: 'app::accordion::collapse',
      },
      dynamicContent: {
        show: 'app::dynamicContent::show',
        hide: 'app::dynamicContent::hide',
      },
    };
  },
  function (t, e, n) {
    var i;
    !(function () {
      'use strict';
      var o, r;

      function s(t) {
        return void 0 === this || Object.getPrototypeOf(this) !== s.prototype
          ? new s(t)
          : (((o = this).version = '3.4.0'),
            (o.tools = new x()),
            o.isSupported()
              ? (o.tools.extend(o.defaults, t || {}),
                (o.defaults.container = a(o.defaults)),
                (o.store = {
                  elements: {},
                  containers: [],
                }),
                (o.sequences = {}),
                (o.history = []),
                (o.uid = 0),
                (o.initialized = !1))
              : 'undefined' != typeof console &&
                null !== console &&
                console.log('ScrollReveal is not supported in this browser.'),
            o);
      }

      function a(t) {
        if (t && t.container) {
          if ('string' == typeof t.container)
            return window.document.documentElement.querySelector(t.container);
          if (o.tools.isNode(t.container)) return t.container;
          console.log(
            'ScrollReveal: invalid container "' + t.container + '" provided.'
          ),
            console.log('ScrollReveal: falling back to default container.');
        }
        return o.defaults.container;
      }

      function l() {
        return ++o.uid;
      }

      function c(t, e, n) {
        e.container && (e.container = n),
          t.config
            ? (t.config = o.tools.extendClone(t.config, e))
            : (t.config = o.tools.extendClone(o.defaults, e)),
          'top' === t.config.origin || 'bottom' === t.config.origin
            ? (t.config.axis = 'Y')
            : (t.config.axis = 'X');
      }

      function u(t) {
        var e = window.getComputedStyle(t.domEl);
        t.styles ||
          ((t.styles = {
            transition: {},
            transform: {},
            computed: {},
          }),
          (t.styles.inline = t.domEl.getAttribute('style') || ''),
          (t.styles.inline += '; visibility: visible; '),
          (t.styles.computed.opacity = e.opacity),
          e.transition && 'all 0s ease 0s' !== e.transition
            ? (t.styles.computed.transition = e.transition + ', ')
            : (t.styles.computed.transition = '')),
          (t.styles.transition.instant = d(t, 0)),
          (t.styles.transition.delayed = d(t, t.config.delay)),
          (t.styles.transform.initial = ' -webkit-transform:'),
          (t.styles.transform.target = ' -webkit-transform:'),
          h(t),
          (t.styles.transform.initial += 'transform:'),
          (t.styles.transform.target += 'transform:'),
          h(t);
      }

      function d(t, e) {
        var n = t.config;
        return (
          '-webkit-transition: ' +
          t.styles.computed.transition +
          '-webkit-transform ' +
          n.duration / 1e3 +
          's ' +
          n.easing +
          ' ' +
          e / 1e3 +
          's, opacity ' +
          n.duration / 1e3 +
          's ' +
          n.easing +
          ' ' +
          e / 1e3 +
          's; transition: ' +
          t.styles.computed.transition +
          'transform ' +
          n.duration / 1e3 +
          's ' +
          n.easing +
          ' ' +
          e / 1e3 +
          's, opacity ' +
          n.duration / 1e3 +
          's ' +
          n.easing +
          ' ' +
          e / 1e3 +
          's; '
        );
      }

      function h(t) {
        var e,
          n = t.config,
          i = t.styles.transform;
        (e =
          'top' === n.origin || 'left' === n.origin
            ? /^-/.test(n.distance)
              ? n.distance.substr(1)
              : '-' + n.distance
            : n.distance),
          parseInt(n.distance) &&
            ((i.initial += ' translate' + n.axis + '(' + e + ')'),
            (i.target += ' translate' + n.axis + '(0)')),
          n.scale &&
            ((i.initial += ' scale(' + n.scale + ')'),
            (i.target += ' scale(1)')),
          n.rotate.x &&
            ((i.initial += ' rotateX(' + n.rotate.x + 'deg)'),
            (i.target += ' rotateX(0)')),
          n.rotate.y &&
            ((i.initial += ' rotateY(' + n.rotate.y + 'deg)'),
            (i.target += ' rotateY(0)')),
          n.rotate.z &&
            ((i.initial += ' rotateZ(' + n.rotate.z + 'deg)'),
            (i.target += ' rotateZ(0)')),
          (i.initial += '; opacity: ' + n.opacity + ';'),
          (i.target += '; opacity: ' + t.styles.computed.opacity + ';');
      }

      function f(t) {
        var e = t.config.container;
        e &&
          -1 === o.store.containers.indexOf(e) &&
          o.store.containers.push(t.config.container),
          (o.store.elements[t.id] = t);
      }

      function p() {
        if (o.isSupported()) {
          m();
          for (var t = 0; t < o.store.containers.length; t++)
            o.store.containers[t].addEventListener('scroll', g),
              o.store.containers[t].addEventListener('resize', g);
          o.initialized ||
            (window.addEventListener('scroll', g),
            window.addEventListener('resize', g),
            (o.initialized = !0));
        }
        return o;
      }

      function g() {
        r(m);
      }

      function m() {
        var t, e;
        !(function () {
          var t, e, n;
          o.tools.forOwn(o.sequences, function (i) {
            (n = o.sequences[i]), (t = !1);
            for (var r = 0; r < n.elemIds.length; r++)
              (e = n.elemIds[r]), w(o.store.elements[e]) && !t && (t = !0);
            n.active = t;
          });
        })(),
          o.tools.forOwn(o.store.elements, function (n) {
            (e = o.store.elements[n]),
              (t = (function (t) {
                var e = t.config.useDelay;
                return (
                  'always' === e ||
                  ('onload' === e && !o.initialized) ||
                  ('once' === e && !t.seen)
                );
              })(e)),
              (function (t) {
                if (t.sequence) {
                  var e = o.sequences[t.sequence.id];
                  return e.active && !e.blocked && !t.revealing && !t.disabled;
                }
                return w(t) && !t.revealing && !t.disabled;
              })(e)
                ? (e.config.beforeReveal(e.domEl),
                  t
                    ? e.domEl.setAttribute(
                        'style',
                        e.styles.inline +
                          e.styles.transform.target +
                          e.styles.transition.delayed
                      )
                    : e.domEl.setAttribute(
                        'style',
                        e.styles.inline +
                          e.styles.transform.target +
                          e.styles.transition.instant
                      ),
                  v('reveal', e, t),
                  (e.revealing = !0),
                  (e.seen = !0),
                  e.sequence &&
                    (function (t, e) {
                      var n = 0,
                        i = 0,
                        r = o.sequences[t.sequence.id];
                      (r.blocked = !0),
                        e &&
                          'onload' === t.config.useDelay &&
                          (i = t.config.delay);
                      t.sequence.timer &&
                        ((n = Math.abs(t.sequence.timer.started - new Date())),
                        window.clearTimeout(t.sequence.timer));
                      (t.sequence.timer = { started: new Date() }),
                        (t.sequence.timer.clock = window.setTimeout(
                          function () {
                            (r.blocked = !1), (t.sequence.timer = null), g();
                          },
                          Math.abs(r.interval) + i - n
                        ));
                    })(e, t))
                : (function (t) {
                    if (t.sequence) {
                      var e = o.sequences[t.sequence.id];
                      return (
                        !e.active &&
                        t.config.reset &&
                        t.revealing &&
                        !t.disabled
                      );
                    }
                    return (
                      !w(t) && t.config.reset && t.revealing && !t.disabled
                    );
                  })(e) &&
                  (e.config.beforeReset(e.domEl),
                  e.domEl.setAttribute(
                    'style',
                    e.styles.inline +
                      e.styles.transform.initial +
                      e.styles.transition.instant
                  ),
                  v('reset', e),
                  (e.revealing = !1));
          });
      }

      function v(t, e, n) {
        var i = 0,
          o = 0,
          r = 'after';
        switch (t) {
          case 'reveal':
            (o = e.config.duration),
              n && (o += e.config.delay),
              (r += 'Reveal');
            break;
          case 'reset':
            (o = e.config.duration), (r += 'Reset');
        }
        e.timer &&
          ((i = Math.abs(e.timer.started - new Date())),
          window.clearTimeout(e.timer.clock)),
          (e.timer = { started: new Date() }),
          (e.timer.clock = window.setTimeout(function () {
            e.config[r](e.domEl), (e.timer = null);
          }, o - i));
      }

      function y(t) {
        var e = 0,
          n = 0,
          i = t.offsetHeight,
          o = t.offsetWidth;
        do {
          isNaN(t.offsetTop) || (e += t.offsetTop),
            isNaN(t.offsetLeft) || (n += t.offsetLeft),
            (t = t.offsetParent);
        } while (t);
        return { top: e, left: n, height: i, width: o };
      }

      function w(t) {
        var e = y(t.domEl),
          n = (function (t) {
            return { width: t.clientWidth, height: t.clientHeight };
          })(t.config.container),
          i = (function (t) {
            if (t && t !== window.document.documentElement) {
              var e = y(t);
              return { x: t.scrollLeft + e.left, y: t.scrollTop + e.top };
            }
            return { x: window.pageXOffset, y: window.pageYOffset };
          })(t.config.container),
          o = t.config.viewFactor,
          r = e.height,
          s = e.width,
          a = e.top,
          l = e.left,
          c = a + r,
          u = l + s;
        return (
          (function () {
            var e = a + r * o,
              d = l + s * o,
              h = c - r * o,
              f = u - s * o,
              p = i.y + t.config.viewOffset.top,
              g = i.x + t.config.viewOffset.left,
              m = i.y - t.config.viewOffset.bottom + n.height,
              v = i.x - t.config.viewOffset.right + n.width;
            return e < m && h > p && d < v && f > g;
          })() || 'fixed' === window.getComputedStyle(t.domEl).position
        );
      }

      function x() {}

      (s.prototype.defaults = {
        origin: 'bottom',
        distance: '20px',
        duration: 500,
        delay: 0,
        rotate: { x: 0, y: 0, z: 0 },
        opacity: 0,
        scale: 0.9,
        easing: 'cubic-bezier(0.6, 0.2, 0.1, 1)',
        container: window.document.documentElement,
        mobile: !0,
        reset: !1,
        useDelay: 'always',
        viewFactor: 0.2,
        viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
        beforeReveal: function (t) {},
        beforeReset: function (t) {},
        afterReveal: function (t) {},
        afterReset: function (t) {},
      }),
        (s.prototype.isSupported = function () {
          var t = document.documentElement.style;
          return (
            ('WebkitTransition' in t && 'WebkitTransform' in t) ||
            ('transition' in t && 'transform' in t)
          );
        }),
        (s.prototype.reveal = function (t, e, n, i) {
          var r, s, d, h, g, m;
          if (
            (void 0 !== e && 'number' == typeof e
              ? ((n = e), (e = {}))
              : (void 0 !== e && null !== e) || (e = {}),
            !(s = (function (t, e) {
              if ('string' == typeof t)
                return Array.prototype.slice.call(e.querySelectorAll(t));
              if (o.tools.isNode(t)) return [t];
              if (o.tools.isNodeList(t)) return Array.prototype.slice.call(t);
              if (Array.isArray(t)) return t.filter(o.tools.isNode);
              return [];
            })(t, (r = a(e)))).length)
          )
            return (
              console.log(
                'ScrollReveal: reveal on "' + t + '" failed, no elements found.'
              ),
              o
            );
          n &&
            'number' == typeof n &&
            ((m = l()),
            (g = o.sequences[m] =
              { id: m, interval: n, elemIds: [], active: !1 }));
          for (var v = 0; v < s.length; v++)
            (h = s[v].getAttribute('data-sr-id'))
              ? (d = o.store.elements[h])
              : (d = {
                  id: l(),
                  domEl: s[v],
                  seen: !1,
                  revealing: !1,
                }).domEl.setAttribute('data-sr-id', d.id),
              g &&
                ((d.sequence = {
                  id: g.id,
                  index: g.elemIds.length,
                }),
                g.elemIds.push(d.id)),
              c(d, e, r),
              u(d),
              f(d),
              (o.tools.isMobile() && !d.config.mobile) || !o.isSupported()
                ? (d.domEl.setAttribute('style', d.styles.inline),
                  (d.disabled = !0))
                : d.revealing ||
                  d.domEl.setAttribute(
                    'style',
                    d.styles.inline + d.styles.transform.initial
                  );
          return (
            !i &&
              o.isSupported() &&
              (!(function (t, e, n) {
                var i = { target: t, config: e, interval: n };
                o.history.push(i);
              })(t, e, n),
              o.initTimeout && window.clearTimeout(o.initTimeout),
              (o.initTimeout = window.setTimeout(p, 0))),
            o
          );
        }),
        (s.prototype.sync = function () {
          if (o.history.length && o.isSupported()) {
            for (var t = 0; t < o.history.length; t++) {
              var e = o.history[t];
              o.reveal(e.target, e.config, e.interval, !0);
            }
            p();
          } else console.log('ScrollReveal: sync failed, no reveals found.');
          return o;
        }),
        (x.prototype.isObject = function (t) {
          return null !== t && 'object' == typeof t && t.constructor === Object;
        }),
        (x.prototype.isNode = function (t) {
          return 'object' == typeof window.Node
            ? t instanceof window.Node
            : t &&
                'object' == typeof t &&
                'number' == typeof t.nodeType &&
                'string' == typeof t.nodeName;
        }),
        (x.prototype.isNodeList = function (t) {
          var e = Object.prototype.toString.call(t);
          return 'object' == typeof window.NodeList
            ? t instanceof window.NodeList
            : t &&
                'object' == typeof t &&
                /^\[object (HTMLCollection|NodeList|Object)\]$/.test(e) &&
                'number' == typeof t.length &&
                (0 === t.length || this.isNode(t[0]));
        }),
        (x.prototype.forOwn = function (t, e) {
          if (!this.isObject(t))
            throw new TypeError(
              'Expected "object", but received "' + typeof t + '".'
            );
          for (var n in t) t.hasOwnProperty(n) && e(n);
        }),
        (x.prototype.extend = function (t, e) {
          return (
            this.forOwn(
              e,
              function (n) {
                this.isObject(e[n])
                  ? ((t[n] && this.isObject(t[n])) || (t[n] = {}),
                    this.extend(t[n], e[n]))
                  : (t[n] = e[n]);
              }.bind(this)
            ),
            t
          );
        }),
        (x.prototype.extendClone = function (t, e) {
          return this.extend(this.extend({}, t), e);
        }),
        (x.prototype.isMobile = function () {
          return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          );
        }),
        (r =
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          function (t) {
            window.setTimeout(t, 1e3 / 60);
          }),
        void 0 ===
          (i = function () {
            return s;
          }.call(e, n, e, t)) || (t.exports = i);
    })();
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 });
    var i = r(n(0)),
      o = r(n(3));

    function r(t) {
      return t && t.__esModule ? t : { default: t };
    }

    var s = {
        $element: void 0,
        selectors: {
          reveal: '.reveal',
          multiReveal: '.reveal--multi',
          multiRevealGroup: '.reveal-group',
        },
        options: { fadeDuration: 1e3, delayOffset: 50 },
      },
      a = (function () {
        function t() {
          var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          !(function (t, e) {
            if (!(t instanceof e))
              throw new TypeError('Cannot call a class as a function');
          })(this, t);
          var n = i.default.extend(!0, {}, s, e);
          (this.$element = n.$element),
            (this.selectors = n.selectors),
            (this.options = n.options);
        }

        return (
          (t.prototype.init = function () {
            var t = this;
            (window.sr = (0, o.default)({ reset: !0 })),
              (0, i.default)(document).ready(function () {
                t.revealElements(sr);
              });
          }),
          (t.prototype.revealElements = function () {
            var t = this,
              e = (0, i.default)(this.selectors.multiRevealGroup),
              n = (0, i.default)(this.selectors.reveal).filter(
                ':not(' + this.selectors.multiReveal + ')'
              );
            e.each(function () {
              sr.reveal(
                (0, i.default)(this).find(t.selectors.multiReveal),
                {
                  distance: 0,
                  duration: t.options.fadeDuration,
                },
                t.options.delayOffset
              );
            }),
              n.each(function () {
                sr.reveal((0, i.default)(this), {
                  distance: 0,
                  duration: t.options.fadeDuration,
                });
              });
          }),
          t
        );
      })();
    e.default = a;
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 });
    var i = (function (t) {
      return t && t.__esModule ? t : { default: t };
    })(n(0));
    var o = {
        $element: void 0,
        selectors: {
          numberGroup: '.js-item-number-group',
          numberItem: '.js-item-number-item',
          numberInput: '.js-item-number-input',
          changeNumber: '.js-change-number',
          countText: '.js-current-count-text',
          submit: '.js-submit-selection',
          packingImage: '.js-packing-image',
          packingSlot: '.js-packing-image-slot',
          packingImageGallery: '#packing-image-gallery',
          selectionInput: '.js-product-selection-input',
        },
        classes: { submit: { disabled: 'button--disabled' } },
        data: {
          max: 'data-js-max-items',
          count: 'data-js-current-items',
          initValue: 'data-js-init-value',
          method: 'data-method',
          slotFlavor: 'data-js-slot-flavor',
        },
        selection: [],
      },
      r = (function () {
        function t() {
          var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          !(function (t, e) {
            if (!(t instanceof e))
              throw new TypeError('Cannot call a class as a function');
          })(this, t);
          var n = i.default.extend(!0, {}, o, e);
          (this.$element = n.$element),
            (this.selectors = n.selectors),
            (this.classes = n.classes),
            (this.data = n.data),
            (this.selection = n.selection);
        }

        return (
          (t.prototype.init = function () {
            (0, i.default)(this.selectors.numberGroup).length &&
              this.numberSelection();
          }),
          (t.prototype.numberSelection = function () {
            var t = this,
              e = this.$element.find(this.selectors.numberGroup),
              n = parseInt(e.attr(this.data.max)),
              o = e.find(this.selectors.numberItem),
              r = 0;
            e.attr(this.data.count, 0),
              o.each(function () {
                var e = (0, i.default)(this).find(t.selectors.numberInput),
                  o = (0, i.default)(this).find(t.selectors.changeNumber),
                  s = e.attr('name'),
                  a = parseInt(e.attr(t.data.initValue)),
                  l = void 0;
                a > 0
                  ? (r + a >= n ? (r = n) : (r += a),
                    (l = r),
                    t.addToSelection(s, l))
                  : (l = 0),
                  e.val(l),
                  t.updateCountText(r),
                  r === n ? t.enableSubmit(!0) : t.enableSubmit(!1),
                  o.on('click', function (o) {
                    o.preventDefault();
                    var s = (0, i.default)(this).attr(t.data.method),
                      a = e.attr('name');
                    'add' === s && r < n
                      ? (l++, r++, e.val(l), t.addToSelection(a))
                      : 'remove' === s &&
                        r > 0 &&
                        l > 0 &&
                        (l--, r--, e.val(l), t.removeFromSelection(a)),
                      t.updateCountText(r),
                      r === n ? t.enableSubmit(!0) : t.enableSubmit(!1);
                  });
              });
          }),
          (t.prototype.updateCountText = function (t) {
            this.$element.find(this.selectors.countText).text(t);
          }),
          (t.prototype.addToSelection = function (t, e) {
            if (e) for (var n = 0; n < e; n++) this.selection.push(t);
            else this.selection.push(t);
            this.updateView();
          }),
          (t.prototype.removeFromSelection = function (t) {
            this.selection.splice(i.default.inArray(t, this.selection), 1),
              this.updateView();
          }),
          (t.prototype.removeFromView = function (t) {
            (0, i.default)(this.selectors.packingSlot)
              .eq(t)
              .removeAttr('style');
          }),
          (t.prototype.updateView = function () {
            var t = (0, i.default)(this.selectors.packingSlot),
              e = this.selection,
              n = e.length;
            t.attr(this.data.slotFlavor, '');
            for (var o = 0; o < n; o++) {
              var r = t.eq(o),
                s = e[o];
              r.attr(this.data.slotFlavor, s);
            }
            (0, i.default)(this.selectors.packingImageGallery).trigger(
              'refresh.owl.carousel'
            ),
              (0, i.default)(this.selectors.packingImageGallery).trigger(
                'to.owl.carousel',
                0
              );
          }),
          (t.prototype.enableSubmit = function (t) {
            var e = this.$element.find(this.selectors.submit);
            t
              ? (e
                  .removeClass(this.classes.submit.disabled)
                  .removeAttr('disabled'),
                (0, i.default)(this.selectors.selectionInput).val(
                  this.selection
                ))
              : (e.addClass(this.classes.submit.disabled).attr('disabled', !0),
                (0, i.default)(this.selectors.selectionInput).val(''));
          }),
          t
        );
      })();
    e.default = r;
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 });
    var i = (function (t) {
      return t && t.__esModule ? t : { default: t };
    })(n(0));
    var o = {
        $element: void 0,
        selectors: {
          radio: '.js-radio-item',
          radioText: '.js-radio-item-text',
          toggleRadios: '.js-toggle-item-radios',
          toggleRadio: '.js-toggle-item-radio',
          toggleIcons: '.js-toggle-item-icons',
          galleryImage: '.js-featured-image',
          productImageGallery: '#product-image-gallery',
          image: '.js-image',
          text: '.js-text',
          submit: '.js-submit-selection',
          select: '.js-variants-select',
        },
        classes: { hidden: 'hidden', selected: 'selected' },
        data: {
          targetGalleryImage: 'data-target-gallery-image',
          targetImage: 'data-target-image',
          targetText: 'data-target-text',
          color: 'data-selected-color',
          imageId: 'data-image-id',
        },
      },
      r = (function () {
        function t() {
          var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          !(function (t, e) {
            if (!(t instanceof e))
              throw new TypeError('Cannot call a class as a function');
          })(this, t);
          var n = i.default.extend(!0, {}, o, e);
          (this.$element = n.$element),
            (this.selectors = n.selectors),
            (this.classes = n.classes),
            (this.data = n.data);
        }

        return (
          (t.prototype.init = function () {
            var t = (0, i.default)(this.selectors.toggleRadios).find(
                'input[type="radio"]'
              ),
              e = (0, i.default)(this.selectors.select).val();
            if ((0, i.default)(this.selectors.toggleRadios).length) {
              var n = t.filter(function () {
                return this.value == e;
              });
              n && this.toggleRadios(n);
            }
          }),
          (t.prototype.toggleRadios = function (t) {
            var e = this,
              n = (0, i.default)(this.selectors.toggleRadios),
              o = n.find('input[type="radio"]:not([disabled]):first');
            t ? t.attr('checked', !0) : o.attr('checked', !0),
              this.toggleRadio(n),
              n.on('change', function (t) {
                e.toggleRadio(n);
              });
          }),
          (t.prototype.toggleRadio = function (t) {
            var e = t.find(this.selectors.toggleRadio + ':checked'),
              n = (0, i.default)(e.attr(this.data.targetGalleryImage)),
              o = (0, i.default)(e.attr(this.data.targetText)),
              r = e.attr(this.data.targetImage),
              s = e.val();
            (0, i.default)(this.selectors.select).val(s).trigger('change'),
              t.find(this.selectors.radio).removeClass(this.classes.selected),
              (0, i.default)(e)
                .closest(this.selectors.radio)
                .addClass(this.classes.selected),
              this.toggleRadioColors(),
              this.switchFeaturedImage(n),
              this.switchText(o),
              this.switchImage(r);
          }),
          (t.prototype.switchFeaturedImage = function (t) {
            this.$element
              .find(this.selectors.galleryImage)
              .addClass(this.classes.hidden),
              t.removeClass(this.classes.hidden),
              (0, i.default)(this.selectors.productImageGallery).trigger(
                'refresh.owl.carousel'
              ),
              (0, i.default)(this.selectors.productImageGallery).trigger(
                'to.owl.carousel',
                0
              );
          }),
          (t.prototype.switchText = function (t) {
            this.$element
              .find(this.selectors.text)
              .addClass(this.classes.hidden),
              t.removeClass(this.classes.hidden);
          }),
          (t.prototype.switchImage = function (t) {
            this.$element.find(this.selectors.image).attr('src', t);
          }),
          (t.prototype.switchDescription = function (t) {
            this.$element.find(this.selectors.image).attr('src', t);
          }),
          (t.prototype.toggleRadioColors = function () {
            var t = this,
              e = (0, i.default)(this.selectors.toggleRadios),
              n = e.find(t.selectors.toggleRadio),
              o = e.find(t.selectors.toggleRadio + ':checked'),
              r = (0, i.default)(o)
                .closest(t.selectors.radio)
                .find(t.selectors.radioText),
              s = (0, i.default)(o)
                .closest(t.selectors.radio)
                .find(t.selectors.toggleIcons),
              a = i.default.parseJSON((0, i.default)(o).attr(t.data.color));
            n.each(function () {
              var e = i.default.parseJSON(
                (0, i.default)(this).attr(t.data.color)
              );
              (0, i.default)(this)
                .closest(t.selectors.radio)
                .find(t.selectors.radioText)
                .removeAttr('style'),
                (0, i.default)(this)
                  .closest(t.selectors.radio)
                  .find(t.selectors.toggleIcons)
                  .css('color', e.bg);
            }),
              s.removeAttr('style'),
              r.css({ 'background-color': a.bg, color: a.color });
          }),
          t
        );
      })();
    e.default = r;
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 });
    var i = (function (t) {
      return t && t.__esModule ? t : { default: t };
    })(n(0));
    var o = {
        $element: void 0,
        selectors: {
          overlay: '.js-overlay',
          hiddenLayer: '.overlay__hidden-layer',
          close: '.js-close-overlay',
        },
        classes: { hidden: 'not-visible', body: { opened: 'overlay-opened' } },
        data: { target: 'data-target-overlay' },
      },
      r = (function () {
        function t() {
          var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          !(function (t, e) {
            if (!(t instanceof e))
              throw new TypeError('Cannot call a class as a function');
          })(this, t);
          var n = i.default.extend(!0, {}, o, e);
          (this.$element = n.$element),
            (this.selectors = n.selectors),
            (this.classes = n.classes),
            (this.data = n.data);
        }

        return (
          (t.prototype.init = function () {
            this.bind();
          }),
          (t.prototype.bind = function () {
            var t = this;
            this.$element.on('click', this.showOverlay.bind(this)),
              (0, i.default)(this.selectors.close).on('click', function (e) {
                e.preventDefault(), t.hideOverlay();
              });
          }),
          (t.prototype.showOverlay = function (t) {
            var e = this;
            t.preventDefault();
            var n = (0, i.default)(t.currentTarget).attr(this.data.target),
              o = (0, i.default)(n);
            (0, i.default)('body').addClass(this.classes.body.opened),
              o.removeClass(this.classes.hidden),
              (0, i.default)(this.selectors.hiddenLayer).removeClass(
                this.classes.hidden
              ),
              (0, i.default)(document).on(
                'click.overlay-opened',
                this.selectors.hiddenLayer,
                function (t) {
                  0 ===
                    (0, i.default)(t.target).closest(e.selectors.overlay)
                      .length && e.hideOverlay();
                }
              );
          }),
          (t.prototype.hideOverlay = function (t) {
            (0, i.default)('body').removeClass(this.classes.body.opened),
              (0, i.default)(this.selectors.hiddenLayer).addClass(
                this.classes.hidden
              ),
              (0, i.default)(this.selectors.overlay).addClass(
                this.classes.hidden
              ),
              (0, i.default)(document).off('click.overlay-opened');
          }),
          t
        );
      })();
    e.default = r;
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 });
    var i = (function (t) {
      return t && t.__esModule ? t : { default: t };
    })(n(0));
    var o = {
        $element: void 0,
        selectors: {
          accordion: '.js-accordion',
          radio: '.js-accordion.js-accordion-radio',
          item: '.js-accordion .js-accordion-item',
          heading: '.js-accordion .js-accordion-heading',
          content: '.js-accordion .js-accordion-content',
          active: '.js-accordion .js-accordion-heading-active',
          collapse: '.js-accordion .accordion__content--collapse',
          clickable: 'a, button',
        },
        classes: {
          active: 'js-accordion-heading-active accordion__heading--active',
          expanded:
            'js-accordion-content-expanded accordion__content--expanded',
          collapse: 'accordion__content--collapse',
          preventOpen: 'js-accordion-prevent-open',
        },
        keys: { enter: 13 },
        transitions: {
          open: { easing: 'easeInOutQuart', duration: 1e3 },
          close: { easing: 'easeInOutQuart', duration: 670 },
        },
      },
      r = (function () {
        function t() {
          var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          !(function (t, e) {
            if (!(t instanceof e))
              throw new TypeError('Cannot call a class as a function');
          })(this, t);
          var n = i.default.extend(!0, {}, o, e);
          (this.$element = n.$element),
            (this.selectors = n.selectors),
            (this.classes = n.classes),
            (this.keys = n.keys),
            (this.transitions = n.transitions);
        }

        return (
          (t.prototype.init = function () {
            this.accessibility(), this.bind();
          }),
          (t.prototype.accessibility = function () {
            this.$element
              .only(this.selectors.heading)
              .each(this.expanded.bind(this))
              .attr({
                tabindex: 0,
                role: 'tab',
                'aria-selected': !1,
              });
          }),
          (t.prototype.expanded = function (t, e) {
            var n = this.classes.active.split(/\s+/).some(function (t) {
              return (0, i.default)(e).hasClass(t);
            });
            (0, i.default)(e).attr('aria-expanded', n),
              (0, i.default)(e).attr('aria-selected', n);
          }),
          (t.prototype.bind = function () {
            var t = this.$element.only(this.selectors.heading);
            t.on('click', this.toggle.bind(this)),
              t.on('keydown', this.keydown.bind(this)),
              this.$element
                .only(this.selectors.collapse)
                .hide()
                .removeClass(this.classes.collapse);
          }),
          (t.prototype.keydown = function (t) {
            t.keyCode === this.keys.enter && this.toggle(t);
          }),
          (t.prototype.toggle = function (t) {
            var e = this;
            (0, i.default)(t.target).hasClass(this.classes.preventOpen) ||
              (0, i.default)(t.target)
                .not(this.selectors.heading)
                .is(this.selectors.clickable) ||
              (t.preventDefault(),
              this.isAnimating(t.currentTarget) ||
                this.beginToggle(t.currentTarget).then(function (n) {
                  e.endToggle(n, t);
                }));
          }),
          (t.prototype.isAnimating = function (t) {
            return (0, i.default)(t)
              .siblings(this.selectors.content)
              .first()
              .is(':animated');
          }),
          (t.prototype.beginToggle = function (t) {
            var e = this,
              n = (0, i.default)(t),
              o = n.siblings(this.selectors.content).first(),
              r = o.is(':hidden');
            return new Promise(function (i) {
              if (e.$element.is(e.selectors.radio)) {
                if (!r) return void i(t);
                e.reset();
              }
              var s = r ? e.transitions.open : e.transitions.close;
              n.toggleClass(e.classes.active),
                o.stop().slideToggle({
                  easing: s.easing,
                  duration: s.duration,
                  complete: function () {
                    i(t);
                  },
                });
            });
          }),
          (t.prototype.endToggle = function (t, e) {
            var n = (0, i.default)(t),
              o = n.siblings(this.selectors.content).first(),
              r = !o.is(':hidden');
            (this.$element.is(this.selectors.radio) && !r) ||
              (n.attr({
                'aria-expanded': r,
                'aria-selected': r,
              }),
              r ? o.attr('tabindex', 0).focus() : o.removeAttr('tabindex'),
              e &&
                e.keyCode === this.keys.enter &&
                (r ? o.attr('tabindex', 0).focus() : o.removeAttr('tabindex')));
          }),
          (t.prototype.reset = function () {
            var t = this.$element.only(this.selectors.heading),
              e = this.$element.only(this.selectors.content);
            t.removeClass(this.classes.active),
              e.slideUp().removeClass(this.classes.expanded),
              t.attr('aria-expanded', !1),
              t.attr('aria-selected', !1);
          }),
          t
        );
      })();
    e.default = r;
  },
  function (t, e) {
    /*!
    Waypoints - 4.0.1
    Copyright © 2011-2016 Caleb Troughton
    Licensed under the MIT license.
    https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
    */
    !(function () {
      'use strict';

      function t(i) {
        if (!i) throw new Error('No options passed to Waypoint constructor');
        if (!i.element)
          throw new Error('No element option passed to Waypoint constructor');
        if (!i.handler)
          throw new Error('No handler option passed to Waypoint constructor');
        (this.key = 'waypoint-' + e),
          (this.options = t.Adapter.extend({}, t.defaults, i)),
          (this.element = this.options.element),
          (this.adapter = new t.Adapter(this.element)),
          (this.callback = i.handler),
          (this.axis = this.options.horizontal ? 'horizontal' : 'vertical'),
          (this.enabled = this.options.enabled),
          (this.triggerPoint = null),
          (this.group = t.Group.findOrCreate({
            name: this.options.group,
            axis: this.axis,
          })),
          (this.context = t.Context.findOrCreateByElement(
            this.options.context
          )),
          t.offsetAliases[this.options.offset] &&
            (this.options.offset = t.offsetAliases[this.options.offset]),
          this.group.add(this),
          this.context.add(this),
          (n[this.key] = this),
          (e += 1);
      }

      var e = 0,
        n = {};
      (t.prototype.queueTrigger = function (t) {
        this.group.queueTrigger(this, t);
      }),
        (t.prototype.trigger = function (t) {
          this.enabled && this.callback && this.callback.apply(this, t);
        }),
        (t.prototype.destroy = function () {
          this.context.remove(this),
            this.group.remove(this),
            delete n[this.key];
        }),
        (t.prototype.disable = function () {
          return (this.enabled = !1), this;
        }),
        (t.prototype.enable = function () {
          return this.context.refresh(), (this.enabled = !0), this;
        }),
        (t.prototype.next = function () {
          return this.group.next(this);
        }),
        (t.prototype.previous = function () {
          return this.group.previous(this);
        }),
        (t.invokeAll = function (t) {
          var e = [];
          for (var i in n) e.push(n[i]);
          for (var o = 0, r = e.length; r > o; o++) e[o][t]();
        }),
        (t.destroyAll = function () {
          t.invokeAll('destroy');
        }),
        (t.disableAll = function () {
          t.invokeAll('disable');
        }),
        (t.enableAll = function () {
          for (var e in (t.Context.refreshAll(), n)) n[e].enabled = !0;
          return this;
        }),
        (t.refreshAll = function () {
          t.Context.refreshAll();
        }),
        (t.viewportHeight = function () {
          return window.innerHeight || document.documentElement.clientHeight;
        }),
        (t.viewportWidth = function () {
          return document.documentElement.clientWidth;
        }),
        (t.adapters = []),
        (t.defaults = {
          context: window,
          continuous: !0,
          enabled: !0,
          group: 'default',
          horizontal: !1,
          offset: 0,
        }),
        (t.offsetAliases = {
          'bottom-in-view': function () {
            return this.context.innerHeight() - this.adapter.outerHeight();
          },
          'right-in-view': function () {
            return this.context.innerWidth() - this.adapter.outerWidth();
          },
        }),
        (window.Waypoint = t);
    })(),
      (function () {
        'use strict';

        function t(t) {
          window.setTimeout(t, 1e3 / 60);
        }

        function e(t) {
          (this.element = t),
            (this.Adapter = o.Adapter),
            (this.adapter = new this.Adapter(t)),
            (this.key = 'waypoint-context-' + n),
            (this.didScroll = !1),
            (this.didResize = !1),
            (this.oldScroll = {
              x: this.adapter.scrollLeft(),
              y: this.adapter.scrollTop(),
            }),
            (this.waypoints = {
              vertical: {},
              horizontal: {},
            }),
            (t.waypointContextKey = this.key),
            (i[t.waypointContextKey] = this),
            (n += 1),
            o.windowContext ||
              ((o.windowContext = !0), (o.windowContext = new e(window))),
            this.createThrottledScrollHandler(),
            this.createThrottledResizeHandler();
        }

        var n = 0,
          i = {},
          o = window.Waypoint,
          r = window.onload;
        (e.prototype.add = function (t) {
          var e = t.options.horizontal ? 'horizontal' : 'vertical';
          (this.waypoints[e][t.key] = t), this.refresh();
        }),
          (e.prototype.checkEmpty = function () {
            var t = this.Adapter.isEmptyObject(this.waypoints.horizontal),
              e = this.Adapter.isEmptyObject(this.waypoints.vertical),
              n = this.element == this.element.window;
            t &&
              e &&
              !n &&
              (this.adapter.off('.waypoints'), delete i[this.key]);
          }),
          (e.prototype.createThrottledResizeHandler = function () {
            function t() {
              e.handleResize(), (e.didResize = !1);
            }

            var e = this;
            this.adapter.on('resize.waypoints', function () {
              e.didResize || ((e.didResize = !0), o.requestAnimationFrame(t));
            });
          }),
          (e.prototype.createThrottledScrollHandler = function () {
            function t() {
              e.handleScroll(), (e.didScroll = !1);
            }

            var e = this;
            this.adapter.on('scroll.waypoints', function () {
              (!e.didScroll || o.isTouch) &&
                ((e.didScroll = !0), o.requestAnimationFrame(t));
            });
          }),
          (e.prototype.handleResize = function () {
            o.Context.refreshAll();
          }),
          (e.prototype.handleScroll = function () {
            var t = {},
              e = {
                horizontal: {
                  newScroll: this.adapter.scrollLeft(),
                  oldScroll: this.oldScroll.x,
                  forward: 'right',
                  backward: 'left',
                },
                vertical: {
                  newScroll: this.adapter.scrollTop(),
                  oldScroll: this.oldScroll.y,
                  forward: 'down',
                  backward: 'up',
                },
              };
            for (var n in e) {
              var i = e[n],
                o = i.newScroll > i.oldScroll ? i.forward : i.backward;
              for (var r in this.waypoints[n]) {
                var s = this.waypoints[n][r];
                if (null !== s.triggerPoint) {
                  var a = i.oldScroll < s.triggerPoint,
                    l = i.newScroll >= s.triggerPoint;
                  ((a && l) || (!a && !l)) &&
                    (s.queueTrigger(o), (t[s.group.id] = s.group));
                }
              }
            }
            for (var c in t) t[c].flushTriggers();
            this.oldScroll = {
              x: e.horizontal.newScroll,
              y: e.vertical.newScroll,
            };
          }),
          (e.prototype.innerHeight = function () {
            return this.element == this.element.window
              ? o.viewportHeight()
              : this.adapter.innerHeight();
          }),
          (e.prototype.remove = function (t) {
            delete this.waypoints[t.axis][t.key], this.checkEmpty();
          }),
          (e.prototype.innerWidth = function () {
            return this.element == this.element.window
              ? o.viewportWidth()
              : this.adapter.innerWidth();
          }),
          (e.prototype.destroy = function () {
            var t = [];
            for (var e in this.waypoints)
              for (var n in this.waypoints[e]) t.push(this.waypoints[e][n]);
            for (var i = 0, o = t.length; o > i; i++) t[i].destroy();
          }),
          (e.prototype.refresh = function () {
            var t,
              e = this.element == this.element.window,
              n = e ? void 0 : this.adapter.offset(),
              i = {};
            for (var r in (this.handleScroll(),
            (t = {
              horizontal: {
                contextOffset: e ? 0 : n.left,
                contextScroll: e ? 0 : this.oldScroll.x,
                contextDimension: this.innerWidth(),
                oldScroll: this.oldScroll.x,
                forward: 'right',
                backward: 'left',
                offsetProp: 'left',
              },
              vertical: {
                contextOffset: e ? 0 : n.top,
                contextScroll: e ? 0 : this.oldScroll.y,
                contextDimension: this.innerHeight(),
                oldScroll: this.oldScroll.y,
                forward: 'down',
                backward: 'up',
                offsetProp: 'top',
              },
            }))) {
              var s = t[r];
              for (var a in this.waypoints[r]) {
                var l,
                  c,
                  u,
                  d,
                  h = this.waypoints[r][a],
                  f = h.options.offset,
                  p = h.triggerPoint,
                  g = 0,
                  m = null == p;
                h.element !== h.element.window &&
                  (g = h.adapter.offset()[s.offsetProp]),
                  'function' == typeof f
                    ? (f = f.apply(h))
                    : 'string' == typeof f &&
                      ((f = parseFloat(f)),
                      h.options.offset.indexOf('%') > -1 &&
                        (f = Math.ceil((s.contextDimension * f) / 100))),
                  (l = s.contextScroll - s.contextOffset),
                  (h.triggerPoint = Math.floor(g + l - f)),
                  (c = p < s.oldScroll),
                  (u = h.triggerPoint >= s.oldScroll),
                  (d = !c && !u),
                  !m && c && u
                    ? (h.queueTrigger(s.backward), (i[h.group.id] = h.group))
                    : !m && d
                    ? (h.queueTrigger(s.forward), (i[h.group.id] = h.group))
                    : m &&
                      s.oldScroll >= h.triggerPoint &&
                      (h.queueTrigger(s.forward), (i[h.group.id] = h.group));
              }
            }
            return (
              o.requestAnimationFrame(function () {
                for (var t in i) i[t].flushTriggers();
              }),
              this
            );
          }),
          (e.findOrCreateByElement = function (t) {
            return e.findByElement(t) || new e(t);
          }),
          (e.refreshAll = function () {
            for (var t in i) i[t].refresh();
          }),
          (e.findByElement = function (t) {
            return i[t.waypointContextKey];
          }),
          (window.onload = function () {
            r && r(), e.refreshAll();
          }),
          (o.requestAnimationFrame = function (e) {
            (
              window.requestAnimationFrame ||
              window.mozRequestAnimationFrame ||
              window.webkitRequestAnimationFrame ||
              t
            ).call(window, e);
          }),
          (o.Context = e);
      })(),
      (function () {
        'use strict';

        function t(t, e) {
          return t.triggerPoint - e.triggerPoint;
        }

        function e(t, e) {
          return e.triggerPoint - t.triggerPoint;
        }

        function n(t) {
          (this.name = t.name),
            (this.axis = t.axis),
            (this.id = this.name + '-' + this.axis),
            (this.waypoints = []),
            this.clearTriggerQueues(),
            (i[this.axis][this.name] = this);
        }

        var i = { vertical: {}, horizontal: {} },
          o = window.Waypoint;
        (n.prototype.add = function (t) {
          this.waypoints.push(t);
        }),
          (n.prototype.clearTriggerQueues = function () {
            this.triggerQueues = { up: [], down: [], left: [], right: [] };
          }),
          (n.prototype.flushTriggers = function () {
            for (var n in this.triggerQueues) {
              var i = this.triggerQueues[n],
                o = 'up' === n || 'left' === n;
              i.sort(o ? e : t);
              for (var r = 0, s = i.length; s > r; r += 1) {
                var a = i[r];
                (a.options.continuous || r === i.length - 1) && a.trigger([n]);
              }
            }
            this.clearTriggerQueues();
          }),
          (n.prototype.next = function (e) {
            this.waypoints.sort(t);
            var n = o.Adapter.inArray(e, this.waypoints);
            return n === this.waypoints.length - 1
              ? null
              : this.waypoints[n + 1];
          }),
          (n.prototype.previous = function (e) {
            this.waypoints.sort(t);
            var n = o.Adapter.inArray(e, this.waypoints);
            return n ? this.waypoints[n - 1] : null;
          }),
          (n.prototype.queueTrigger = function (t, e) {
            this.triggerQueues[e].push(t);
          }),
          (n.prototype.remove = function (t) {
            var e = o.Adapter.inArray(t, this.waypoints);
            e > -1 && this.waypoints.splice(e, 1);
          }),
          (n.prototype.first = function () {
            return this.waypoints[0];
          }),
          (n.prototype.last = function () {
            return this.waypoints[this.waypoints.length - 1];
          }),
          (n.findOrCreate = function (t) {
            return i[t.axis][t.name] || new n(t);
          }),
          (o.Group = n);
      })(),
      (function () {
        'use strict';

        function t(t) {
          this.$element = e(t);
        }

        var e = window.jQuery,
          n = window.Waypoint;
        e.each(
          [
            'innerHeight',
            'innerWidth',
            'off',
            'offset',
            'on',
            'outerHeight',
            'outerWidth',
            'scrollLeft',
            'scrollTop',
          ],
          function (e, n) {
            t.prototype[n] = function () {
              var t = Array.prototype.slice.call(arguments);
              return this.$element[n].apply(this.$element, t);
            };
          }
        ),
          e.each(['extend', 'inArray', 'isEmptyObject'], function (n, i) {
            t[i] = e[i];
          }),
          n.adapters.push({ name: 'jquery', Adapter: t }),
          (n.Adapter = t);
      })(),
      (function () {
        'use strict';

        function t(t) {
          return function () {
            var n = [],
              i = arguments[0];
            return (
              t.isFunction(arguments[0]) &&
                ((i = t.extend({}, arguments[1])).handler = arguments[0]),
              this.each(function () {
                var o = t.extend({}, i, { element: this });
                'string' == typeof o.context &&
                  (o.context = t(this).closest(o.context)[0]),
                  n.push(new e(o));
              }),
              n
            );
          };
        }

        var e = window.Waypoint;
        window.jQuery && (window.jQuery.fn.waypoint = t(window.jQuery)),
          window.Zepto && (window.Zepto.fn.waypoint = t(window.Zepto));
      })();
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 });
    var i = (function (t) {
      return t && t.__esModule ? t : { default: t };
    })(n(0));
    n(9);
    var o = { $element: void 0, classes: { entered: 'entered' } };
    !(function () {
      function t() {}

      var e = window.Waypoint;

      function n(t) {
        (this.options = e.Adapter.extend({}, n.defaults, t)),
          (this.axis = this.options.horizontal ? 'horizontal' : 'vertical'),
          (this.waypoints = []),
          (this.element = this.options.element),
          this.createWaypoints();
      }

      (n.prototype.createWaypoints = function () {
        for (
          var t = {
              vertical: [
                { down: 'enter', up: 'exited', offset: '100%' },
                {
                  down: 'entered',
                  up: 'exit',
                  offset: function () {
                    var t,
                      e = this.options.context.outerWidth;
                    return e > this.options.offset.desktop.minWidth
                      ? ((t =
                          (this.options.offset &&
                            this.options.offset.desktop.bottom) ||
                          0),
                        this.options.context.innerHeight -
                          this.element.outerHeight() -
                          t)
                      : e > this.options.offset.tablet.minWidth
                      ? ((t =
                          (this.options.offset &&
                            this.options.offset.tablet.bottom) ||
                          0),
                        this.options.context.innerHeight -
                          this.element.outerHeight() -
                          t)
                      : ((t =
                          (this.options.offset &&
                            this.options.offset.mobile.bottom) ||
                          0),
                        this.options.context.innerHeight -
                          this.element.outerHeight() -
                          t);
                  }.bind(this),
                },
                {
                  down: 'exit',
                  up: 'entered',
                  offset: function () {
                    var t = this.options.context.outerWidth;
                    return -(t > this.options.offset.desktop.minWidth
                      ? (this.options.offset &&
                          this.options.offset.desktop.top) ||
                        0
                      : t > this.options.offset.tablet.minWidth
                      ? (this.options.offset &&
                          this.options.offset.tablet.top) ||
                        0
                      : (this.options.offset &&
                          this.options.offset.mobile.top) ||
                        0);
                  }.bind(this),
                },
                {
                  down: 'exited',
                  up: 'enter',
                  offset: function () {
                    var t,
                      e = this.options.context.outerWidth;
                    return (
                      (t =
                        e > this.options.offset.desktop.minWidth
                          ? (this.options.offset &&
                              this.options.offset.desktop.top) ||
                            0
                          : e > this.options.offset.tablet.minWidth
                          ? (this.options.offset &&
                              this.options.offset.tablet.top) ||
                            0
                          : (this.options.offset &&
                              this.options.offset.mobile.top) ||
                            0),
                      -(this.element.outerHeight() + t)
                    );
                  }.bind(this),
                },
              ],
              horizontal: [
                { right: 'enter', left: 'exited', offset: '100%' },
                {
                  right: 'entered',
                  left: 'exit',
                  offset: 'right-in-view',
                },
                { right: 'exit', left: 'entered', offset: 0 },
                {
                  right: 'exited',
                  left: 'enter',
                  offset: function () {
                    return -this.adapter.outerWidth();
                  },
                },
              ],
            },
            e = 0,
            n = t[this.axis].length;
          e < n;
          e++
        ) {
          var i = t[this.axis][e];
          this.createWaypoint(i);
        }
      }),
        (n.prototype.createWaypoint = function (t) {
          var n = this;
          this.waypoints.push(
            new e({
              context: this.options.context,
              element: this.options.element,
              enabled: this.options.enabled,
              handler: (function (t) {
                return function (e) {
                  n.options[t[e]].call(n, e);
                };
              })(t),
              offset: t.offset,
              horizontal: this.options.horizontal,
            })
          );
        }),
        (n.prototype.destroy = function () {
          for (var t = 0, e = this.waypoints.length; t < e; t++)
            this.waypoints[t].destroy();
          this.waypoints = [];
        }),
        (n.prototype.disable = function () {
          for (var t = 0, e = this.waypoints.length; t < e; t++)
            this.waypoints[t].disable();
        }),
        (n.prototype.enable = function () {
          for (var t = 0, e = this.waypoints.length; t < e; t++)
            this.waypoints[t].enable();
        }),
        (n.defaults = {
          context: window,
          enabled: !0,
          enter: t,
          entered: t,
          exit: t,
          exited: t,
        }),
        (e.Inview = n);
    })();
    var r = (function () {
      function t() {
        var e =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !(function (t, e) {
          if (!(t instanceof e))
            throw new TypeError('Cannot call a class as a function');
        })(this, t);
        var n = i.default.extend(!0, {}, o, e);
        (this.$element = n.$element), (this.classes = n.classes);
      }

      return (
        (t.prototype.init = function () {
          var t = this;
       
          new Waypoint.Inview({
            element: t.$element,
            enter: function () {},
            entered: function () {
              (0, i.default)(t.$element).addClass(t.classes.entered);
            },
            exit: function () {},
            exited: function () {
              (0, i.default)(t.$element).removeClass(t.classes.entered);
            },
            offset: {
              desktop: { minWidth: 1025, top: 70, bottom: 70 },
              tablet: { minWidth: 641, top: 70, bottom: 70 },
              mobile: { minWidth: 0, top: 140, bottom: 140 },
            },
          });
        }),
        t
      );
    })();
    e.default = r;
  },
  function (t, e, n) {
    !(function (e) {
      'use strict';
      'object' == typeof t && 'object' == typeof t.exports
        ? (t.exports = e(n(0)))
        : e(jQuery);
    })(function (t) {
      'use strict';
      var e = !1,
        n = function () {
          e = !1;
        },
        i = function (t, e) {
          return t.css({ 'background-position': 'center ' + -e + 'px' });
        },
        o = function (t, e) {
          return t.css({ 'background-position': -e + 'px center' });
        },
        r = function (t, e, n) {
          return (
            'none' !== n || (n = ''),
            t.css({
              '-webkit-transform': 'translateY(' + e + 'px)' + n,
              '-moz-transform': 'translateY(' + e + 'px)' + n,
              transform: 'translateY(' + e + 'px)' + n,
              transition: 'transform linear',
              'will-change': 'transform',
            })
          );
        },
        s = function (t, e, n) {
          return (
            'none' !== n || (n = ''),
            t.css({
              '-webkit-transform': 'translateX(' + e + 'px)' + n,
              '-moz-transform': 'translateX(' + e + 'px)' + n,
              transform: 'translateX(' + e + 'px)' + n,
              transition: 'transform linear',
              'will-change': 'transform',
            })
          );
        },
        a = function (t, e, n) {
          var i = t.data('paroller-factor'),
            o = i || n.factor;
          if (e < 576) {
            var r = t.data('paroller-factor-xs'),
              s = r || n.factorXs;
            return s || o;
          }
          if (e <= 768) {
            var a = t.data('paroller-factor-sm'),
              l = a || n.factorSm;
            return l || o;
          }
          if (e <= 1024) {
            var c = t.data('paroller-factor-md'),
              u = c || n.factorMd;
            return u || o;
          }
          if (e <= 1200) {
            var d = t.data('paroller-factor-lg'),
              h = d || n.factorLg;
            return h || o;
          }
          if (e <= 1920) {
            var f = t.data('paroller-factor-xl'),
              p = f || n.factorXl;
            return p || o;
          }
          return o;
        },
        l = function (t, e) {
          return Math.round(t * e);
        },
        c = function (t, e, n, i) {
          return Math.round((t - n / 2 + i) * e);
        },
        u = function (t) {
          return t.css({ 'background-position': 'unset' });
        },
        d = function (t) {
          return t.css({ transform: 'unset', transition: 'unset' });
        };
      t.fn.paroller = function (h) {
        var f = t(window).height(),
          p = t(document).height();
        h = t.extend(
          {
            factor: 0,
            factorXs: 0,
            factorSm: 0,
            factorMd: 0,
            factorLg: 0,
            factorXl: 0,
            type: 'background',
            direction: 'vertical',
          },
          h
        );
        return this.each(function () {
          var g = t(this),
            m = t(window).width(),
            v = g.offset().top,
            y = g.outerHeight(),
            w = g.data('paroller-type'),
            x = g.data('paroller-direction'),
            b = g.css('transform'),
            _ = w || h.type,
            C = x || h.direction,
            T = a(g, m, h),
            k = l(v, T),
            E = c(v, T, f, y);
          'background' === _
            ? 'vertical' === C
              ? i(g, k)
              : 'horizontal' === C && o(g, k)
            : 'foreground' === _ &&
              ('vertical' === C
                ? r(g, E, b)
                : 'horizontal' === C && s(g, E, b)),
            t(window).on('resize', function () {
              var l = t(this).scrollTop();
              (m = t(window).width()),
                (v = g.offset().top),
                (y = g.outerHeight()),
                (T = a(g, m, h)),
                (k = Math.round(v * T)),
                (E = Math.round((v - f / 2 + y) * T)),
                e || (window.requestAnimationFrame(n), (e = !0)),
                'background' === _
                  ? (u(g),
                    'vertical' === C ? i(g, k) : 'horizontal' === C && o(g, k))
                  : 'foreground' === _ &&
                    l <= p &&
                    (d(g),
                    'vertical' === C ? r(g, E) : 'horizontal' === C && s(g, E));
            }),
            t(window).on('scroll', function () {
              var a = t(this).scrollTop();
              (p = t(document).height()),
                (k = Math.round((v - a) * T)),
                (E = Math.round((v - f / 2 + y - a) * T)),
                e || (window.requestAnimationFrame(n), (e = !0)),
                'background' === _
                  ? 'vertical' === C
                    ? i(g, k)
                    : 'horizontal' === C && o(g, k)
                  : 'foreground' === _ &&
                    a <= p &&
                    ('vertical' === C
                      ? r(g, E, b)
                      : 'horizontal' === C && s(g, E, b));
            });
        });
      };
    });
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 });
    var i = (function (t) {
      return t && t.__esModule ? t : { default: t };
    })(n(0));
    n(11);
    var o = { $element: void 0, classes: {} },
      r = (function () {
        function t() {
          var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          !(function (t, e) {
            if (!(t instanceof e))
              throw new TypeError('Cannot call a class as a function');
          })(this, t);
          var n = i.default.extend(!0, {}, o, e);
          (this.$element = n.$element), (this.classes = n.classes);
        }

        return (
          (t.prototype.init = function () {
            var t = this;
            (0, i.default)(window).on('load', function () {
              t.$element.paroller(), (0, i.default)(window).trigger('resize');
            });
          }),
          t
        );
      })();
    e.default = r;
  },
  function (t, e) {
    !(function (t, e, n, i) {
      function o(e, n) {
        (this.settings = null),
          (this.options = t.extend({}, o.Defaults, n)),
          (this.$element = t(e)),
          (this._handlers = {}),
          (this._plugins = {}),
          (this._supress = {}),
          (this._current = null),
          (this._speed = null),
          (this._coordinates = []),
          (this._breakpoint = null),
          (this._width = null),
          (this._items = []),
          (this._clones = []),
          (this._mergers = []),
          (this._widths = []),
          (this._invalidated = {}),
          (this._pipe = []),
          (this._drag = {
            time: null,
            target: null,
            pointer: null,
            stage: { start: null, current: null },
            direction: null,
          }),
          (this._states = {
            current: {},
            tags: {
              initializing: ['busy'],
              animating: ['busy'],
              dragging: ['interacting'],
            },
          }),
          t.each(
            ['onResize', 'onThrottledResize'],
            t.proxy(function (e, n) {
              this._handlers[n] = t.proxy(this[n], this);
            }, this)
          ),
          t.each(
            o.Plugins,
            t.proxy(function (t, e) {
              this._plugins[t.charAt(0).toLowerCase() + t.slice(1)] = new e(
                this
              );
            }, this)
          ),
          t.each(
            o.Workers,
            t.proxy(function (e, n) {
              this._pipe.push({ filter: n.filter, run: t.proxy(n.run, this) });
            }, this)
          ),
          this.setup(),
          this.initialize();
      }

      (o.Defaults = {
        items: 3,
        loop: !1,
        center: !1,
        rewind: !1,
        checkVisibility: !0,
        mouseDrag: !0,
        touchDrag: !0,
        pullDrag: !0,
        freeDrag: !1,
        margin: 0,
        stagePadding: 0,
        merge: !1,
        mergeFit: !0,
        autoWidth: !1,
        startPosition: 0,
        rtl: !1,
        smartSpeed: 250,
        fluidSpeed: !1,
        dragEndSpeed: !1,
        responsive: {},
        responsiveRefreshRate: 200,
        responsiveBaseElement: e,
        fallbackEasing: 'swing',
        slideTransition: '',
        info: !1,
        nestedItemSelector: !1,
        itemElement: 'div',
        stageElement: 'div',
        refreshClass: 'owl-refresh',
        loadedClass: 'owl-loaded',
        loadingClass: 'owl-loading',
        rtlClass: 'owl-rtl',
        responsiveClass: 'owl-responsive',
        dragClass: 'owl-drag',
        itemClass: 'owl-item',
        stageClass: 'owl-stage',
        stageOuterClass: 'owl-stage-outer',
        grabClass: 'owl-grab',
      }),
        (o.Width = { Default: 'default', Inner: 'inner', Outer: 'outer' }),
        (o.Type = {
          Event: 'event',
          State: 'state',
        }),
        (o.Plugins = {}),
        (o.Workers = [
          {
            filter: ['width', 'settings'],
            run: function () {
              this._width = this.$element.width();
            },
          },
          {
            filter: ['width', 'items', 'settings'],
            run: function (t) {
              t.current =
                this._items && this._items[this.relative(this._current)];
            },
          },
          {
            filter: ['items', 'settings'],
            run: function () {
              this.$stage.children('.cloned').remove();
            },
          },
          {
            filter: ['width', 'items', 'settings'],
            run: function (t) {
              var e = this.settings.margin || '',
                n = !this.settings.autoWidth,
                i = this.settings.rtl,
                o = {
                  width: 'auto',
                  'margin-left': i ? e : '',
                  'margin-right': i ? '' : e,
                };
              !n && this.$stage.children().css(o), (t.css = o);
            },
          },
          {
            filter: ['width', 'items', 'settings'],
            run: function (t) {
              var e =
                  (this.width() / this.settings.items).toFixed(3) -
                  this.settings.margin,
                n = null,
                i = this._items.length,
                o = !this.settings.autoWidth,
                r = [];
              for (
                t.items = {
                  merge: !1,
                  width: e,
                };
                i--;

              )
                (n = this._mergers[i]),
                  (n =
                    (this.settings.mergeFit &&
                      Math.min(n, this.settings.items)) ||
                    n),
                  (t.items.merge = n > 1 || t.items.merge),
                  (r[i] = o ? e * n : this._items[i].width());
              this._widths = r;
            },
          },
          {
            filter: ['items', 'settings'],
            run: function () {
              var e = [],
                n = this._items,
                i = this.settings,
                o = Math.max(2 * i.items, 4),
                r = 2 * Math.ceil(n.length / 2),
                s = i.loop && n.length ? (i.rewind ? o : Math.max(o, r)) : 0,
                a = '',
                l = '';
              for (s /= 2; s > 0; )
                e.push(this.normalize(e.length / 2, !0)),
                  (a += n[e[e.length - 1]][0].outerHTML),
                  e.push(this.normalize(n.length - 1 - (e.length - 1) / 2, !0)),
                  (l = n[e[e.length - 1]][0].outerHTML + l),
                  (s -= 1);
              (this._clones = e),
                t(a).addClass('cloned').appendTo(this.$stage),
                t(l).addClass('cloned').prependTo(this.$stage);
            },
          },
          {
            filter: ['width', 'items', 'settings'],
            run: function () {
              for (
                var t = this.settings.rtl ? 1 : -1,
                  e = this._clones.length + this._items.length,
                  n = -1,
                  i = 0,
                  o = 0,
                  r = [];
                ++n < e;

              )
                (i = r[n - 1] || 0),
                  (o = this._widths[this.relative(n)] + this.settings.margin),
                  r.push(i + o * t);
              this._coordinates = r;
            },
          },
          {
            filter: ['width', 'items', 'settings'],
            run: function () {
              var t = this.settings.stagePadding,
                e = this._coordinates,
                n = {
                  width: Math.ceil(Math.abs(e[e.length - 1])) + 2 * t,
                  'padding-left': t || '',
                  'padding-right': t || '',
                };
              this.$stage.css(n);
            },
          },
          {
            filter: ['width', 'items', 'settings'],
            run: function (t) {
              var e = this._coordinates.length,
                n = !this.settings.autoWidth,
                i = this.$stage.children();
              if (n && t.items.merge)
                for (; e--; )
                  (t.css.width = this._widths[this.relative(e)]),
                    i.eq(e).css(t.css);
              else n && ((t.css.width = t.items.width), i.css(t.css));
            },
          },
          {
            filter: ['items'],
            run: function () {
              this._coordinates.length < 1 && this.$stage.removeAttr('style');
            },
          },
          {
            filter: ['width', 'items', 'settings'],
            run: function (t) {
              (t.current = t.current
                ? this.$stage.children().index(t.current)
                : 0),
                (t.current = Math.max(
                  this.minimum(),
                  Math.min(this.maximum(), t.current)
                )),
                this.reset(t.current);
            },
          },
          {
            filter: ['position'],
            run: function () {
              this.animate(this.coordinates(this._current));
            },
          },
          {
            filter: ['width', 'position', 'items', 'settings'],
            run: function () {
              var t,
                e,
                n,
                i,
                o = this.settings.rtl ? 1 : -1,
                r = 2 * this.settings.stagePadding,
                s = this.coordinates(this.current()) + r,
                a = s + this.width() * o,
                l = [];
              for (n = 0, i = this._coordinates.length; n < i; n++)
                (t = this._coordinates[n - 1] || 0),
                  (e = Math.abs(this._coordinates[n]) + r * o),
                  ((this.op(t, '<=', s) && this.op(t, '>', a)) ||
                    (this.op(e, '<', s) && this.op(e, '>', a))) &&
                    l.push(n);
              this.$stage.children('.active').removeClass('active'),
                this.$stage
                  .children(':eq(' + l.join('), :eq(') + ')')
                  .addClass('active'),
                this.$stage.children('.center').removeClass('center'),
                this.settings.center &&
                  this.$stage.children().eq(this.current()).addClass('center');
            },
          },
        ]),
        (o.prototype.initializeStage = function () {
          (this.$stage = this.$element.find('.' + this.settings.stageClass)),
            this.$stage.length ||
              (this.$element.addClass(this.options.loadingClass),
              (this.$stage = t('<' + this.settings.stageElement + '>', {
                class: this.settings.stageClass,
              }).wrap(t('<div/>', { class: this.settings.stageOuterClass }))),
              this.$element.append(this.$stage.parent()));
        }),
        (o.prototype.initializeItems = function () {
          var e = this.$element.find('.owl-item');
          if (e.length)
            return (
              (this._items = e.get().map(function (e) {
                return t(e);
              })),
              (this._mergers = this._items.map(function () {
                return 1;
              })),
              void this.refresh()
            );
          this.replace(this.$element.children().not(this.$stage.parent())),
            this.isVisible() ? this.refresh() : this.invalidate('width'),
            this.$element
              .removeClass(this.options.loadingClass)
              .addClass(this.options.loadedClass);
        }),
        (o.prototype.initialize = function () {
          var t, e, n;
          (this.enter('initializing'),
          this.trigger('initialize'),
          this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl),
          this.settings.autoWidth && !this.is('pre-loading')) &&
            ((t = this.$element.find('img')),
            (e = this.settings.nestedItemSelector
              ? '.' + this.settings.nestedItemSelector
              : void 0),
            (n = this.$element.children(e).width()),
            t.length && n <= 0 && this.preloadAutoWidthImages(t));
          this.initializeStage(),
            this.initializeItems(),
            this.registerEventHandlers(),
            this.leave('initializing'),
            this.trigger('initialized');
        }),
        (o.prototype.isVisible = function () {
          return !this.settings.checkVisibility || this.$element.is(':visible');
        }),
        (o.prototype.setup = function () {
          var e = this.viewport(),
            n = this.options.responsive,
            i = -1,
            o = null;
          n
            ? (t.each(n, function (t) {
                t <= e && t > i && (i = Number(t));
              }),
              'function' ==
                typeof (o = t.extend({}, this.options, n[i])).stagePadding &&
                (o.stagePadding = o.stagePadding()),
              delete o.responsive,
              o.responsiveClass &&
                this.$element.attr(
                  'class',
                  this.$element
                    .attr('class')
                    .replace(
                      new RegExp(
                        '(' + this.options.responsiveClass + '-)\\S+\\s',
                        'g'
                      ),
                      '$1' + i
                    )
                ))
            : (o = t.extend({}, this.options)),
            this.trigger('change', {
              property: {
                name: 'settings',
                value: o,
              },
            }),
            (this._breakpoint = i),
            (this.settings = o),
            this.invalidate('settings'),
            this.trigger('changed', {
              property: {
                name: 'settings',
                value: this.settings,
              },
            });
        }),
        (o.prototype.optionsLogic = function () {
          this.settings.autoWidth &&
            ((this.settings.stagePadding = !1), (this.settings.merge = !1));
        }),
        (o.prototype.prepare = function (e) {
          var n = this.trigger('prepare', { content: e });
          return (
            n.data ||
              (n.data = t('<' + this.settings.itemElement + '/>')
                .addClass(this.options.itemClass)
                .append(e)),
            this.trigger('prepared', { content: n.data }),
            n.data
          );
        }),
        (o.prototype.update = function () {
          for (
            var e = 0,
              n = this._pipe.length,
              i = t.proxy(function (t) {
                return this[t];
              }, this._invalidated),
              o = {};
            e < n;

          )
            (this._invalidated.all ||
              t.grep(this._pipe[e].filter, i).length > 0) &&
              this._pipe[e].run(o),
              e++;
          (this._invalidated = {}), !this.is('valid') && this.enter('valid');
        }),
        (o.prototype.width = function (t) {
          switch ((t = t || o.Width.Default)) {
            case o.Width.Inner:
            case o.Width.Outer:
              return this._width;
            default:
              return (
                this._width -
                2 * this.settings.stagePadding +
                this.settings.margin
              );
          }
        }),
        (o.prototype.refresh = function () {
          this.enter('refreshing'),
            this.trigger('refresh'),
            this.setup(),
            this.optionsLogic(),
            this.$element.addClass(this.options.refreshClass),
            this.update(),
            this.$element.removeClass(this.options.refreshClass),
            this.leave('refreshing'),
            this.trigger('refreshed');
        }),
        (o.prototype.onThrottledResize = function () {
          e.clearTimeout(this.resizeTimer),
            (this.resizeTimer = e.setTimeout(
              this._handlers.onResize,
              this.settings.responsiveRefreshRate
            ));
        }),
        (o.prototype.onResize = function () {
          return (
            !!this._items.length &&
            this._width !== this.$element.width() &&
            !!this.isVisible() &&
            (this.enter('resizing'),
            this.trigger('resize').isDefaultPrevented()
              ? (this.leave('resizing'), !1)
              : (this.invalidate('width'),
                this.refresh(),
                this.leave('resizing'),
                void this.trigger('resized')))
          );
        }),
        (o.prototype.registerEventHandlers = function () {
          t.support.transition &&
            this.$stage.on(
              t.support.transition.end + '.owl.core',
              t.proxy(this.onTransitionEnd, this)
            ),
            !1 !== this.settings.responsive &&
              this.on(e, 'resize', this._handlers.onThrottledResize),
            this.settings.mouseDrag &&
              (this.$element.addClass(this.options.dragClass),
              this.$stage.on(
                'mousedown.owl.core',
                t.proxy(this.onDragStart, this)
              ),
              this.$stage.on(
                'dragstart.owl.core selectstart.owl.core',
                function () {
                  return !1;
                }
              )),
            this.settings.touchDrag &&
              (this.$stage.on(
                'touchstart.owl.core',
                t.proxy(this.onDragStart, this)
              ),
              this.$stage.on(
                'touchcancel.owl.core',
                t.proxy(this.onDragEnd, this)
              ));
        }),
        (o.prototype.onDragStart = function (e) {
          var i = null;
          3 !== e.which &&
            (t.support.transform
              ? (i = {
                  x: (i = this.$stage
                    .css('transform')
                    .replace(/.*\(|\)| /g, '')
                    .split(','))[16 === i.length ? 12 : 4],
                  y: i[16 === i.length ? 13 : 5],
                })
              : ((i = this.$stage.position()),
                (i = {
                  x: this.settings.rtl
                    ? i.left +
                      this.$stage.width() -
                      this.width() +
                      this.settings.margin
                    : i.left,
                  y: i.top,
                })),
            this.is('animating') &&
              (t.support.transform ? this.animate(i.x) : this.$stage.stop(),
              this.invalidate('position')),
            this.$element.toggleClass(
              this.options.grabClass,
              'mousedown' === e.type
            ),
            this.speed(0),
            (this._drag.time = new Date().getTime()),
            (this._drag.target = t(e.target)),
            (this._drag.stage.start = i),
            (this._drag.stage.current = i),
            (this._drag.pointer = this.pointer(e)),
            t(n).on(
              'mouseup.owl.core touchend.owl.core',
              t.proxy(this.onDragEnd, this)
            ),
            t(n).one(
              'mousemove.owl.core touchmove.owl.core',
              t.proxy(function (e) {
                var i = this.difference(this._drag.pointer, this.pointer(e));
                t(n).on(
                  'mousemove.owl.core touchmove.owl.core',
                  t.proxy(this.onDragMove, this)
                ),
                  (Math.abs(i.x) < Math.abs(i.y) && this.is('valid')) ||
                    (e.preventDefault(),
                    this.enter('dragging'),
                    this.trigger('drag'));
              }, this)
            ));
        }),
        (o.prototype.onDragMove = function (t) {
          var e = null,
            n = null,
            i = null,
            o = this.difference(this._drag.pointer, this.pointer(t)),
            r = this.difference(this._drag.stage.start, o);
          this.is('dragging') &&
            (t.preventDefault(),
            this.settings.loop
              ? ((e = this.coordinates(this.minimum())),
                (n = this.coordinates(this.maximum() + 1) - e),
                (r.x = ((((r.x - e) % n) + n) % n) + e))
              : ((e = this.settings.rtl
                  ? this.coordinates(this.maximum())
                  : this.coordinates(this.minimum())),
                (n = this.settings.rtl
                  ? this.coordinates(this.minimum())
                  : this.coordinates(this.maximum())),
                (i = this.settings.pullDrag ? (-1 * o.x) / 5 : 0),
                (r.x = Math.max(Math.min(r.x, e + i), n + i))),
            (this._drag.stage.current = r),
            this.animate(r.x));
        }),
        (o.prototype.onDragEnd = function (e) {
          var i = this.difference(this._drag.pointer, this.pointer(e)),
            o = this._drag.stage.current,
            r = (i.x > 0) ^ this.settings.rtl ? 'left' : 'right';
          t(n).off('.owl.core'),
            this.$element.removeClass(this.options.grabClass),
            ((0 !== i.x && this.is('dragging')) || !this.is('valid')) &&
              (this.speed(
                this.settings.dragEndSpeed || this.settings.smartSpeed
              ),
              this.current(
                this.closest(o.x, 0 !== i.x ? r : this._drag.direction)
              ),
              this.invalidate('position'),
              this.update(),
              (this._drag.direction = r),
              (Math.abs(i.x) > 3 ||
                new Date().getTime() - this._drag.time > 300) &&
                this._drag.target.one('click.owl.core', function () {
                  return !1;
                })),
            this.is('dragging') &&
              (this.leave('dragging'), this.trigger('dragged'));
        }),
        (o.prototype.closest = function (e, n) {
          var i = -1,
            o = this.width(),
            r = this.coordinates();
          return (
            this.settings.freeDrag ||
              t.each(
                r,
                t.proxy(function (t, s) {
                  return (
                    'left' === n && e > s - 30 && e < s + 30
                      ? (i = t)
                      : 'right' === n && e > s - o - 30 && e < s - o + 30
                      ? (i = t + 1)
                      : this.op(e, '<', s) &&
                        this.op(
                          e,
                          '>',
                          void 0 !== r[t + 1] ? r[t + 1] : s - o
                        ) &&
                        (i = 'left' === n ? t + 1 : t),
                    -1 === i
                  );
                }, this)
              ),
            this.settings.loop ||
              (this.op(e, '>', r[this.minimum()])
                ? (i = e = this.minimum())
                : this.op(e, '<', r[this.maximum()]) &&
                  (i = e = this.maximum())),
            i
          );
        }),
        (o.prototype.animate = function (e) {
          var n = this.speed() > 0;
          this.is('animating') && this.onTransitionEnd(),
            n && (this.enter('animating'), this.trigger('translate')),
            t.support.transform3d && t.support.transition
              ? this.$stage.css({
                  transform: 'translate3d(' + e + 'px,0px,0px)',
                  transition:
                    this.speed() / 1e3 +
                    's' +
                    (this.settings.slideTransition
                      ? ' ' + this.settings.slideTransition
                      : ''),
                })
              : n
              ? this.$stage.animate(
                  { left: e + 'px' },
                  this.speed(),
                  this.settings.fallbackEasing,
                  t.proxy(this.onTransitionEnd, this)
                )
              : this.$stage.css({ left: e + 'px' });
        }),
        (o.prototype.is = function (t) {
          return this._states.current[t] && this._states.current[t] > 0;
        }),
        (o.prototype.current = function (t) {
          if (void 0 === t) return this._current;
          if (0 !== this._items.length) {
            if (((t = this.normalize(t)), this._current !== t)) {
              var e = this.trigger('change', {
                property: { name: 'position', value: t },
              });
              void 0 !== e.data && (t = this.normalize(e.data)),
                (this._current = t),
                this.invalidate('position'),
                this.trigger('changed', {
                  property: {
                    name: 'position',
                    value: this._current,
                  },
                });
            }
            return this._current;
          }
        }),
        (o.prototype.invalidate = function (e) {
          return (
            'string' === t.type(e) &&
              ((this._invalidated[e] = !0),
              this.is('valid') && this.leave('valid')),
            t.map(this._invalidated, function (t, e) {
              return e;
            })
          );
        }),
        (o.prototype.reset = function (t) {
          void 0 !== (t = this.normalize(t)) &&
            ((this._speed = 0),
            (this._current = t),
            this.suppress(['translate', 'translated']),
            this.animate(this.coordinates(t)),
            this.release(['translate', 'translated']));
        }),
        (o.prototype.normalize = function (t, e) {
          var n = this._items.length,
            i = e ? 0 : this._clones.length;
          return (
            !this.isNumeric(t) || n < 1
              ? (t = void 0)
              : (t < 0 || t >= n + i) &&
                (t = ((((t - i / 2) % n) + n) % n) + i / 2),
            t
          );
        }),
        (o.prototype.relative = function (t) {
          return (t -= this._clones.length / 2), this.normalize(t, !0);
        }),
        (o.prototype.maximum = function (t) {
          var e,
            n,
            i,
            o = this.settings,
            r = this._coordinates.length;
          if (o.loop) r = this._clones.length / 2 + this._items.length - 1;
          else if (o.autoWidth || o.merge) {
            if ((e = this._items.length))
              for (
                n = this._items[--e].width(), i = this.$element.width();
                e-- &&
                !((n += this._items[e].width() + this.settings.margin) > i);

              );
            r = e + 1;
          } else
            r = o.center
              ? this._items.length - 1
              : this._items.length - o.items;
          return t && (r -= this._clones.length / 2), Math.max(r, 0);
        }),
        (o.prototype.minimum = function (t) {
          return t ? 0 : this._clones.length / 2;
        }),
        (o.prototype.items = function (t) {
          return void 0 === t
            ? this._items.slice()
            : ((t = this.normalize(t, !0)), this._items[t]);
        }),
        (o.prototype.mergers = function (t) {
          return void 0 === t
            ? this._mergers.slice()
            : ((t = this.normalize(t, !0)), this._mergers[t]);
        }),
        (o.prototype.clones = function (e) {
          var n = this._clones.length / 2,
            i = n + this._items.length,
            o = function (t) {
              return t % 2 == 0 ? i + t / 2 : n - (t + 1) / 2;
            };
          return void 0 === e
            ? t.map(this._clones, function (t, e) {
                return o(e);
              })
            : t.map(this._clones, function (t, n) {
                return t === e ? o(n) : null;
              });
        }),
        (o.prototype.speed = function (t) {
          return void 0 !== t && (this._speed = t), this._speed;
        }),
        (o.prototype.coordinates = function (e) {
          var n,
            i = 1,
            o = e - 1;
          return void 0 === e
            ? t.map(
                this._coordinates,
                t.proxy(function (t, e) {
                  return this.coordinates(e);
                }, this)
              )
            : (this.settings.center
                ? (this.settings.rtl && ((i = -1), (o = e + 1)),
                  (n = this._coordinates[e]),
                  (n +=
                    ((this.width() - n + (this._coordinates[o] || 0)) / 2) * i))
                : (n = this._coordinates[o] || 0),
              (n = Math.ceil(n)));
        }),
        (o.prototype.duration = function (t, e, n) {
          return 0 === n
            ? 0
            : Math.min(Math.max(Math.abs(e - t), 1), 6) *
                Math.abs(n || this.settings.smartSpeed);
        }),
        (o.prototype.to = function (t, e) {
          var n = this.current(),
            i = null,
            o = t - this.relative(n),
            r = (o > 0) - (o < 0),
            s = this._items.length,
            a = this.minimum(),
            l = this.maximum();
          this.settings.loop
            ? (!this.settings.rewind &&
                Math.abs(o) > s / 2 &&
                (o += -1 * r * s),
              (i = (((((t = n + o) - a) % s) + s) % s) + a) !== t &&
                i - o <= l &&
                i - o > 0 &&
                ((n = i - o), (t = i), this.reset(n)))
            : (t = this.settings.rewind
                ? ((t % (l += 1)) + l) % l
                : Math.max(a, Math.min(l, t))),
            this.speed(this.duration(n, t, e)),
            this.current(t),
            this.isVisible() && this.update();
        }),
        (o.prototype.next = function (t) {
          (t = t || !1), this.to(this.relative(this.current()) + 1, t);
        }),
        (o.prototype.prev = function (t) {
          (t = t || !1), this.to(this.relative(this.current()) - 1, t);
        }),
        (o.prototype.onTransitionEnd = function (t) {
          if (
            void 0 !== t &&
            (t.stopPropagation(),
            (t.target || t.srcElement || t.originalTarget) !==
              this.$stage.get(0))
          )
            return !1;
          this.leave('animating'), this.trigger('translated');
        }),
        (o.prototype.viewport = function () {
          var i;
          return (
            this.options.responsiveBaseElement !== e
              ? (i = t(this.options.responsiveBaseElement).width())
              : e.innerWidth
              ? (i = e.innerWidth)
              : n.documentElement && n.documentElement.clientWidth
              ? (i = n.documentElement.clientWidth)
              : console.warn('Can not detect viewport width.'),
            i
          );
        }),
        (o.prototype.replace = function (e) {
          this.$stage.empty(),
            (this._items = []),
            e && (e = e instanceof jQuery ? e : t(e)),
            this.settings.nestedItemSelector &&
              (e = e.find('.' + this.settings.nestedItemSelector)),
            e
              .filter(function () {
                return 1 === this.nodeType;
              })
              .each(
                t.proxy(function (t, e) {
                  (e = this.prepare(e)),
                    this.$stage.append(e),
                    this._items.push(e),
                    this._mergers.push(
                      1 *
                        e
                          .find('[data-merge]')
                          .addBack('[data-merge]')
                          .attr('data-merge') || 1
                    );
                }, this)
              ),
            this.reset(
              this.isNumeric(this.settings.startPosition)
                ? this.settings.startPosition
                : 0
            ),
            this.invalidate('items');
        }),
        (o.prototype.add = function (e, n) {
          var i = this.relative(this._current);
          (n = void 0 === n ? this._items.length : this.normalize(n, !0)),
            (e = e instanceof jQuery ? e : t(e)),
            this.trigger('add', {
              content: e,
              position: n,
            }),
            (e = this.prepare(e)),
            0 === this._items.length || n === this._items.length
              ? (0 === this._items.length && this.$stage.append(e),
                0 !== this._items.length && this._items[n - 1].after(e),
                this._items.push(e),
                this._mergers.push(
                  1 *
                    e
                      .find('[data-merge]')
                      .addBack('[data-merge]')
                      .attr('data-merge') || 1
                ))
              : (this._items[n].before(e),
                this._items.splice(n, 0, e),
                this._mergers.splice(
                  n,
                  0,
                  1 *
                    e
                      .find('[data-merge]')
                      .addBack('[data-merge]')
                      .attr('data-merge') || 1
                )),
            this._items[i] && this.reset(this._items[i].index()),
            this.invalidate('items'),
            this.trigger('added', {
              content: e,
              position: n,
            });
        }),
        (o.prototype.remove = function (t) {
          void 0 !== (t = this.normalize(t, !0)) &&
            (this.trigger('remove', {
              content: this._items[t],
              position: t,
            }),
            this._items[t].remove(),
            this._items.splice(t, 1),
            this._mergers.splice(t, 1),
            this.invalidate('items'),
            this.trigger('removed', {
              content: null,
              position: t,
            }));
        }),
        (o.prototype.preloadAutoWidthImages = function (e) {
          e.each(
            t.proxy(function (e, n) {
              this.enter('pre-loading'),
                (n = t(n)),
                t(new Image())
                  .one(
                    'load',
                    t.proxy(function (t) {
                      n.attr('src', t.target.src),
                        n.css('opacity', 1),
                        this.leave('pre-loading'),
                        !this.is('pre-loading') &&
                          !this.is('initializing') &&
                          this.refresh();
                    }, this)
                  )
                  .attr(
                    'src',
                    n.attr('src') ||
                      n.attr('data-src') ||
                      n.attr('data-src-retina')
                  );
            }, this)
          );
        }),
        (o.prototype.destroy = function () {
          for (var i in (this.$element.off('.owl.core'),
          this.$stage.off('.owl.core'),
          t(n).off('.owl.core'),
          !1 !== this.settings.responsive &&
            (e.clearTimeout(this.resizeTimer),
            this.off(e, 'resize', this._handlers.onThrottledResize)),
          this._plugins))
            this._plugins[i].destroy();
          this.$stage.children('.cloned').remove(),
            this.$stage.unwrap(),
            this.$stage.children().contents().unwrap(),
            this.$stage.children().unwrap(),
            this.$stage.remove(),
            this.$element
              .removeClass(this.options.refreshClass)
              .removeClass(this.options.loadingClass)
              .removeClass(this.options.loadedClass)
              .removeClass(this.options.rtlClass)
              .removeClass(this.options.dragClass)
              .removeClass(this.options.grabClass)
              .attr(
                'class',
                this.$element
                  .attr('class')
                  .replace(
                    new RegExp(this.options.responsiveClass + '-\\S+\\s', 'g'),
                    ''
                  )
              )
              .removeData('owl.carousel');
        }),
        (o.prototype.op = function (t, e, n) {
          var i = this.settings.rtl;
          switch (e) {
            case '<':
              return i ? t > n : t < n;
            case '>':
              return i ? t < n : t > n;
            case '>=':
              return i ? t <= n : t >= n;
            case '<=':
              return i ? t >= n : t <= n;
          }
        }),
        (o.prototype.on = function (t, e, n, i) {
          t.addEventListener
            ? t.addEventListener(e, n, i)
            : t.attachEvent && t.attachEvent('on' + e, n);
        }),
        (o.prototype.off = function (t, e, n, i) {
          t.removeEventListener
            ? t.removeEventListener(e, n, i)
            : t.detachEvent && t.detachEvent('on' + e, n);
        }),
        (o.prototype.trigger = function (e, n, i, r, s) {
          var a = {
              item: { count: this._items.length, index: this.current() },
            },
            l = t.camelCase(
              t
                .grep(['on', e, i], function (t) {
                  return t;
                })
                .join('-')
                .toLowerCase()
            ),
            c = t.Event(
              [e, 'owl', i || 'carousel'].join('.').toLowerCase(),
              t.extend({ relatedTarget: this }, a, n)
            );
          return (
            this._supress[e] ||
              (t.each(this._plugins, function (t, e) {
                e.onTrigger && e.onTrigger(c);
              }),
              this.register({
                type: o.Type.Event,
                name: e,
              }),
              this.$element.trigger(c),
              this.settings &&
                'function' == typeof this.settings[l] &&
                this.settings[l].call(this, c)),
            c
          );
        }),
        (o.prototype.enter = function (e) {
          t.each(
            [e].concat(this._states.tags[e] || []),
            t.proxy(function (t, e) {
              void 0 === this._states.current[e] &&
                (this._states.current[e] = 0),
                this._states.current[e]++;
            }, this)
          );
        }),
        (o.prototype.leave = function (e) {
          t.each(
            [e].concat(this._states.tags[e] || []),
            t.proxy(function (t, e) {
              this._states.current[e]--;
            }, this)
          );
        }),
        (o.prototype.register = function (e) {
          if (e.type === o.Type.Event) {
            if (
              (t.event.special[e.name] || (t.event.special[e.name] = {}),
              !t.event.special[e.name].owl)
            ) {
              var n = t.event.special[e.name]._default;
              (t.event.special[e.name]._default = function (t) {
                return !n ||
                  !n.apply ||
                  (t.namespace && -1 !== t.namespace.indexOf('owl'))
                  ? t.namespace && t.namespace.indexOf('owl') > -1
                  : n.apply(this, arguments);
              }),
                (t.event.special[e.name].owl = !0);
            }
          } else
            e.type === o.Type.State &&
              (this._states.tags[e.name]
                ? (this._states.tags[e.name] = this._states.tags[e.name].concat(
                    e.tags
                  ))
                : (this._states.tags[e.name] = e.tags),
              (this._states.tags[e.name] = t.grep(
                this._states.tags[e.name],
                t.proxy(function (n, i) {
                  return t.inArray(n, this._states.tags[e.name]) === i;
                }, this)
              )));
        }),
        (o.prototype.suppress = function (e) {
          t.each(
            e,
            t.proxy(function (t, e) {
              this._supress[e] = !0;
            }, this)
          );
        }),
        (o.prototype.release = function (e) {
          t.each(
            e,
            t.proxy(function (t, e) {
              delete this._supress[e];
            }, this)
          );
        }),
        (o.prototype.pointer = function (t) {
          var n = { x: null, y: null };
          return (
            (t =
              (t = t.originalEvent || t || e.event).touches && t.touches.length
                ? t.touches[0]
                : t.changedTouches && t.changedTouches.length
                ? t.changedTouches[0]
                : t).pageX
              ? ((n.x = t.pageX), (n.y = t.pageY))
              : ((n.x = t.clientX), (n.y = t.clientY)),
            n
          );
        }),
        (o.prototype.isNumeric = function (t) {
          return !isNaN(parseFloat(t));
        }),
        (o.prototype.difference = function (t, e) {
          return { x: t.x - e.x, y: t.y - e.y };
        }),
        (t.fn.owlCarousel = function (e) {
          var n = Array.prototype.slice.call(arguments, 1);
          return this.each(function () {
            var i = t(this),
              r = i.data('owl.carousel');
            r ||
              ((r = new o(this, 'object' == typeof e && e)),
              i.data('owl.carousel', r),
              t.each(
                [
                  'next',
                  'prev',
                  'to',
                  'destroy',
                  'refresh',
                  'replace',
                  'add',
                  'remove',
                ],
                function (e, n) {
                  r.register({
                    type: o.Type.Event,
                    name: n,
                  }),
                    r.$element.on(
                      n + '.owl.carousel.core',
                      t.proxy(function (t) {
                        t.namespace &&
                          t.relatedTarget !== this &&
                          (this.suppress([n]),
                          r[n].apply(this, [].slice.call(arguments, 1)),
                          this.release([n]));
                      }, r)
                    );
                }
              )),
              'string' == typeof e && '_' !== e.charAt(0) && r[e].apply(r, n);
          });
        }),
        (t.fn.owlCarousel.Constructor = o);
    })(window.Zepto || window.jQuery, window, document),
      (function (t, e, n, i) {
        var o = function (e) {
          (this._core = e),
            (this._interval = null),
            (this._visible = null),
            (this._handlers = {
              'initialized.owl.carousel': t.proxy(function (t) {
                t.namespace && this._core.settings.autoRefresh && this.watch();
              }, this),
            }),
            (this._core.options = t.extend({}, o.Defaults, this._core.options)),
            this._core.$element.on(this._handlers);
        };
        (o.Defaults = { autoRefresh: !0, autoRefreshInterval: 500 }),
          (o.prototype.watch = function () {
            this._interval ||
              ((this._visible = this._core.isVisible()),
              (this._interval = e.setInterval(
                t.proxy(this.refresh, this),
                this._core.settings.autoRefreshInterval
              )));
          }),
          (o.prototype.refresh = function () {
            this._core.isVisible() !== this._visible &&
              ((this._visible = !this._visible),
              this._core.$element.toggleClass('owl-hidden', !this._visible),
              this._visible &&
                this._core.invalidate('width') &&
                this._core.refresh());
          }),
          (o.prototype.destroy = function () {
            var t, n;
            for (t in (e.clearInterval(this._interval), this._handlers))
              this._core.$element.off(t, this._handlers[t]);
            for (n in Object.getOwnPropertyNames(this))
              'function' != typeof this[n] && (this[n] = null);
          }),
          (t.fn.owlCarousel.Constructor.Plugins.AutoRefresh = o);
      })(window.Zepto || window.jQuery, window, document),
      (function (t, e, n, i) {
        var o = function (e) {
          (this._core = e),
            (this._loaded = []),
            (this._handlers = {
              'initialized.owl.carousel change.owl.carousel resized.owl.carousel':
                t.proxy(function (e) {
                  if (
                    e.namespace &&
                    this._core.settings &&
                    this._core.settings.lazyLoad &&
                    ((e.property && 'position' == e.property.name) ||
                      'initialized' == e.type)
                  ) {
                    var n = this._core.settings,
                      i = (n.center && Math.ceil(n.items / 2)) || n.items,
                      o = (n.center && -1 * i) || 0,
                      r =
                        (e.property && void 0 !== e.property.value
                          ? e.property.value
                          : this._core.current()) + o,
                      s = this._core.clones().length,
                      a = t.proxy(function (t, e) {
                        this.load(e);
                      }, this);
                    for (
                      n.lazyLoadEager > 0 &&
                      ((i += n.lazyLoadEager),
                      n.loop && ((r -= n.lazyLoadEager), i++));
                      o++ < i;

                    )
                      this.load(s / 2 + this._core.relative(r)),
                        s &&
                          t.each(this._core.clones(this._core.relative(r)), a),
                        r++;
                  }
                }, this),
            }),
            (this._core.options = t.extend({}, o.Defaults, this._core.options)),
            this._core.$element.on(this._handlers);
        };
        (o.Defaults = { lazyLoad: !1, lazyLoadEager: 0 }),
          (o.prototype.load = function (n) {
            var i = this._core.$stage.children().eq(n),
              o = i && i.find('.owl-lazy');
            !o ||
              t.inArray(i.get(0), this._loaded) > -1 ||
              (o.each(
                t.proxy(function (n, i) {
                  var o,
                    r = t(i),
                    s =
                      (e.devicePixelRatio > 1 && r.attr('data-src-retina')) ||
                      r.attr('data-src') ||
                      r.attr('data-srcset');
                  this._core.trigger(
                    'load',
                    {
                      element: r,
                      url: s,
                    },
                    'lazy'
                  ),
                    r.is('img')
                      ? r
                          .one(
                            'load.owl.lazy',
                            t.proxy(function () {
                              r.css('opacity', 1),
                                this._core.trigger(
                                  'loaded',
                                  { element: r, url: s },
                                  'lazy'
                                );
                            }, this)
                          )
                          .attr('src', s)
                      : r.is('source')
                      ? r
                          .one(
                            'load.owl.lazy',
                            t.proxy(function () {
                              this._core.trigger(
                                'loaded',
                                { element: r, url: s },
                                'lazy'
                              );
                            }, this)
                          )
                          .attr('srcset', s)
                      : (((o = new Image()).onload = t.proxy(function () {
                          r.css({
                            'background-image': 'url("' + s + '")',
                            opacity: '1',
                          }),
                            this._core.trigger(
                              'loaded',
                              { element: r, url: s },
                              'lazy'
                            );
                        }, this)),
                        (o.src = s));
                }, this)
              ),
              this._loaded.push(i.get(0)));
          }),
          (o.prototype.destroy = function () {
            var t, e;
            for (t in this.handlers)
              this._core.$element.off(t, this.handlers[t]);
            for (e in Object.getOwnPropertyNames(this))
              'function' != typeof this[e] && (this[e] = null);
          }),
          (t.fn.owlCarousel.Constructor.Plugins.Lazy = o);
      })(window.Zepto || window.jQuery, window, document),
      (function (t, e, n, i) {
        var o = function (n) {
          (this._core = n),
            (this._previousHeight = null),
            (this._handlers = {
              'initialized.owl.carousel refreshed.owl.carousel': t.proxy(
                function (t) {
                  t.namespace &&
                    this._core.settings.autoHeight &&
                    this.update();
                },
                this
              ),
              'changed.owl.carousel': t.proxy(function (t) {
                t.namespace &&
                  this._core.settings.autoHeight &&
                  'position' === t.property.name &&
                  this.update();
              }, this),
              'loaded.owl.lazy': t.proxy(function (t) {
                t.namespace &&
                  this._core.settings.autoHeight &&
                  t.element
                    .closest('.' + this._core.settings.itemClass)
                    .index() === this._core.current() &&
                  this.update();
              }, this),
            }),
            (this._core.options = t.extend({}, o.Defaults, this._core.options)),
            this._core.$element.on(this._handlers),
            (this._intervalId = null);
          var i = this;
          t(e).on('load', function () {
            i._core.settings.autoHeight && i.update();
          }),
            t(e).resize(function () {
              i._core.settings.autoHeight &&
                (null != i._intervalId && clearTimeout(i._intervalId),
                (i._intervalId = setTimeout(function () {
                  i.update();
                }, 250)));
            });
        };
        (o.Defaults = { autoHeight: !1, autoHeightClass: 'owl-height' }),
          (o.prototype.update = function () {
            var e = this._core._current,
              n = e + this._core.settings.items,
              i = this._core.settings.lazyLoad,
              o = this._core.$stage.children().toArray().slice(e, n),
              r = [],
              s = 0;
            t.each(o, function (e, n) {
              r.push(t(n).height());
            }),
              (s = Math.max.apply(null, r)) <= 1 &&
                i &&
                this._previousHeight &&
                (s = this._previousHeight),
              (this._previousHeight = s),
              this._core.$stage
                .parent()
                .height(s)
                .addClass(this._core.settings.autoHeightClass);
          }),
          (o.prototype.destroy = function () {
            var t, e;
            for (t in this._handlers)
              this._core.$element.off(t, this._handlers[t]);
            for (e in Object.getOwnPropertyNames(this))
              'function' != typeof this[e] && (this[e] = null);
          }),
          (t.fn.owlCarousel.Constructor.Plugins.AutoHeight = o);
      })(window.Zepto || window.jQuery, window, document),
      (function (t, e, n, i) {
        var o = function (e) {
          (this._core = e),
            (this._videos = {}),
            (this._playing = null),
            (this._handlers = {
              'initialized.owl.carousel': t.proxy(function (t) {
                t.namespace &&
                  this._core.register({
                    type: 'state',
                    name: 'playing',
                    tags: ['interacting'],
                  });
              }, this),
              'resize.owl.carousel': t.proxy(function (t) {
                t.namespace &&
                  this._core.settings.video &&
                  this.isInFullScreen() &&
                  t.preventDefault();
              }, this),
              'refreshed.owl.carousel': t.proxy(function (t) {
                t.namespace &&
                  this._core.is('resizing') &&
                  this._core.$stage.find('.cloned .owl-video-frame').remove();
              }, this),
              'changed.owl.carousel': t.proxy(function (t) {
                t.namespace &&
                  'position' === t.property.name &&
                  this._playing &&
                  this.stop();
              }, this),
              'prepared.owl.carousel': t.proxy(function (e) {
                if (e.namespace) {
                  var n = t(e.content).find('.owl-video');
                  n.length &&
                    (n.css('display', 'none'), this.fetch(n, t(e.content)));
                }
              }, this),
            }),
            (this._core.options = t.extend({}, o.Defaults, this._core.options)),
            this._core.$element.on(this._handlers),
            this._core.$element.on(
              'click.owl.video',
              '.owl-video-play-icon',
              t.proxy(function (t) {
                this.play(t);
              }, this)
            );
        };
        (o.Defaults = { video: !1, videoHeight: !1, videoWidth: !1 }),
          (o.prototype.fetch = function (t, e) {
            var n = t.attr('data-vimeo-id')
                ? 'vimeo'
                : t.attr('data-vzaar-id')
                ? 'vzaar'
                : 'youtube',
              i =
                t.attr('data-vimeo-id') ||
                t.attr('data-youtube-id') ||
                t.attr('data-vzaar-id'),
              o = t.attr('data-width') || this._core.settings.videoWidth,
              r = t.attr('data-height') || this._core.settings.videoHeight,
              s = t.attr('href');
            if (!s) throw new Error('Missing video URL.');
            if (
              (i = s.match(
                /(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
              ))[3].indexOf('youtu') > -1
            )
              n = 'youtube';
            else if (i[3].indexOf('vimeo') > -1) n = 'vimeo';
            else {
              if (!(i[3].indexOf('vzaar') > -1))
                throw new Error('Video URL not supported.');
              n = 'vzaar';
            }
            (i = i[6]),
              (this._videos[s] = {
                type: n,
                id: i,
                width: o,
                height: r,
              }),
              e.attr('data-video', s),
              this.thumbnail(t, this._videos[s]);
          }),
          (o.prototype.thumbnail = function (e, n) {
            var i,
              o,
              r,
              s =
                n.width && n.height
                  ? 'width:' + n.width + 'px;height:' + n.height + 'px;'
                  : '',
              a = e.find('img'),
              l = 'src',
              c = '',
              u = this._core.settings,
              d = function (n) {
                (o = '<div class="owl-video-play-icon"></div>'),
                  (i = u.lazyLoad
                    ? t('<div/>', {
                        class: 'owl-video-tn ' + c,
                        srcType: n,
                      })
                    : t('<div/>', {
                        class: 'owl-video-tn',
                        style: 'opacity:1;background-image:url(' + n + ')',
                      })),
                  e.after(i),
                  e.after(o);
              };
            if (
              (e.wrap(
                t('<div/>', {
                  class: 'owl-video-wrapper',
                  style: s,
                })
              ),
              this._core.settings.lazyLoad &&
                ((l = 'data-src'), (c = 'owl-lazy')),
              a.length)
            )
              return d(a.attr(l)), a.remove(), !1;
            'youtube' === n.type
              ? ((r = '//img.youtube.com/vi/' + n.id + '/hqdefault.jpg'), d(r))
              : 'vimeo' === n.type
              ? t.ajax({
                  type: 'GET',
                  url: '//vimeo.com/api/v2/video/' + n.id + '.json',
                  jsonp: 'callback',
                  dataType: 'jsonp',
                  success: function (t) {
                    (r = t[0].thumbnail_large), d(r);
                  },
                })
              : 'vzaar' === n.type &&
                t.ajax({
                  type: 'GET',
                  url: '//vzaar.com/api/videos/' + n.id + '.json',
                  jsonp: 'callback',
                  dataType: 'jsonp',
                  success: function (t) {
                    (r = t.framegrab_url), d(r);
                  },
                });
          }),
          (o.prototype.stop = function () {
            this._core.trigger('stop', null, 'video'),
              this._playing.find('.owl-video-frame').remove(),
              this._playing.removeClass('owl-video-playing'),
              (this._playing = null),
              this._core.leave('playing'),
              this._core.trigger('stopped', null, 'video');
          }),
          (o.prototype.play = function (e) {
            var n,
              i = t(e.target).closest('.' + this._core.settings.itemClass),
              o = this._videos[i.attr('data-video')],
              r = o.width || '100%',
              s = o.height || this._core.$stage.height();
            this._playing ||
              (this._core.enter('playing'),
              this._core.trigger('play', null, 'video'),
              (i = this._core.items(this._core.relative(i.index()))),
              this._core.reset(i.index()),
              (n = t(
                '<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>'
              )).attr('height', s),
              n.attr('width', r),
              'youtube' === o.type
                ? n.attr(
                    'src',
                    '//www.youtube.com/embed/' +
                      o.id +
                      '?autoplay=1&rel=0&v=' +
                      o.id
                  )
                : 'vimeo' === o.type
                ? n.attr(
                    'src',
                    '//player.vimeo.com/video/' + o.id + '?autoplay=1'
                  )
                : 'vzaar' === o.type &&
                  n.attr(
                    'src',
                    '//view.vzaar.com/' + o.id + '/player?autoplay=true'
                  ),
              t(n)
                .wrap('<div class="owl-video-frame" />')
                .insertAfter(i.find('.owl-video')),
              (this._playing = i.addClass('owl-video-playing')));
          }),
          (o.prototype.isInFullScreen = function () {
            var e =
              n.fullscreenElement ||
              n.mozFullScreenElement ||
              n.webkitFullscreenElement;
            return e && t(e).parent().hasClass('owl-video-frame');
          }),
          (o.prototype.destroy = function () {
            var t, e;
            for (t in (this._core.$element.off('click.owl.video'),
            this._handlers))
              this._core.$element.off(t, this._handlers[t]);
            for (e in Object.getOwnPropertyNames(this))
              'function' != typeof this[e] && (this[e] = null);
          }),
          (t.fn.owlCarousel.Constructor.Plugins.Video = o);
      })(window.Zepto || window.jQuery, window, document),
      (function (t, e, n, i) {
        var o = function (e) {
          (this.core = e),
            (this.core.options = t.extend({}, o.Defaults, this.core.options)),
            (this.swapping = !0),
            (this.previous = void 0),
            (this.next = void 0),
            (this.handlers = {
              'change.owl.carousel': t.proxy(function (t) {
                t.namespace &&
                  'position' == t.property.name &&
                  ((this.previous = this.core.current()),
                  (this.next = t.property.value));
              }, this),
              'drag.owl.carousel dragged.owl.carousel translated.owl.carousel':
                t.proxy(function (t) {
                  t.namespace && (this.swapping = 'translated' == t.type);
                }, this),
              'translate.owl.carousel': t.proxy(function (t) {
                t.namespace &&
                  this.swapping &&
                  (this.core.options.animateOut ||
                    this.core.options.animateIn) &&
                  this.swap();
              }, this),
            }),
            this.core.$element.on(this.handlers);
        };
        (o.Defaults = { animateOut: !1, animateIn: !1 }),
          (o.prototype.swap = function () {
            if (
              1 === this.core.settings.items &&
              t.support.animation &&
              t.support.transition
            ) {
              this.core.speed(0);
              var e,
                n = t.proxy(this.clear, this),
                i = this.core.$stage.children().eq(this.previous),
                o = this.core.$stage.children().eq(this.next),
                r = this.core.settings.animateIn,
                s = this.core.settings.animateOut;
              this.core.current() !== this.previous &&
                (s &&
                  ((e =
                    this.core.coordinates(this.previous) -
                    this.core.coordinates(this.next)),
                  i
                    .one(t.support.animation.end, n)
                    .css({ left: e + 'px' })
                    .addClass('animated owl-animated-out')
                    .addClass(s)),
                r &&
                  o
                    .one(t.support.animation.end, n)
                    .addClass('animated owl-animated-in')
                    .addClass(r));
            }
          }),
          (o.prototype.clear = function (e) {
            t(e.target)
              .css({ left: '' })
              .removeClass('animated owl-animated-out owl-animated-in')
              .removeClass(this.core.settings.animateIn)
              .removeClass(this.core.settings.animateOut),
              this.core.onTransitionEnd();
          }),
          (o.prototype.destroy = function () {
            var t, e;
            for (t in this.handlers)
              this.core.$element.off(t, this.handlers[t]);
            for (e in Object.getOwnPropertyNames(this))
              'function' != typeof this[e] && (this[e] = null);
          }),
          (t.fn.owlCarousel.Constructor.Plugins.Animate = o);
      })(window.Zepto || window.jQuery, window, document),
      (function (t, e, n, i) {
        var o = function (e) {
          (this._core = e),
            (this._call = null),
            (this._time = 0),
            (this._timeout = 0),
            (this._paused = !0),
            (this._handlers = {
              'changed.owl.carousel': t.proxy(function (t) {
                t.namespace && 'settings' === t.property.name
                  ? this._core.settings.autoplay
                    ? this.play()
                    : this.stop()
                  : t.namespace &&
                    'position' === t.property.name &&
                    this._paused &&
                    (this._time = 0);
              }, this),
              'initialized.owl.carousel': t.proxy(function (t) {
                t.namespace && this._core.settings.autoplay && this.play();
              }, this),
              'play.owl.autoplay': t.proxy(function (t, e, n) {
                t.namespace && this.play(e, n);
              }, this),
              'stop.owl.autoplay': t.proxy(function (t) {
                t.namespace && this.stop();
              }, this),
              'mouseover.owl.autoplay': t.proxy(function () {
                this._core.settings.autoplayHoverPause &&
                  this._core.is('rotating') &&
                  this.pause();
              }, this),
              'mouseleave.owl.autoplay': t.proxy(function () {
                this._core.settings.autoplayHoverPause &&
                  this._core.is('rotating') &&
                  this.play();
              }, this),
              'touchstart.owl.core': t.proxy(function () {
                this._core.settings.autoplayHoverPause &&
                  this._core.is('rotating') &&
                  this.pause();
              }, this),
              'touchend.owl.core': t.proxy(function () {
                this._core.settings.autoplayHoverPause && this.play();
              }, this),
            }),
            this._core.$element.on(this._handlers),
            (this._core.options = t.extend({}, o.Defaults, this._core.options));
        };
        (o.Defaults = {
          autoplay: !1,
          autoplayTimeout: 5e3,
          autoplayHoverPause: !1,
          autoplaySpeed: !1,
        }),
          (o.prototype._next = function (i) {
            (this._call = e.setTimeout(
              t.proxy(this._next, this, i),
              this._timeout * (Math.round(this.read() / this._timeout) + 1) -
                this.read()
            )),
              this._core.is('interacting') ||
                n.hidden ||
                this._core.next(i || this._core.settings.autoplaySpeed);
          }),
          (o.prototype.read = function () {
            return new Date().getTime() - this._time;
          }),
          (o.prototype.play = function (n, i) {
            var o;
            this._core.is('rotating') || this._core.enter('rotating'),
              (n = n || this._core.settings.autoplayTimeout),
              (o = Math.min(this._time % (this._timeout || n), n)),
              this._paused
                ? ((this._time = this.read()), (this._paused = !1))
                : e.clearTimeout(this._call),
              (this._time += (this.read() % n) - o),
              (this._timeout = n),
              (this._call = e.setTimeout(t.proxy(this._next, this, i), n - o));
          }),
          (o.prototype.stop = function () {
            this._core.is('rotating') &&
              ((this._time = 0),
              (this._paused = !0),
              e.clearTimeout(this._call),
              this._core.leave('rotating'));
          }),
          (o.prototype.pause = function () {
            this._core.is('rotating') &&
              !this._paused &&
              ((this._time = this.read()),
              (this._paused = !0),
              e.clearTimeout(this._call));
          }),
          (o.prototype.destroy = function () {
            var t, e;
            for (t in (this.stop(), this._handlers))
              this._core.$element.off(t, this._handlers[t]);
            for (e in Object.getOwnPropertyNames(this))
              'function' != typeof this[e] && (this[e] = null);
          }),
          (t.fn.owlCarousel.Constructor.Plugins.autoplay = o);
      })(window.Zepto || window.jQuery, window, document),
      (function (t, e, n, i) {
        'use strict';
        var o = function (e) {
          (this._core = e),
            (this._initialized = !1),
            (this._pages = []),
            (this._controls = {}),
            (this._templates = []),
            (this.$element = this._core.$element),
            (this._overrides = {
              next: this._core.next,
              prev: this._core.prev,
              to: this._core.to,
            }),
            (this._handlers = {
              'prepared.owl.carousel': t.proxy(function (e) {
                e.namespace &&
                  this._core.settings.dotsData &&
                  this._templates.push(
                    '<div class="' +
                      this._core.settings.dotClass +
                      '">' +
                      t(e.content)
                        .find('[data-dot]')
                        .addBack('[data-dot]')
                        .attr('data-dot') +
                      '</div>'
                  );
              }, this),
              'added.owl.carousel': t.proxy(function (t) {
                t.namespace &&
                  this._core.settings.dotsData &&
                  this._templates.splice(t.position, 0, this._templates.pop());
              }, this),
              'remove.owl.carousel': t.proxy(function (t) {
                t.namespace &&
                  this._core.settings.dotsData &&
                  this._templates.splice(t.position, 1);
              }, this),
              'changed.owl.carousel': t.proxy(function (t) {
                t.namespace && 'position' == t.property.name && this.draw();
              }, this),
              'initialized.owl.carousel': t.proxy(function (t) {
                t.namespace &&
                  !this._initialized &&
                  (this._core.trigger('initialize', null, 'navigation'),
                  this.initialize(),
                  this.update(),
                  this.draw(),
                  (this._initialized = !0),
                  this._core.trigger('initialized', null, 'navigation'));
              }, this),
              'refreshed.owl.carousel': t.proxy(function (t) {
                t.namespace &&
                  this._initialized &&
                  (this._core.trigger('refresh', null, 'navigation'),
                  this.update(),
                  this.draw(),
                  this._core.trigger('refreshed', null, 'navigation'));
              }, this),
            }),
            (this._core.options = t.extend({}, o.Defaults, this._core.options)),
            this.$element.on(this._handlers);
        };
        (o.Defaults = {
          nav: !1,
          navText: [
            '<span aria-label="Previous">&#x2039;</span>',
            '<span aria-label="Next">&#x203a;</span>',
          ],
          navSpeed: !1,
          navElement: 'button type="button" role="presentation"',
          navContainer: !1,
          navContainerClass: 'owl-nav',
          navClass: ['owl-prev', 'owl-next'],
          slideBy: 1,
          dotClass: 'owl-dot',
          dotsClass: 'owl-dots',
          dots: !0,
          dotsEach: !1,
          dotsData: !1,
          dotsSpeed: !1,
          dotsContainer: !1,
        }),
          (o.prototype.initialize = function () {
            var e,
              n = this._core.settings;
            for (e in ((this._controls.$relative = (
              n.navContainer
                ? t(n.navContainer)
                : t('<div>')
                    .addClass(n.navContainerClass)
                    .appendTo(this.$element)
            ).addClass('disabled')),
            (this._controls.$previous = t('<' + n.navElement + '>')
              .addClass(n.navClass[0])
              .html(n.navText[0])
              .prependTo(this._controls.$relative)
              .on(
                'click',
                t.proxy(function (t) {
                  this.prev(n.navSpeed);
                }, this)
              )),
            (this._controls.$next = t('<' + n.navElement + '>')
              .addClass(n.navClass[1])
              .html(n.navText[1])
              .appendTo(this._controls.$relative)
              .on(
                'click',
                t.proxy(function (t) {
                  this.next(n.navSpeed);
                }, this)
              )),
            n.dotsData ||
              (this._templates = [
                t('<button role="button">')
                  .addClass(n.dotClass)
                  .append(t('<span>'))
                  .prop('outerHTML'),
              ]),
            (this._controls.$absolute = (
              n.dotsContainer
                ? t(n.dotsContainer)
                : t('<div>').addClass(n.dotsClass).appendTo(this.$element)
            ).addClass('disabled')),
            this._controls.$absolute.on(
              'click',
              'button',
              t.proxy(function (e) {
                var i = t(e.target).parent().is(this._controls.$absolute)
                  ? t(e.target).index()
                  : t(e.target).parent().index();
                e.preventDefault(), this.to(i, n.dotsSpeed);
              }, this)
            ),
            this._overrides))
              this._core[e] = t.proxy(this[e], this);
          }),
          (o.prototype.destroy = function () {
            var t, e, n, i, o;
            for (t in ((o = this._core.settings), this._handlers))
              this.$element.off(t, this._handlers[t]);
            for (e in this._controls)
              '$relative' === e && o.navContainer
                ? this._controls[e].html('')
                : this._controls[e].remove();
            for (i in this.overides) this._core[i] = this._overrides[i];
            for (n in Object.getOwnPropertyNames(this))
              'function' != typeof this[n] && (this[n] = null);
          }),
          (o.prototype.update = function () {
            var t,
              e,
              n = this._core.clones().length / 2,
              i = n + this._core.items().length,
              o = this._core.maximum(!0),
              r = this._core.settings,
              s =
                r.center || r.autoWidth || r.dotsData
                  ? 1
                  : r.dotsEach || r.items;
            if (
              ('page' !== r.slideBy &&
                (r.slideBy = Math.min(r.slideBy, r.items)),
              r.dots || 'page' == r.slideBy)
            )
              for (this._pages = [], t = n, e = 0, 0; t < i; t++) {
                if (e >= s || 0 === e) {
                  if (
                    (this._pages.push({
                      start: Math.min(o, t - n),
                      end: t - n + s - 1,
                    }),
                    Math.min(o, t - n) === o)
                  )
                    break;
                  (e = 0), 0;
                }
                e += this._core.mergers(this._core.relative(t));
              }
          }),
          (o.prototype.draw = function () {
            var e,
              n = this._core.settings,
              i = this._core.items().length <= n.items,
              o = this._core.relative(this._core.current()),
              r = n.loop || n.rewind;
            this._controls.$relative.toggleClass('disabled', !n.nav || i),
              n.nav &&
                (this._controls.$previous.toggleClass(
                  'disabled',
                  !r && o <= this._core.minimum(!0)
                ),
                this._controls.$next.toggleClass(
                  'disabled',
                  !r && o >= this._core.maximum(!0)
                )),
              this._controls.$absolute.toggleClass('disabled', !n.dots || i),
              n.dots &&
                ((e =
                  this._pages.length -
                  this._controls.$absolute.children().length),
                n.dotsData && 0 !== e
                  ? this._controls.$absolute.html(this._templates.join(''))
                  : e > 0
                  ? this._controls.$absolute.append(
                      new Array(e + 1).join(this._templates[0])
                    )
                  : e < 0 &&
                    this._controls.$absolute.children().slice(e).remove(),
                this._controls.$absolute.find('.active').removeClass('active'),
                this._controls.$absolute
                  .children()
                  .eq(t.inArray(this.current(), this._pages))
                  .addClass('active'));
          }),
          (o.prototype.onTrigger = function (e) {
            var n = this._core.settings;
            e.page = {
              index: t.inArray(this.current(), this._pages),
              count: this._pages.length,
              size:
                n &&
                (n.center || n.autoWidth || n.dotsData
                  ? 1
                  : n.dotsEach || n.items),
            };
          }),
          (o.prototype.current = function () {
            var e = this._core.relative(this._core.current());
            return t
              .grep(
                this._pages,
                t.proxy(function (t, n) {
                  return t.start <= e && t.end >= e;
                }, this)
              )
              .pop();
          }),
          (o.prototype.getPosition = function (e) {
            var n,
              i,
              o = this._core.settings;
            return (
              'page' == o.slideBy
                ? ((n = t.inArray(this.current(), this._pages)),
                  (i = this._pages.length),
                  e ? ++n : --n,
                  (n = this._pages[((n % i) + i) % i].start))
                : ((n = this._core.relative(this._core.current())),
                  (i = this._core.items().length),
                  e ? (n += o.slideBy) : (n -= o.slideBy)),
              n
            );
          }),
          (o.prototype.next = function (e) {
            t.proxy(this._overrides.to, this._core)(this.getPosition(!0), e);
          }),
          (o.prototype.prev = function (e) {
            t.proxy(this._overrides.to, this._core)(this.getPosition(!1), e);
          }),
          (o.prototype.to = function (e, n, i) {
            var o;
            !i && this._pages.length
              ? ((o = this._pages.length),
                t.proxy(this._overrides.to, this._core)(
                  this._pages[((e % o) + o) % o].start,
                  n
                ))
              : t.proxy(this._overrides.to, this._core)(e, n);
          }),
          (t.fn.owlCarousel.Constructor.Plugins.Navigation = o);
      })(window.Zepto || window.jQuery, window, document),
      (function (t, e, n, i) {
        'use strict';
        var o = function (n) {
          (this._core = n),
            (this._hashes = {}),
            (this.$element = this._core.$element),
            (this._handlers = {
              'initialized.owl.carousel': t.proxy(function (n) {
                n.namespace &&
                  'URLHash' === this._core.settings.startPosition &&
                  t(e).trigger('hashchange.owl.navigation');
              }, this),
              'prepared.owl.carousel': t.proxy(function (e) {
                if (e.namespace) {
                  var n = t(e.content)
                    .find('[data-hash]')
                    .addBack('[data-hash]')
                    .attr('data-hash');
                  if (!n) return;
                  this._hashes[n] = e.content;
                }
              }, this),
              'changed.owl.carousel': t.proxy(function (n) {
                if (n.namespace && 'position' === n.property.name) {
                  var i = this._core.items(
                      this._core.relative(this._core.current())
                    ),
                    o = t
                      .map(this._hashes, function (t, e) {
                        return t === i ? e : null;
                      })
                      .join();
                  if (!o || e.location.hash.slice(1) === o) return;
                  e.location.hash = o;
                }
              }, this),
            }),
            (this._core.options = t.extend({}, o.Defaults, this._core.options)),
            this.$element.on(this._handlers),
            t(e).on(
              'hashchange.owl.navigation',
              t.proxy(function (t) {
                var n = e.location.hash.substring(1),
                  i = this._core.$stage.children(),
                  o = this._hashes[n] && i.index(this._hashes[n]);
                void 0 !== o &&
                  o !== this._core.current() &&
                  this._core.to(this._core.relative(o), !1, !0);
              }, this)
            );
        };
        (o.Defaults = { URLhashListener: !1 }),
          (o.prototype.destroy = function () {
            var n, i;
            for (n in (t(e).off('hashchange.owl.navigation'), this._handlers))
              this._core.$element.off(n, this._handlers[n]);
            for (i in Object.getOwnPropertyNames(this))
              'function' != typeof this[i] && (this[i] = null);
          }),
          (t.fn.owlCarousel.Constructor.Plugins.Hash = o);
      })(window.Zepto || window.jQuery, window, document),
      (function (t, e, n, i) {
        var o = t('<support>').get(0).style,
          r = 'Webkit Moz O ms'.split(' '),
          s = {
            transition: {
              end: {
                WebkitTransition: 'webkitTransitionEnd',
                MozTransition: 'transitionend',
                OTransition: 'oTransitionEnd',
                transition: 'transitionend',
              },
            },
            animation: {
              end: {
                WebkitAnimation: 'webkitAnimationEnd',
                MozAnimation: 'animationend',
                OAnimation: 'oAnimationEnd',
                animation: 'animationend',
              },
            },
          },
          a = function () {
            return !!u('transform');
          },
          l = function () {
            return !!u('perspective');
          },
          c = function () {
            return !!u('animation');
          };

        function u(e, n) {
          var s = !1,
            a = e.charAt(0).toUpperCase() + e.slice(1);
          return (
            t.each((e + ' ' + r.join(a + ' ') + a).split(' '), function (t, e) {
              if (o[e] !== i) return (s = !n || e), !1;
            }),
            s
          );
        }

        function d(t) {
          return u(t, !0);
        }

        (function () {
          return !!u('transition');
        })() &&
          ((t.support.transition = new String(d('transition'))),
          (t.support.transition.end = s.transition.end[t.support.transition])),
          c() &&
            ((t.support.animation = new String(d('animation'))),
            (t.support.animation.end = s.animation.end[t.support.animation])),
          a() &&
            ((t.support.transform = new String(d('transform'))),
            (t.support.transform3d = l()));
      })(window.Zepto || window.jQuery, window, document);
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 });
    var i = (function (t) {
      return t && t.__esModule ? t : { default: t };
    })(n(0));
    n(13);
    var o = {
        $element: void 0,
        selectors: { options: 'data-js-options' },
        classes: { carousel: 'owl-carousel' },
        options: {
          items: 1,
          dots: !0,
          dotsClass: 'carousel__dots',
          dotClass: 'carousel__dot',
          lazyLoad: !0,
          loop: !0,
          autoHeight: !0,
        },
      },
      r = (function () {
        function t() {
          var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          !(function (t, e) {
            if (!(t instanceof e))
              throw new TypeError('Cannot call a class as a function');
          })(this, t);
          var n = i.default.extend(!0, {}, o, e);
          (this.$element = n.$element),
            (this.selectors = n.selectors),
            (this.classes = n.classes),
            (this.options = n.options);
        }

        return (
          (t.prototype.init = function () {
            var t = this,
              e = this.$element.attr(this.selectors.options),
              n = void 0;
            (e = void 0 === e ? {} : JSON.parse(e)) &&
              (n = i.default.extend(!0, this.options, e)),
              (0, i.default)(window).on('load', function () {
                t.$element.addClass(t.classes.carousel),
                  t.$element.owlCarousel(n);
              });
          }),
          t
        );
      })();
    e.default = r;
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 });
    var i = (function (t) {
      return t && t.__esModule ? t : { default: t };
    })(n(0));
    var o = { $element: void 0, data: { target: 'data-js-target' } },
      r = (function () {
        function t() {
          var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          !(function (t, e) {
            if (!(t instanceof e))
              throw new TypeError('Cannot call a class as a function');
          })(this, t);
          var n = i.default.extend(!0, {}, o, e);
          (this.$element = n.$element), (this.data = n.data);
        }

        return (
          (t.prototype.init = function () {
            var t = (0, i.default)(this.$element.attr(this.data.target)),
              e = (0, i.default)('.header').height();
            t &&
              this.$element.on('click', function () {
                (0, i.default)('html, body').animate(
                  { scrollTop: t.offset().top - e },
                  'slow'
                );
              });
          }),
          t
        );
      })();
    e.default = r;
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 });
    var i = (function (t) {
      return t && t.__esModule ? t : { default: t };
    })(n(0));
    var o = {
        $element: void 0,
        classes: { transparent: 'header--transparent', anim: 'header--anim' },
      },
      r = (function () {
        function t() {
          var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          !(function (t, e) {
            if (!(t instanceof e))
              throw new TypeError('Cannot call a class as a function');
          })(this, t);
          var n = i.default.extend(!0, {}, o, e);
          (this.$element = n.$element), (this.classes = n.classes);
        }

        return (
          (t.prototype.init = function () {
            var t = this;
            this.headerAnim(),
              (0, i.default)(window).on('scroll', function () {
                t.headerAnim();
              });
          }),
          (t.prototype.headerAnim = function () {
            this.$element.hasClass(this.classes.anim) &&
              ((0, i.default)(window).scrollTop() > 20
                ? this.$element.removeClass(this.classes.transparent)
                : this.$element.addClass(this.classes.transparent));
          }),
          t
        );
      })();
    e.default = r;
  },
  function (t, e, n) {
    'use strict';
    Object.defineProperty(e, '__esModule', { value: !0 });
    var i = g(n(2)),
      o = g(n(16)),
      r = g(n(15)),
      s = g(n(14)),
      a = g(n(12)),
      l = g(n(10)),
      c = g(n(8)),
      u = g(n(7)),
      d = g(n(6)),
      h = g(n(5)),
      f = g(n(4)),
      p = g(n(1));

    function g(t) {
      return t && t.__esModule ? t : { default: t };
    }

    var m = (window._app = {
      _events: i.default,
      _header: o.default,
      _scrollToTarget: r.default,
      _packingProducts: h.default,
      _toggleProduct: d.default,
      _carousel: s.default,
      _parallax: a.default,
      _waypoints: l.default,
      _accordion: c.default,
      _overlay: u.default,
      _reveal: f.default,
      _utils: p.default,
    });
    e.default = m;
  },
  function (t, e, n) {
    'use strict';
    (function (t) {
      return t && t.__esModule ? t : { default: t };
    })(n(0)).default.fn.extend({
      only: function (t) {
        var e = t.indexOf(' ');
        if (~e) {
          var n,
            i = t.substr(0, e),
            o = t.substr(e + 1);
          return (n = this.closest(i).find(i).find(o)), this.find(o).not(n);
        }
        return this.find(t);
      },
    });
  },
  function (t, e, n) {
    var i, o;
    (i = [n(0)]),
      void 0 ===
        (o = function (t) {
          return (function (t) {
            t.easing.jswing = t.easing.swing;
            var e = Math.pow,
              n = Math.sqrt,
              i = Math.sin,
              o = Math.cos,
              r = Math.PI,
              s = 1.70158,
              a = 1.525 * s,
              l = (2 * r) / 3,
              c = (2 * r) / 4.5;

            function u(t) {
              var e = 7.5625,
                n = 2.75;
              return t < 1 / n
                ? e * t * t
                : t < 2 / n
                ? e * (t -= 1.5 / n) * t + 0.75
                : t < 2.5 / n
                ? e * (t -= 2.25 / n) * t + 0.9375
                : e * (t -= 2.625 / n) * t + 0.984375;
            }

            t.extend(t.easing, {
              def: 'easeOutQuad',
              swing: function (e) {
                return t.easing[t.easing.def](e);
              },
              easeInQuad: function (t) {
                return t * t;
              },
              easeOutQuad: function (t) {
                return 1 - (1 - t) * (1 - t);
              },
              easeInOutQuad: function (t) {
                return t < 0.5 ? 2 * t * t : 1 - e(-2 * t + 2, 2) / 2;
              },
              easeInCubic: function (t) {
                return t * t * t;
              },
              easeOutCubic: function (t) {
                return 1 - e(1 - t, 3);
              },
              easeInOutCubic: function (t) {
                return t < 0.5 ? 4 * t * t * t : 1 - e(-2 * t + 2, 3) / 2;
              },
              easeInQuart: function (t) {
                return t * t * t * t;
              },
              easeOutQuart: function (t) {
                return 1 - e(1 - t, 4);
              },
              easeInOutQuart: function (t) {
                return t < 0.5 ? 8 * t * t * t * t : 1 - e(-2 * t + 2, 4) / 2;
              },
              easeInQuint: function (t) {
                return t * t * t * t * t;
              },
              easeOutQuint: function (t) {
                return 1 - e(1 - t, 5);
              },
              easeInOutQuint: function (t) {
                return t < 0.5
                  ? 16 * t * t * t * t * t
                  : 1 - e(-2 * t + 2, 5) / 2;
              },
              easeInSine: function (t) {
                return 1 - o((t * r) / 2);
              },
              easeOutSine: function (t) {
                return i((t * r) / 2);
              },
              easeInOutSine: function (t) {
                return -(o(r * t) - 1) / 2;
              },
              easeInExpo: function (t) {
                return 0 === t ? 0 : e(2, 10 * t - 10);
              },
              easeOutExpo: function (t) {
                return 1 === t ? 1 : 1 - e(2, -10 * t);
              },
              easeInOutExpo: function (t) {
                return 0 === t
                  ? 0
                  : 1 === t
                  ? 1
                  : t < 0.5
                  ? e(2, 20 * t - 10) / 2
                  : (2 - e(2, -20 * t + 10)) / 2;
              },
              easeInCirc: function (t) {
                return 1 - n(1 - e(t, 2));
              },
              easeOutCirc: function (t) {
                return n(1 - e(t - 1, 2));
              },
              easeInOutCirc: function (t) {
                return t < 0.5
                  ? (1 - n(1 - e(2 * t, 2))) / 2
                  : (n(1 - e(-2 * t + 2, 2)) + 1) / 2;
              },
              easeInElastic: function (t) {
                return 0 === t
                  ? 0
                  : 1 === t
                  ? 1
                  : -e(2, 10 * t - 10) * i((10 * t - 10.75) * l);
              },
              easeOutElastic: function (t) {
                return 0 === t
                  ? 0
                  : 1 === t
                  ? 1
                  : e(2, -10 * t) * i((10 * t - 0.75) * l) + 1;
              },
              easeInOutElastic: function (t) {
                return 0 === t
                  ? 0
                  : 1 === t
                  ? 1
                  : t < 0.5
                  ? (-e(2, 20 * t - 10) * i((20 * t - 11.125) * c)) / 2
                  : (e(2, -20 * t + 10) * i((20 * t - 11.125) * c)) / 2 + 1;
              },
              easeInBack: function (t) {
                return 2.70158 * t * t * t - s * t * t;
              },
              easeOutBack: function (t) {
                return 1 + 2.70158 * e(t - 1, 3) + s * e(t - 1, 2);
              },
              easeInOutBack: function (t) {
                return t < 0.5
                  ? (e(2 * t, 2) * (7.189819 * t - a)) / 2
                  : (e(2 * t - 2, 2) * ((a + 1) * (2 * t - 2) + a) + 2) / 2;
              },
              easeInBounce: function (t) {
                return 1 - u(1 - t);
              },
              easeOutBounce: u,
              easeInOutBounce: function (t) {
                return t < 0.5
                  ? (1 - u(1 - 2 * t)) / 2
                  : (1 + u(2 * t - 1)) / 2;
              },
            });
          })(t);
        }.apply(e, i)) || (t.exports = o);
  },
  function (t, e, n) {
    'use strict';
    n.r(e),
      (e.default = {
        id: 'icon-tick-usage',
        viewBox: '0 0 32 32',
        url: n.p + 'icons/sprite-471412.svg#icon-tick',
        toString: function () {
          return this.url;
        },
      });
  },
  function (t, e, n) {
    'use strict';
    n.r(e),
      (e.default = {
        id: 'icon-navigation-usage',
        viewBox: '0 0 32 32',
        url: n.p + 'icons/sprite-471412.svg#icon-navigation',
        toString: function () {
          return this.url;
        },
      });
  },
  function (t, e, n) {
    'use strict';
    n.r(e),
      (e.default = {
        id: 'icon-angle-up-usage',
        viewBox: '0 0 32 32',
        url: n.p + 'icons/sprite-471412.svg#icon-angle-up',
        toString: function () {
          return this.url;
        },
      });
  },
  function (t, e, n) {
    'use strict';
    n.r(e),
      (e.default = {
        id: 'icon-angle-down-usage',
        viewBox: '0 0 32 32',
        url: n.p + 'icons/sprite-471412.svg#icon-angle-down',
        toString: function () {
          return this.url;
        },
      });
  },
  function (t, e, n) {
    'use strict';
    n.r(e),
      (e.default = {
        id: 'icon-minus-usage',
        viewBox: '0 0 32 32',
        url: n.p + 'icons/sprite-471412.svg#icon-minus',
        toString: function () {
          return this.url;
        },
      });
  },
  function (t, e, n) {
    'use strict';
    n.r(e),
      (e.default = {
        id: 'icon-plus-usage',
        viewBox: '0 0 32 32',
        url: n.p + 'icons/sprite-471412.svg#icon-plus',
        toString: function () {
          return this.url;
        },
      });
  },
  function (t, e, n) {
    'use strict';
    n.r(e),
      (e.default = {
        id: 'icon-star-usage',
        viewBox: '0 0 32 32',
        url: n.p + 'icons/sprite-471412.svg#icon-star',
        toString: function () {
          return this.url;
        },
      });
  },
  function (t, e, n) {
    'use strict';
    n.r(e),
      (e.default = {
        id: 'icon-frappe-usage',
        viewBox: '0 0 32 32',
        url: n.p + 'icons/sprite-471412.svg#icon-frappe',
        toString: function () {
          return this.url;
        },
      });
  },
  function (t, e, n) {
    'use strict';
    n.r(e),
      (e.default = {
        id: 'icon-caramel-usage',
        viewBox: '0 0 32 32',
        url: n.p + 'icons/sprite-471412.svg#icon-caramel',
        toString: function () {
          return this.url;
        },
      });
  },
  function (t, e, n) {
    'use strict';
    n.r(e),
      (e.default = {
        id: 'icon-vanilla-usage',
        viewBox: '0 0 32 32',
        url: n.p + 'icons/sprite-471412.svg#icon-vanilla',
        toString: function () {
          return this.url;
        },
      });
  },
  function (t, e, n) {
    'use strict';
    n.r(e),
      (e.default = {
        id: 'icon-banana-usage',
        viewBox: '0 0 32 32',
        url: n.p + 'icons/sprite-471412.svg#icon-banana',
        toString: function () {
          return this.url;
        },
      });
  },
  function (t, e, n) {
    'use strict';
    n.r(e),
      (e.default = {
        id: 'icon-cupcake-usage',
        viewBox: '0 0 32 32',
        url: n.p + 'icons/sprite-471412.svg#icon-cupcake',
        toString: function () {
          return this.url;
        },
      });
  },
  function (t, e, n) {
    'use strict';
    n.r(e),
      (e.default = {
        id: 'icon-chocolate-usage',
        viewBox: '0 0 32 32',
        url: n.p + 'icons/sprite-471412.svg#icon-chocolate',
        toString: function () {
          return this.url;
        },
      });
  },
  function (t, e, n) {
    'use strict';
    n.r(e),
      (e.default = {
        id: 'icon-slice-of-cake-usage',
        viewBox: '0 0 32 32',
        url: n.p + 'icons/sprite-471412.svg#icon-slice-of-cake',
        toString: function () {
          return this.url;
        },
      });
  },
  function (t, e, n) {
    'use strict';
    n.r(e),
      (e.default = {
        id: 'icon-cake-usage',
        viewBox: '0 0 32 32',
        url: n.p + 'icons/sprite-471412.svg#icon-cake',
        toString: function () {
          return this.url;
        },
      });
  },
  function (t, e, n) {
    'use strict';
    n.r(e),
      (e.default = {
        id: 'icon-apple-usage',
        viewBox: '0 0 32 32',
        url: n.p + 'icons/sprite-471412.svg#icon-apple',
        toString: function () {
          return this.url;
        },
      });
  },
  function (t, e, n) {
    'use strict';
    n.r(e),
      (e.default = {
        id: 'icon-close-usage',
        viewBox: '0 0 32 32',
        url: n.p + 'icons/sprite-471412.svg#icon-close',
        toString: function () {
          return this.url;
        },
      });
  },
  function (t, e, n) {
    'use strict';
    n(46),
      n(36),
      n(35),
      n(34),
      n(33),
      n(32),
      n(31),
      n(30),
      n(29),
      n(28),
      n(27),
      n(26),
      n(25),
      n(24),
      n(23),
      n(22),
      n(21),
      n(20);
    var i = o(n(0));
    o(n(2));

    function o(t) {
      return t && t.__esModule ? t : { default: t };
    }

    (window.jQuery = i.default),
      (window.$ = i.default),
      n(19),
      n(18),
      n(17),
      n(1).init();
  },
  ,
  ,
  ,
  ,
  ,
  ,
  ,
  ,
  function (t, e) {},
]);

//# sourceMappingURL=bundle.e7ba721f7c979cb28d69.js.map

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function checkCookie() {
  var user = getCookie('username');
  if (user != '') {
    alert('Welcome again ' + user);
  } else {
    user = prompt('Please enter your name:', '');
    if (user != '' && user != null) {
      setCookie('username', user, 365);
    }
  }
}

/*! Magnific Popup - v1.1.0 - 2016-02-20
 * http://dimsemenov.com/plugins/magnific-popup/
 * Copyright (c) 2016 Dmitry Semenov; */
!(function (a) {
  'function' == typeof define && define.amd
    ? define(['jquery'], a)
    : a(
        'object' == typeof exports
          ? require('jquery')
          : window.jQuery || window.Zepto
      );
})(function (a) {
  var b,
    c,
    d,
    e,
    f,
    g,
    h = 'Close',
    i = 'BeforeClose',
    j = 'AfterClose',
    k = 'BeforeAppend',
    l = 'MarkupParse',
    m = 'Open',
    n = 'Change',
    o = 'mfp',
    p = '.' + o,
    q = 'mfp-ready',
    r = 'mfp-removing',
    s = 'mfp-prevent-close',
    t = function () {},
    u = !!window.jQuery,
    v = a(window),
    w = function (a, c) {
      b.ev.on(o + a + p, c);
    },
    x = function (b, c, d, e) {
      var f = document.createElement('div');
      return (
        (f.className = 'mfp-' + b),
        d && (f.innerHTML = d),
        e ? c && c.appendChild(f) : ((f = a(f)), c && f.appendTo(c)),
        f
      );
    },
    y = function (c, d) {
      b.ev.triggerHandler(o + c, d),
        b.st.callbacks &&
          ((c = c.charAt(0).toLowerCase() + c.slice(1)),
          b.st.callbacks[c] &&
            b.st.callbacks[c].apply(b, a.isArray(d) ? d : [d]));
    },
    z = function (c) {
      return (
        (c === g && b.currTemplate.closeBtn) ||
          ((b.currTemplate.closeBtn = a(
            b.st.closeMarkup.replace('%title%', b.st.tClose)
          )),
          (g = c)),
        b.currTemplate.closeBtn
      );
    },
    A = function () {
      a.magnificPopup.instance ||
        ((b = new t()), b.init(), (a.magnificPopup.instance = b));
    },
    B = function () {
      var a = document.createElement('p').style,
        b = ['ms', 'O', 'Moz', 'Webkit'];
      if (void 0 !== a.transition) return !0;
      for (; b.length; ) if (b.pop() + 'Transition' in a) return !0;
      return !1;
    };
  (t.prototype = {
    constructor: t,
    init: function () {
      var c = navigator.appVersion;
      (b.isLowIE = b.isIE8 = document.all && !document.addEventListener),
        (b.isAndroid = /android/gi.test(c)),
        (b.isIOS = /iphone|ipad|ipod/gi.test(c)),
        (b.supportsTransition = B()),
        (b.probablyMobile =
          b.isAndroid ||
          b.isIOS ||
          /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(
            navigator.userAgent
          )),
        (d = a(document)),
        (b.popupsCache = {});
    },
    open: function (c) {
      var e;
      if (c.isObj === !1) {
        (b.items = c.items.toArray()), (b.index = 0);
        var g,
          h = c.items;
        for (e = 0; e < h.length; e++)
          if (((g = h[e]), g.parsed && (g = g.el[0]), g === c.el[0])) {
            b.index = e;
            break;
          }
      } else
        (b.items = a.isArray(c.items) ? c.items : [c.items]),
          (b.index = c.index || 0);
      if (b.isOpen) return void b.updateItemHTML();
      (b.types = []),
        (f = ''),
        c.mainEl && c.mainEl.length ? (b.ev = c.mainEl.eq(0)) : (b.ev = d),
        c.key
          ? (b.popupsCache[c.key] || (b.popupsCache[c.key] = {}),
            (b.currTemplate = b.popupsCache[c.key]))
          : (b.currTemplate = {}),
        (b.st = a.extend(!0, {}, a.magnificPopup.defaults, c)),
        (b.fixedContentPos =
          'auto' === b.st.fixedContentPos
            ? !b.probablyMobile
            : b.st.fixedContentPos),
        b.st.modal &&
          ((b.st.closeOnContentClick = !1),
          (b.st.closeOnBgClick = !1),
          (b.st.showCloseBtn = !1),
          (b.st.enableEscapeKey = !1)),
        b.bgOverlay ||
          ((b.bgOverlay = x('bg').on('click' + p, function () {
            b.close();
          })),
          (b.wrap = x('wrap')
            .attr('tabindex', -1)
            .on('click' + p, function (a) {
              b._checkIfClose(a.target) && b.close();
            })),
          (b.container = x('container', b.wrap))),
        (b.contentContainer = x('content')),
        b.st.preloader &&
          (b.preloader = x('preloader', b.container, b.st.tLoading));
      var i = a.magnificPopup.modules;
      for (e = 0; e < i.length; e++) {
        var j = i[e];
        (j = j.charAt(0).toUpperCase() + j.slice(1)), b['init' + j].call(b);
      }
      y('BeforeOpen'),
        b.st.showCloseBtn &&
          (b.st.closeBtnInside
            ? (w(l, function (a, b, c, d) {
                c.close_replaceWith = z(d.type);
              }),
              (f += ' mfp-close-btn-in'))
            : b.wrap.append(z())),
        b.st.alignTop && (f += ' mfp-align-top'),
        b.fixedContentPos
          ? b.wrap.css({
              overflow: b.st.overflowY,
              overflowX: 'hidden',
              overflowY: b.st.overflowY,
            })
          : b.wrap.css({
              top: v.scrollTop(),
              position: 'absolute',
            }),
        (b.st.fixedBgPos === !1 ||
          ('auto' === b.st.fixedBgPos && !b.fixedContentPos)) &&
          b.bgOverlay.css({
            height: d.height(),
            position: 'absolute',
          }),
        b.st.enableEscapeKey &&
          d.on('keyup' + p, function (a) {
            27 === a.keyCode && b.close();
          }),
        v.on('resize' + p, function () {
          b.updateSize();
        }),
        b.st.closeOnContentClick || (f += ' mfp-auto-cursor'),
        f && b.wrap.addClass(f);
      var k = (b.wH = v.height()),
        n = {};
      if (b.fixedContentPos && b._hasScrollBar(k)) {
        var o = b._getScrollbarSize();
        o && (n.marginRight = o);
      }
      b.fixedContentPos &&
        (b.isIE7
          ? a('body, html').css('overflow', 'hidden')
          : (n.overflow = 'hidden'));
      var r = b.st.mainClass;
      return (
        b.isIE7 && (r += ' mfp-ie7'),
        r && b._addClassToMFP(r),
        b.updateItemHTML(),
        y('BuildControls'),
        a('html').css(n),
        b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo || a(document.body)),
        (b._lastFocusedEl = document.activeElement),
        setTimeout(function () {
          b.content
            ? (b._addClassToMFP(q), b._setFocus())
            : b.bgOverlay.addClass(q),
            d.on('focusin' + p, b._onFocusIn);
        }, 16),
        (b.isOpen = !0),
        b.updateSize(k),
        y(m),
        c
      );
    },
    close: function () {
      b.isOpen &&
        (y(i),
        (b.isOpen = !1),
        b.st.removalDelay && !b.isLowIE && b.supportsTransition
          ? (b._addClassToMFP(r),
            setTimeout(function () {
              b._close();
            }, b.st.removalDelay))
          : b._close());
    },
    _close: function () {
      y(h);
      var c = r + ' ' + q + ' ';
      if (
        (b.bgOverlay.detach(),
        b.wrap.detach(),
        b.container.empty(),
        b.st.mainClass && (c += b.st.mainClass + ' '),
        b._removeClassFromMFP(c),
        b.fixedContentPos)
      ) {
        var e = { marginRight: '' };
        b.isIE7 ? a('body, html').css('overflow', '') : (e.overflow = ''),
          a('html').css(e);
      }
      d.off('keyup' + p + ' focusin' + p),
        b.ev.off(p),
        b.wrap.attr('class', 'mfp-wrap').removeAttr('style'),
        b.bgOverlay.attr('class', 'mfp-bg'),
        b.container.attr('class', 'mfp-container'),
        !b.st.showCloseBtn ||
          (b.st.closeBtnInside && b.currTemplate[b.currItem.type] !== !0) ||
          (b.currTemplate.closeBtn && b.currTemplate.closeBtn.detach()),
        b.st.autoFocusLast && b._lastFocusedEl && a(b._lastFocusedEl).focus(),
        (b.currItem = null),
        (b.content = null),
        (b.currTemplate = null),
        (b.prevHeight = 0),
        y(j);
    },
    updateSize: function (a) {
      if (b.isIOS) {
        var c = document.documentElement.clientWidth / window.innerWidth,
          d = window.innerHeight * c;
        b.wrap.css('height', d), (b.wH = d);
      } else b.wH = a || v.height();
      b.fixedContentPos || b.wrap.css('height', b.wH), y('Resize');
    },
    updateItemHTML: function () {
      var c = b.items[b.index];
      b.contentContainer.detach(),
        b.content && b.content.detach(),
        c.parsed || (c = b.parseEl(b.index));
      var d = c.type;
      if (
        (y('BeforeChange', [b.currItem ? b.currItem.type : '', d]),
        (b.currItem = c),
        !b.currTemplate[d])
      ) {
        var f = b.st[d] ? b.st[d].markup : !1;
        y('FirstMarkupParse', f),
          f ? (b.currTemplate[d] = a(f)) : (b.currTemplate[d] = !0);
      }
      e && e !== c.type && b.container.removeClass('mfp-' + e + '-holder');
      var g = b['get' + d.charAt(0).toUpperCase() + d.slice(1)](
        c,
        b.currTemplate[d]
      );
      b.appendContent(g, d),
        (c.preloaded = !0),
        y(n, c),
        (e = c.type),
        b.container.prepend(b.contentContainer),
        y('AfterChange');
    },
    appendContent: function (a, c) {
      (b.content = a),
        a
          ? b.st.showCloseBtn && b.st.closeBtnInside && b.currTemplate[c] === !0
            ? b.content.find('.mfp-close').length || b.content.append(z())
            : (b.content = a)
          : (b.content = ''),
        y(k),
        b.container.addClass('mfp-' + c + '-holder'),
        b.contentContainer.append(b.content);
    },
    parseEl: function (c) {
      var d,
        e = b.items[c];
      if (
        (e.tagName
          ? (e = { el: a(e) })
          : ((d = e.type), (e = { data: e, src: e.src })),
        e.el)
      ) {
        for (var f = b.types, g = 0; g < f.length; g++)
          if (e.el.hasClass('mfp-' + f[g])) {
            d = f[g];
            break;
          }
        (e.src = e.el.attr('data-mfp-src')),
          e.src || (e.src = e.el.attr('href'));
      }
      return (
        (e.type = d || b.st.type || 'inline'),
        (e.index = c),
        (e.parsed = !0),
        (b.items[c] = e),
        y('ElementParse', e),
        b.items[c]
      );
    },
    addGroup: function (a, c) {
      var d = function (d) {
        (d.mfpEl = this), b._openClick(d, a, c);
      };
      c || (c = {});
      var e = 'click.magnificPopup';
      (c.mainEl = a),
        c.items
          ? ((c.isObj = !0), a.off(e).on(e, d))
          : ((c.isObj = !1),
            c.delegate
              ? a.off(e).on(e, c.delegate, d)
              : ((c.items = a), a.off(e).on(e, d)));
    },
    _openClick: function (c, d, e) {
      var f =
        void 0 !== e.midClick ? e.midClick : a.magnificPopup.defaults.midClick;
      if (
        f ||
        !(2 === c.which || c.ctrlKey || c.metaKey || c.altKey || c.shiftKey)
      ) {
        var g =
          void 0 !== e.disableOn
            ? e.disableOn
            : a.magnificPopup.defaults.disableOn;
        if (g)
          if (a.isFunction(g)) {
            if (!g.call(b)) return !0;
          } else if (v.width() < g) return !0;
        c.type && (c.preventDefault(), b.isOpen && c.stopPropagation()),
          (e.el = a(c.mfpEl)),
          e.delegate && (e.items = d.find(e.delegate)),
          b.open(e);
      }
    },
    updateStatus: function (a, d) {
      if (b.preloader) {
        c !== a && b.container.removeClass('mfp-s-' + c),
          d || 'loading' !== a || (d = b.st.tLoading);
        var e = { status: a, text: d };
        y('UpdateStatus', e),
          (a = e.status),
          (d = e.text),
          b.preloader.html(d),
          b.preloader.find('a').on('click', function (a) {
            a.stopImmediatePropagation();
          }),
          b.container.addClass('mfp-s-' + a),
          (c = a);
      }
    },
    _checkIfClose: function (c) {
      if (!a(c).hasClass(s)) {
        var d = b.st.closeOnContentClick,
          e = b.st.closeOnBgClick;
        if (d && e) return !0;
        if (
          !b.content ||
          a(c).hasClass('mfp-close') ||
          (b.preloader && c === b.preloader[0])
        )
          return !0;
        if (c === b.content[0] || a.contains(b.content[0], c)) {
          if (d) return !0;
        } else if (e && a.contains(document, c)) return !0;
        return !1;
      }
    },
    _addClassToMFP: function (a) {
      b.bgOverlay.addClass(a), b.wrap.addClass(a);
    },
    _removeClassFromMFP: function (a) {
      this.bgOverlay.removeClass(a), b.wrap.removeClass(a);
    },
    _hasScrollBar: function (a) {
      return (
        (b.isIE7 ? d.height() : document.body.scrollHeight) > (a || v.height())
      );
    },
    _setFocus: function () {
      (b.st.focus ? b.content.find(b.st.focus).eq(0) : b.wrap).focus();
    },
    _onFocusIn: function (c) {
      return c.target === b.wrap[0] || a.contains(b.wrap[0], c.target)
        ? void 0
        : (b._setFocus(), !1);
    },
    _parseMarkup: function (b, c, d) {
      var e;
      d.data && (c = a.extend(d.data, c)),
        y(l, [b, c, d]),
        a.each(c, function (c, d) {
          if (void 0 === d || d === !1) return !0;
          if (((e = c.split('_')), e.length > 1)) {
            var f = b.find(p + '-' + e[0]);
            if (f.length > 0) {
              var g = e[1];
              'replaceWith' === g
                ? f[0] !== d[0] && f.replaceWith(d)
                : 'img' === g
                ? f.is('img')
                  ? f.attr('src', d)
                  : f.replaceWith(
                      a('<img>').attr('src', d).attr('class', f.attr('class'))
                    )
                : f.attr(e[1], d);
            }
          } else b.find(p + '-' + c).html(d);
        });
    },
    _getScrollbarSize: function () {
      if (void 0 === b.scrollbarSize) {
        var a = document.createElement('div');
        (a.style.cssText =
          'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;'),
          document.body.appendChild(a),
          (b.scrollbarSize = a.offsetWidth - a.clientWidth),
          document.body.removeChild(a);
      }
      return b.scrollbarSize;
    },
  }),
    (a.magnificPopup = {
      instance: null,
      proto: t.prototype,
      modules: [],
      open: function (b, c) {
        return (
          A(),
          (b = b ? a.extend(!0, {}, b) : {}),
          (b.isObj = !0),
          (b.index = c || 0),
          this.instance.open(b)
        );
      },
      close: function () {
        return a.magnificPopup.instance && a.magnificPopup.instance.close();
      },
      registerModule: function (b, c) {
        c.options && (a.magnificPopup.defaults[b] = c.options),
          a.extend(this.proto, c.proto),
          this.modules.push(b);
      },
      defaults: {
        disableOn: 0,
        key: null,
        midClick: !1,
        mainClass: '',
        preloader: !0,
        focus: '',
        closeOnContentClick: !1,
        closeOnBgClick: !0,
        closeBtnInside: !0,
        showCloseBtn: !0,
        enableEscapeKey: !0,
        modal: !1,
        alignTop: !1,
        removalDelay: 0,
        prependTo: null,
        fixedContentPos: 'auto',
        fixedBgPos: 'auto',
        overflowY: 'auto',
        closeMarkup:
          '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
        tClose: 'Close (Esc)',
        tLoading: 'Loading...',
        autoFocusLast: !0,
      },
    }),
    (a.fn.magnificPopup = function (c) {
      A();
      var d = a(this);
      if ('string' == typeof c)
        if ('open' === c) {
          var e,
            f = u ? d.data('magnificPopup') : d[0].magnificPopup,
            g = parseInt(arguments[1], 10) || 0;
          f.items
            ? (e = f.items[g])
            : ((e = d), f.delegate && (e = e.find(f.delegate)), (e = e.eq(g))),
            b._openClick({ mfpEl: e }, d, f);
        } else
          b.isOpen && b[c].apply(b, Array.prototype.slice.call(arguments, 1));
      else
        (c = a.extend(!0, {}, c)),
          u ? d.data('magnificPopup', c) : (d[0].magnificPopup = c),
          b.addGroup(d, c);
      return d;
    });
  var C,
    D,
    E,
    F = 'inline',
    G = function () {
      E && (D.after(E.addClass(C)).detach(), (E = null));
    };
  a.magnificPopup.registerModule(F, {
    options: {
      hiddenClass: 'hide',
      markup: '',
      tNotFound: 'Content not found',
    },
    proto: {
      initInline: function () {
        b.types.push(F),
          w(h + '.' + F, function () {
            G();
          });
      },
      getInline: function (c, d) {
        if ((G(), c.src)) {
          var e = b.st.inline,
            f = a(c.src);
          if (f.length) {
            var g = f[0].parentNode;
            g &&
              g.tagName &&
              (D || ((C = e.hiddenClass), (D = x(C)), (C = 'mfp-' + C)),
              (E = f.after(D).detach().removeClass(C))),
              b.updateStatus('ready');
          } else b.updateStatus('error', e.tNotFound), (f = a('<div>'));
          return (c.inlineElement = f), f;
        }
        return b.updateStatus('ready'), b._parseMarkup(d, {}, c), d;
      },
    },
  });
  var H,
    I = 'ajax',
    J = function () {
      H && a(document.body).removeClass(H);
    },
    K = function () {
      J(), b.req && b.req.abort();
    };
  a.magnificPopup.registerModule(I, {
    options: {
      settings: null,
      cursor: 'mfp-ajax-cur',
      tError: '<a href="%url%">The content</a> could not be loaded.',
    },
    proto: {
      initAjax: function () {
        b.types.push(I),
          (H = b.st.ajax.cursor),
          w(h + '.' + I, K),
          w('BeforeChange.' + I, K);
      },
      getAjax: function (c) {
        H && a(document.body).addClass(H), b.updateStatus('loading');
        var d = a.extend(
          {
            url: c.src,
            success: function (d, e, f) {
              var g = { data: d, xhr: f };
              y('ParseAjax', g),
                b.appendContent(a(g.data), I),
                (c.finished = !0),
                J(),
                b._setFocus(),
                setTimeout(function () {
                  b.wrap.addClass(q);
                }, 16),
                b.updateStatus('ready'),
                y('AjaxContentAdded');
            },
            error: function () {
              J(),
                (c.finished = c.loadError = !0),
                b.updateStatus(
                  'error',
                  b.st.ajax.tError.replace('%url%', c.src)
                );
            },
          },
          b.st.ajax.settings
        );
        return (b.req = a.ajax(d)), '';
      },
    },
  });
  var L,
    M = function (c) {
      if (c.data && void 0 !== c.data.title) return c.data.title;
      var d = b.st.image.titleSrc;
      if (d) {
        if (a.isFunction(d)) return d.call(b, c);
        if (c.el) return c.el.attr(d) || '';
      }
      return '';
    };
  a.magnificPopup.registerModule('image', {
    options: {
      markup:
        '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
      cursor: 'mfp-zoom-out-cur',
      titleSrc: 'title',
      verticalFit: !0,
      tError: '<a href="%url%">The image</a> could not be loaded.',
    },
    proto: {
      initImage: function () {
        var c = b.st.image,
          d = '.image';
        b.types.push('image'),
          w(m + d, function () {
            'image' === b.currItem.type &&
              c.cursor &&
              a(document.body).addClass(c.cursor);
          }),
          w(h + d, function () {
            c.cursor && a(document.body).removeClass(c.cursor),
              v.off('resize' + p);
          }),
          w('Resize' + d, b.resizeImage),
          b.isLowIE && w('AfterChange', b.resizeImage);
      },
      resizeImage: function () {
        var a = b.currItem;
        if (a && a.img && b.st.image.verticalFit) {
          var c = 0;
          b.isLowIE &&
            (c =
              parseInt(a.img.css('padding-top'), 10) +
              parseInt(a.img.css('padding-bottom'), 10)),
            a.img.css('max-height', b.wH - c);
        }
      },
      _onImageHasSize: function (a) {
        a.img &&
          ((a.hasSize = !0),
          L && clearInterval(L),
          (a.isCheckingImgSize = !1),
          y('ImageHasSize', a),
          a.imgHidden &&
            (b.content && b.content.removeClass('mfp-loading'),
            (a.imgHidden = !1)));
      },
      findImageSize: function (a) {
        var c = 0,
          d = a.img[0],
          e = function (f) {
            L && clearInterval(L),
              (L = setInterval(function () {
                return d.naturalWidth > 0
                  ? void b._onImageHasSize(a)
                  : (c > 200 && clearInterval(L),
                    c++,
                    void (3 === c
                      ? e(10)
                      : 40 === c
                      ? e(50)
                      : 100 === c && e(500)));
              }, f));
          };
        e(1);
      },
      getImage: function (c, d) {
        var e = 0,
          f = function () {
            c &&
              (c.img[0].complete
                ? (c.img.off('.mfploader'),
                  c === b.currItem &&
                    (b._onImageHasSize(c), b.updateStatus('ready')),
                  (c.hasSize = !0),
                  (c.loaded = !0),
                  y('ImageLoadComplete'))
                : (e++, 200 > e ? setTimeout(f, 100) : g()));
          },
          g = function () {
            c &&
              (c.img.off('.mfploader'),
              c === b.currItem &&
                (b._onImageHasSize(c),
                b.updateStatus('error', h.tError.replace('%url%', c.src))),
              (c.hasSize = !0),
              (c.loaded = !0),
              (c.loadError = !0));
          },
          h = b.st.image,
          i = d.find('.mfp-img');
        if (i.length) {
          var j = document.createElement('img');
          (j.className = 'mfp-img'),
            c.el &&
              c.el.find('img').length &&
              (j.alt = c.el.find('img').attr('alt')),
            (c.img = a(j).on('load.mfploader', f).on('error.mfploader', g)),
            (j.src = c.src),
            i.is('img') && (c.img = c.img.clone()),
            (j = c.img[0]),
            j.naturalWidth > 0 ? (c.hasSize = !0) : j.width || (c.hasSize = !1);
        }
        return (
          b._parseMarkup(
            d,
            {
              title: M(c),
              img_replaceWith: c.img,
            },
            c
          ),
          b.resizeImage(),
          c.hasSize
            ? (L && clearInterval(L),
              c.loadError
                ? (d.addClass('mfp-loading'),
                  b.updateStatus('error', h.tError.replace('%url%', c.src)))
                : (d.removeClass('mfp-loading'), b.updateStatus('ready')),
              d)
            : (b.updateStatus('loading'),
              (c.loading = !0),
              c.hasSize ||
                ((c.imgHidden = !0),
                d.addClass('mfp-loading'),
                b.findImageSize(c)),
              d)
        );
      },
    },
  });
  var N,
    O = function () {
      return (
        void 0 === N &&
          (N = void 0 !== document.createElement('p').style.MozTransform),
        N
      );
    };
  a.magnificPopup.registerModule('zoom', {
    options: {
      enabled: !1,
      easing: 'ease-in-out',
      duration: 300,
      opener: function (a) {
        return a.is('img') ? a : a.find('img');
      },
    },
    proto: {
      initZoom: function () {
        var a,
          c = b.st.zoom,
          d = '.zoom';
        if (c.enabled && b.supportsTransition) {
          var e,
            f,
            g = c.duration,
            j = function (a) {
              var b = a
                  .clone()
                  .removeAttr('style')
                  .removeAttr('class')
                  .addClass('mfp-animated-image'),
                d = 'all ' + c.duration / 1e3 + 's ' + c.easing,
                e = {
                  position: 'fixed',
                  zIndex: 9999,
                  left: 0,
                  top: 0,
                  '-webkit-backface-visibility': 'hidden',
                },
                f = 'transition';
              return (
                (e['-webkit-' + f] = e['-moz-' + f] = e['-o-' + f] = e[f] = d),
                b.css(e),
                b
              );
            },
            k = function () {
              b.content.css('visibility', 'visible');
            };
          w('BuildControls' + d, function () {
            if (b._allowZoom()) {
              if (
                (clearTimeout(e),
                b.content.css('visibility', 'hidden'),
                (a = b._getItemToZoom()),
                !a)
              )
                return void k();
              (f = j(a)),
                f.css(b._getOffset()),
                b.wrap.append(f),
                (e = setTimeout(function () {
                  f.css(b._getOffset(!0)),
                    (e = setTimeout(function () {
                      k(),
                        setTimeout(function () {
                          f.remove(), (a = f = null), y('ZoomAnimationEnded');
                        }, 16);
                    }, g));
                }, 16));
            }
          }),
            w(i + d, function () {
              if (b._allowZoom()) {
                if ((clearTimeout(e), (b.st.removalDelay = g), !a)) {
                  if (((a = b._getItemToZoom()), !a)) return;
                  f = j(a);
                }
                f.css(b._getOffset(!0)),
                  b.wrap.append(f),
                  b.content.css('visibility', 'hidden'),
                  setTimeout(function () {
                    f.css(b._getOffset());
                  }, 16);
              }
            }),
            w(h + d, function () {
              b._allowZoom() && (k(), f && f.remove(), (a = null));
            });
        }
      },
      _allowZoom: function () {
        return 'image' === b.currItem.type;
      },
      _getItemToZoom: function () {
        return b.currItem.hasSize ? b.currItem.img : !1;
      },
      _getOffset: function (c) {
        var d;
        d = c ? b.currItem.img : b.st.zoom.opener(b.currItem.el || b.currItem);
        var e = d.offset(),
          f = parseInt(d.css('padding-top'), 10),
          g = parseInt(d.css('padding-bottom'), 10);
        e.top -= a(window).scrollTop() - f;
        var h = {
          width: d.width(),
          height: (u ? d.innerHeight() : d[0].offsetHeight) - g - f,
        };
        return (
          O()
            ? (h['-moz-transform'] = h.transform =
                'translate(' + e.left + 'px,' + e.top + 'px)')
            : ((h.left = e.left), (h.top = e.top)),
          h
        );
      },
    },
  });
  var P = 'iframe',
    Q = '//about:blank',
    R = function (a) {
      if (b.currTemplate[P]) {
        var c = b.currTemplate[P].find('iframe');
        c.length &&
          (a || (c[0].src = Q),
          b.isIE8 && c.css('display', a ? 'block' : 'none'));
      }
    };
  a.magnificPopup.registerModule(P, {
    options: {
      markup:
        '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
      srcAction: 'iframe_src',
      patterns: {
        youtube: {
          index: 'youtube.com',
          id: 'v=',
          src: '//www.youtube.com/embed/%id%?autoplay=1',
        },
        vimeo: {
          index: 'vimeo.com/',
          id: '/',
          src: '//player.vimeo.com/video/%id%?autoplay=1',
        },
        gmaps: { index: '//maps.google.', src: '%id%&output=embed' },
      },
    },
    proto: {
      initIframe: function () {
        b.types.push(P),
          w('BeforeChange', function (a, b, c) {
            b !== c && (b === P ? R() : c === P && R(!0));
          }),
          w(h + '.' + P, function () {
            R();
          });
      },
      getIframe: function (c, d) {
        var e = c.src,
          f = b.st.iframe;
        a.each(f.patterns, function () {
          return e.indexOf(this.index) > -1
            ? (this.id &&
                (e =
                  'string' == typeof this.id
                    ? e.substr(
                        e.lastIndexOf(this.id) + this.id.length,
                        e.length
                      )
                    : this.id.call(this, e)),
              (e = this.src.replace('%id%', e)),
              !1)
            : void 0;
        });
        var g = {};
        return (
          f.srcAction && (g[f.srcAction] = e),
          b._parseMarkup(d, g, c),
          b.updateStatus('ready'),
          d
        );
      },
    },
  });
  var S = function (a) {
      var c = b.items.length;
      return a > c - 1 ? a - c : 0 > a ? c + a : a;
    },
    T = function (a, b, c) {
      return a.replace(/%curr%/gi, b + 1).replace(/%total%/gi, c);
    };
  a.magnificPopup.registerModule('gallery', {
    options: {
      enabled: !1,
      arrowMarkup:
        '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
      preload: [0, 2],
      navigateByImgClick: !0,
      arrows: !0,
      tPrev: 'Previous (Left arrow key)',
      tNext: 'Next (Right arrow key)',
      tCounter: '%curr% of %total%',
    },
    proto: {
      initGallery: function () {
        var c = b.st.gallery,
          e = '.mfp-gallery';
        return (
          (b.direction = !0),
          c && c.enabled
            ? ((f += ' mfp-gallery'),
              w(m + e, function () {
                c.navigateByImgClick &&
                  b.wrap.on('click' + e, '.mfp-img', function () {
                    return b.items.length > 1 ? (b.next(), !1) : void 0;
                  }),
                  d.on('keydown' + e, function (a) {
                    37 === a.keyCode ? b.prev() : 39 === a.keyCode && b.next();
                  });
              }),
              w('UpdateStatus' + e, function (a, c) {
                c.text &&
                  (c.text = T(c.text, b.currItem.index, b.items.length));
              }),
              w(l + e, function (a, d, e, f) {
                var g = b.items.length;
                e.counter = g > 1 ? T(c.tCounter, f.index, g) : '';
              }),
              w('BuildControls' + e, function () {
                if (b.items.length > 1 && c.arrows && !b.arrowLeft) {
                  var d = c.arrowMarkup,
                    e = (b.arrowLeft = a(
                      d.replace(/%title%/gi, c.tPrev).replace(/%dir%/gi, 'left')
                    ).addClass(s)),
                    f = (b.arrowRight = a(
                      d
                        .replace(/%title%/gi, c.tNext)
                        .replace(/%dir%/gi, 'right')
                    ).addClass(s));
                  e.click(function () {
                    b.prev();
                  }),
                    f.click(function () {
                      b.next();
                    }),
                    b.container.append(e.add(f));
                }
              }),
              w(n + e, function () {
                b._preloadTimeout && clearTimeout(b._preloadTimeout),
                  (b._preloadTimeout = setTimeout(function () {
                    b.preloadNearbyImages(), (b._preloadTimeout = null);
                  }, 16));
              }),
              void w(h + e, function () {
                d.off(e),
                  b.wrap.off('click' + e),
                  (b.arrowRight = b.arrowLeft = null);
              }))
            : !1
        );
      },
      next: function () {
        (b.direction = !0), (b.index = S(b.index + 1)), b.updateItemHTML();
      },
      prev: function () {
        (b.direction = !1), (b.index = S(b.index - 1)), b.updateItemHTML();
      },
      goTo: function (a) {
        (b.direction = a >= b.index), (b.index = a), b.updateItemHTML();
      },
      preloadNearbyImages: function () {
        var a,
          c = b.st.gallery.preload,
          d = Math.min(c[0], b.items.length),
          e = Math.min(c[1], b.items.length);
        for (a = 1; a <= (b.direction ? e : d); a++)
          b._preloadItem(b.index + a);
        for (a = 1; a <= (b.direction ? d : e); a++)
          b._preloadItem(b.index - a);
      },
      _preloadItem: function (c) {
        if (((c = S(c)), !b.items[c].preloaded)) {
          var d = b.items[c];
          d.parsed || (d = b.parseEl(c)),
            y('LazyLoad', d),
            'image' === d.type &&
              (d.img = a('<img class="mfp-img" />')
                .on('load.mfploader', function () {
                  d.hasSize = !0;
                })
                .on('error.mfploader', function () {
                  (d.hasSize = !0), (d.loadError = !0), y('LazyLoadError', d);
                })
                .attr('src', d.src)),
            (d.preloaded = !0);
        }
      },
    },
  });
  var U = 'retina';
  a.magnificPopup.registerModule(U, {
    options: {
      replaceSrc: function (a) {
        return a.src.replace(/\.\w+$/, function (a) {
          return '@2x' + a;
        });
      },
      ratio: 1,
    },
    proto: {
      initRetina: function () {
        if (window.devicePixelRatio > 1) {
          var a = b.st.retina,
            c = a.ratio;
          (c = isNaN(c) ? c() : c),
            c > 1 &&
              (w('ImageHasSize.' + U, function (a, b) {
                b.img.css({
                  'max-width': b.img[0].naturalWidth / c,
                  width: '100%',
                });
              }),
              w('ElementParse.' + U, function (b, d) {
                d.src = a.replaceSrc(d, c);
              }));
        }
      },
    },
  }),
    A();
});

var cookieName = 'nullsAc1';
var nullsCookie = '';
nullsCookie = getCookie(cookieName);
if (nullsCookie === undefined) {
  nullsCookie = '';
}

if (window.top.location.href.indexOf('nullsLang') > 0) {
  setCookie(cookieName, 'DE', 1);
  nullsCookie = getCookie(cookieName);
}

magnificPopup = $('.openLanguage').magnificPopup({
  type: 'inline',
  mainClass: 'mfp-fade',
  overflowY: 'scroll',
  midClick: true,
  callbacks: {
    open: function () {},
    close: function () {},
  },
});

if (typeof getCountryCode == "undefined") {
  var cCode = "";
}else {
  var cCode = getCountryCode();
}


$('.nullsButton').removeClass('nullsButtonFirst');
$('.nullsButton').removeClass('nullsButtonSecond');
if (nullsCookie == '') {
 
  setCookie(cookieName, getCountryCode(), 1);
  nullsCookie = getCookie(cookieName);
  /*$('.openLanguage').trigger( "click" );*/
} else {
  if (cCode == 'DE') {
    $('.nullsButton').removeClass('nullsButtonFirst');
    $('.nullsFlagDe div').addClass('nullsButtonFirst');
  } else if (cCode == 'HU') {
    $('.nullsButton').removeClass('nullsButtonFirst');
    $('.nullsFlagHu div').addClass('nullsButtonFirst');
  } else {
    $('.nullsButton').removeClass('nullsButtonFirst');
    $('.nullsFlagEn div').addClass('nullsButtonFirst');
  }
  /**/
}
function getCountryCode() {
  return "HU";
}
/*
function getCountryCode() {
  var ip = '';
  console.log('ikinci');
  $.ajax({
    url: 'https://geoip-db.com/jsonp',
    jsonpCallback: 'callback',
    dataType: 'jsonp',
    success: function (location) {
      var co = location.country_code;
      console.log(co);
      if (co == 'HU') {
        $('.nullsButton').removeClass('nullsButtonFirst');
        $('.nullsFlagHu div').addClass('nullsButtonFirst');
        return 'HU';
      }
      if (co == 'DE' || co == 'AT' || co == 'CH') {
        $('.nullsButton').removeClass('nullsButtonFirst');
        $('.nullsFlagDe div').addClass('nullsButtonFirst');
        $('.nullsFlagDe').trigger('click');
        return 'DE';
      }
      $('.nullsButton').removeClass('nullsButtonFirst');
      $('.nullsFlagEn div').addClass('nullsButtonFirst');
      return 'EN';
    },
  });
}
*/

/*console.log(nullsCookie);*/

function letsGo(where, here) {
 
  if (where === nullsCookie) {
    setCookie(cookieName, where, 1);
    var magnificPopup = $.magnificPopup.instance; 
    magnificPopup.close(); 
  } else {
    console.log('....');
    setCookie(cookieName, where, 1);
    console.log(here);
    var url = here;

    url += decodeURIComponent('?nullsLang=1');

    window.location.href = url;
  }
}
